import { LocationKey, DistanceMatrixEntry } from './types';

// Georgia Tech campus coordinates for proximity bias
export const GT_CAMPUS_CENTER = {
  longitude: -84.3963,
  latitude: 33.7756,
};

// Fallback GT locations - about 300 lines
export const FALLBACK_GT_LOCATIONS = [
  {
    name: 'Skiles',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.773568, long: -84.395957 },
  },
  {
    name: 'Clough Commons',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.774909, long: -84.396404 },
  },
  {
    name: 'Clough UG Learning Commons',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.774909, long: -84.396404 },
  },
  {
    name: 'Boggs',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776085, long: -84.400181 },
  },
  {
    name: 'Architecture (West)',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776076, long: -84.396114 },
  },
  {
    name: 'West Architecture',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776076, long: -84.396114 },
  },
  {
    name: 'Architecture (East)',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776177, long: -84.395459 },
  },
  {
    name: 'East Architecture',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776177, long: -84.395459 },
  },
  {
    name: 'Scheller College of Business',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776533, long: -84.387765 },
  },
  {
    name: 'Guggenheim Aerospace',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.771771, long: -84.395796 },
  },
  {
    name: 'Van Leer',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776065, long: -84.397116 },
  },
  {
    name: 'Bunger-Henry',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775803, long: -84.398189 },
  },
  {
    name: 'Coll of Computing',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777576, long: -84.397352 },
  },
  {
    name: 'College of Computing',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777576, long: -84.397352 },
  },
  {
    name: 'Weber SST III',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.772949, long: -84.396066 },
  },
  {
    name: 'Engr Science & Mech',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.772114, long: -84.395289 },
  },
  {
    name: 'Engineering Sci and Mechanics',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.772114, long: -84.395289 },
  },
  {
    name: 'Mason',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776764, long: -84.39844 },
  },
  {
    name: 'Love (MRDC II)',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77672, long: -84.401764 },
  },
  {
    name: 'J. Erskine Love Manufacturing',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77672, long: -84.401764 },
  },
  {
    name: 'MRDC',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777187, long: -84.400484 },
  },
  {
    name: 'Manufacture Rel Discip Complex',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777187, long: -84.400484 },
  },
  {
    name: 'Allen Sustainable Education',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77622, long: -84.397959 },
  },
  {
    name: 'Howey (Physics)',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777622, long: -84.398785 },
  },
  {
    name: 'Instr Center',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775587, long: -84.401213 },
  },
  {
    name: 'Instructional Center',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775587, long: -84.401213 },
  },
  {
    name: "O'Keefe",
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779177, long: -84.392196 },
  },
  {
    name: 'Curran Street Deck',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779495, long: -84.405633 },
  },
  {
    name: 'D. M. Smith',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.773801, long: -84.395122 },
  },
  {
    name: 'Swann',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.771658, long: -84.395302 },
  },
  {
    name: 'Kendeda',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.778759, long: -84.399597 },
  },
  {
    name: 'Ford Environmental Sci & Tech',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779004, long: -84.395849 },
  },
  {
    name: 'Klaus Advanced Computing Building',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777107, long: -84.395817 },
  },
  {
    name: 'Cherry Emerson',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.778011, long: -84.397065 },
  },
  {
    name: 'U A Whitaker Biomedical Engr',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.778513, long: -84.396825 },
  },
  {
    name: 'Whitaker',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.778513, long: -84.396825 },
  },
  {
    name: 'Molecular Sciences & Engr',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779836, long: -84.396666 },
  },
  {
    name: '760 Spring Street',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77561, long: -84.38906 },
  },
  {
    name: 'Paper Tricentennial',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.780983, long: -84.404516 },
  },
  {
    name: 'Daniel Lab',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.773714, long: -84.394047 },
  },
  {
    name: 'Pettit MiRC',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.776532, long: -84.397307 },
  },
  {
    name: 'Centergy',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.777062, long: -84.388997 },
  },
  {
    name: 'Stephen C Hall',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.774134, long: -84.39396 },
  },
  {
    name: 'Brittain T Room',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77247, long: -84.391271 },
  },
  {
    name: 'Hefner Dormitory(HEF)',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779159, long: -84.403952 },
  },
  {
    name: 'Old Civil Engr',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7742, long: -84.394637 },
  },
  {
    name: 'West Village Dining Commons',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.779564, long: -84.404718 },
  },
  {
    name: 'Couch',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.778233, long: -84.404507 },
  },
  {
    name: 'J. S. Coon',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77258, long: -84.395624 },
  },
  {
    name: '575 Fourteenth Street',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.786914, long: -84.406213 },
  },
  {
    name: 'Groseclose',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775778, long: -84.401885 },
  },
  {
    name: 'Theater for the Arts',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775041, long: -84.399287 },
  },
  {
    name: 'Habersham',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.773978, long: -84.404311 },
  },
  {
    name: 'Savant',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.772075, long: -84.395277 },
  },
  {
    name: 'ISyE Main',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775178, long: -84.401879 },
  },
  {
    name: 'Fourth Street Houses',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.775381, long: -84.391451 },
  },
  {
    name: 'Rich-Computer Center',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.77535159008218, long: -84.39513500282604 },
  },
  {
    name: 'Student Center',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7738, long: -84.397 },
  },
  {
    name: 'Campus Recreation Center',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7766, long: -84.4048 },
  },
  {
    name: 'Tech Tower',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7756, long: -84.3963 },
  },
  {
    name: 'McCamish Pavilion',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7805, long: -84.3921 },
  },
  {
    name: 'Bobby Dodd Stadium',
    address: 'Georgia Institute of Technology, Atlanta, GA',
    coords: { lat: 33.7723, long: -84.3922 },
  },
];

// Pre-computed distance matrix between GT locations
// This will be populated by calling Mapbox Matrix API once
// Key format: "lat1,long1|lat2,long2" for location pairs
// Value: walking duration in seconds
export const GT_DISTANCE_MATRIX: Record<LocationKey, DistanceMatrixEntry> = {
  '33.773568,-84.395957|33.773568,-84.395957': 0,
  '33.773568,-84.395957|33.774909,-84.396404': 227.9,
  '33.773568,-84.395957|33.776085,-84.400181': 445.7,
  '33.773568,-84.395957|33.776076,-84.396114': 301.3,
  '33.773568,-84.395957|33.776177,-84.395459': 296.9,
  '33.773568,-84.395957|33.776533,-84.387765': 786.7,
  '33.773568,-84.395957|33.771771,-84.395796': 181.1,
  '33.773568,-84.395957|33.776065,-84.397116': 320.8,
  '33.773568,-84.395957|33.775803,-84.398189': 293.5,
  '33.774909,-84.396404|33.773568,-84.395957': 227.9,
  '33.774909,-84.396404|33.774909,-84.396404': 0,
  '33.774909,-84.396404|33.776085,-84.400181': 310.5,
  '33.774909,-84.396404|33.776076,-84.396114': 105.4,
  '33.774909,-84.396404|33.776177,-84.395459': 189.5,
  '33.774909,-84.396404|33.776533,-84.387765': 711.1,
  '33.774909,-84.396404|33.771771,-84.395796': 391.4,
  '33.774909,-84.396404|33.776065,-84.397116': 124.9,
  '33.774909,-84.396404|33.775803,-84.398189': 121,
  '33.776085,-84.400181|33.773568,-84.395957': 445.7,
  '33.776085,-84.400181|33.774909,-84.396404': 310.5,
  '33.776085,-84.400181|33.776085,-84.400181': 0,
  '33.776085,-84.400181|33.776076,-84.396114': 368,
  '33.776085,-84.400181|33.776177,-84.395459': 442.2,
  '33.776085,-84.400181|33.776533,-84.387765': 912.5,
  '33.776085,-84.400181|33.771771,-84.395796': 583,
  '33.776085,-84.400181|33.776065,-84.397116': 369.3,
  '33.776085,-84.400181|33.775803,-84.398189': 239.8,
  '33.776076,-84.396114|33.773568,-84.395957': 301.3,
  '33.776076,-84.396114|33.774909,-84.396404': 105.4,
  '33.776076,-84.396114|33.776085,-84.400181': 368,
  '33.776076,-84.396114|33.776076,-84.396114': 0,
  '33.776076,-84.396114|33.776177,-84.395459': 119.1,
  '33.776076,-84.396114|33.776533,-84.387765': 656.8,
  '33.776076,-84.396114|33.771771,-84.395796': 450.8,
  '33.776076,-84.396114|33.776065,-84.397116': 61.1,
  '33.776076,-84.396114|33.775803,-84.398189': 171.1,
  '33.776177,-84.395459|33.773568,-84.395957': 296.9,
  '33.776177,-84.395459|33.774909,-84.396404': 189.5,
  '33.776177,-84.395459|33.776085,-84.400181': 442.2,
  '33.776177,-84.395459|33.776076,-84.396114': 119.1,
  '33.776177,-84.395459|33.776177,-84.395459': 0,
  '33.776177,-84.395459|33.776533,-84.387765': 581.1,
  '33.776177,-84.395459|33.771771,-84.395796': 435.7,
  '33.776177,-84.395459|33.776065,-84.397116': 131.7,
  '33.776177,-84.395459|33.775803,-84.398189': 273.3,
  '33.776533,-84.387765|33.773568,-84.395957': 786.7,
  '33.776533,-84.387765|33.774909,-84.396404': 711.1,
  '33.776533,-84.387765|33.776085,-84.400181': 912.5,
  '33.776533,-84.387765|33.776076,-84.396114': 656.8,
  '33.776533,-84.387765|33.776177,-84.395459': 581.1,
  '33.776533,-84.387765|33.776533,-84.387765': 0,
  '33.776533,-84.387765|33.771771,-84.395796': 925.5,
  '33.776533,-84.387765|33.776065,-84.397116': 669.4,
  '33.776533,-84.387765|33.775803,-84.398189': 800.1,
  '33.771771,-84.395796|33.773568,-84.395957': 181.1,
  '33.771771,-84.395796|33.774909,-84.396404': 391.4,
  '33.771771,-84.395796|33.776085,-84.400181': 583,
  '33.771771,-84.395796|33.776076,-84.396114': 450.8,
  '33.771771,-84.395796|33.776177,-84.395459': 435.7,
  '33.771771,-84.395796|33.776533,-84.387765': 925.5,
  '33.771771,-84.395796|33.771771,-84.395796': 0,
  '33.771771,-84.395796|33.776065,-84.397116': 470.3,
  '33.771771,-84.395796|33.775803,-84.398189': 445.1,
  '33.776065,-84.397116|33.773568,-84.395957': 320.8,
  '33.776065,-84.397116|33.774909,-84.396404': 124.9,
  '33.776065,-84.397116|33.776085,-84.400181': 369.3,
  '33.776065,-84.397116|33.776076,-84.396114': 61.1,
  '33.776065,-84.397116|33.776177,-84.395459': 131.7,
  '33.776065,-84.397116|33.776533,-84.387765': 669.4,
  '33.776065,-84.397116|33.771771,-84.395796': 470.3,
  '33.776065,-84.397116|33.776065,-84.397116': 0,
  '33.776065,-84.397116|33.775803,-84.398189': 190.6,
  '33.775803,-84.398189|33.773568,-84.395957': 293.5,
  '33.775803,-84.398189|33.774909,-84.396404': 121,
  '33.775803,-84.398189|33.776085,-84.400181': 239.8,
  '33.775803,-84.398189|33.776076,-84.396114': 171.1,
  '33.775803,-84.398189|33.776177,-84.395459': 273.3,
  '33.775803,-84.398189|33.776533,-84.387765': 800.1,
  '33.775803,-84.398189|33.771771,-84.395796': 445.1,
  '33.775803,-84.398189|33.776065,-84.397116': 190.6,
  '33.775803,-84.398189|33.775803,-84.398189': 0,
  '33.773568,-84.395957|33.777576,-84.397352': 467.4,
  '33.773568,-84.395957|33.772949,-84.396066': 85.3,
  '33.773568,-84.395957|33.772114,-84.395289': 138.3,
  '33.773568,-84.395957|33.776764,-84.39844': 409.3,
  '33.773568,-84.395957|33.77672,-84.401764': 612.4,
  '33.773568,-84.395957|33.777187,-84.400484': 533.7,
  '33.773568,-84.395957|33.77622,-84.397959': 328.6,
  '33.773568,-84.395957|33.777622,-84.398785': 520.8,
  '33.774909,-84.396404|33.777576,-84.397352': 271.5,
  '33.774909,-84.396404|33.772949,-84.396066': 258.2,
  '33.774909,-84.396404|33.772114,-84.395289': 348.6,
  '33.774909,-84.396404|33.776764,-84.39844': 236.8,
  '33.774909,-84.396404|33.77672,-84.401764': 494.9,
  '33.774909,-84.396404|33.777187,-84.400484': 398.5,
  '33.774909,-84.396404|33.77622,-84.397959': 156.1,
  '33.774909,-84.396404|33.777622,-84.398785': 348.3,
  '33.776085,-84.400181|33.777576,-84.397352': 309.2,
  '33.776085,-84.400181|33.772949,-84.396066': 447.8,
  '33.776085,-84.400181|33.772114,-84.395289': 553.4,
  '33.776085,-84.400181|33.776764,-84.39844': 196.1,
  '33.776085,-84.400181|33.77672,-84.401764': 184.4,
  '33.776085,-84.400181|33.777187,-84.400484': 150,
  '33.776085,-84.400181|33.77622,-84.397959': 182.9,
  '33.776085,-84.400181|33.777622,-84.398785': 230.2,
  '33.776076,-84.396114|33.777576,-84.397352': 207.7,
  '33.776076,-84.396114|33.772949,-84.396066': 331.6,
  '33.776076,-84.396114|33.772114,-84.395289': 408,
  '33.776076,-84.396114|33.776764,-84.39844': 226.7,
  '33.776076,-84.396114|33.77672,-84.401764': 552.4,
  '33.776076,-84.396114|33.777187,-84.400484': 388.9,
  '33.776076,-84.396114|33.77622,-84.397959': 206.2,
  '33.776076,-84.396114|33.777622,-84.398785': 289.4,
  '33.776177,-84.395459|33.777576,-84.397352': 255.5,
  '33.776177,-84.395459|33.772949,-84.396066': 368.9,
  '33.776177,-84.395459|33.772114,-84.395289': 392.9,
  '33.776177,-84.395459|33.776764,-84.39844': 280.9,
  '33.776177,-84.395459|33.77672,-84.401764': 626.4,
  '33.776177,-84.395459|33.777187,-84.400484': 443.1,
  '33.776177,-84.395459|33.77622,-84.397959': 285.4,
  '33.776177,-84.395459|33.777622,-84.398785': 343.6,
  '33.776533,-84.387765|33.777576,-84.397352': 718.2,
  '33.776533,-84.387765|33.772949,-84.396066': 858.7,
  '33.776533,-84.387765|33.772114,-84.395289': 882.7,
  '33.776533,-84.387765|33.776764,-84.39844': 751.2,
  '33.776533,-84.387765|33.77672,-84.401764': 1096.7,
  '33.776533,-84.387765|33.777187,-84.400484': 913.4,
  '33.776533,-84.387765|33.77622,-84.397959': 755.7,
  '33.776533,-84.387765|33.777622,-84.398785': 813.9,
  '33.771771,-84.395796|33.777576,-84.397352': 608.4,
  '33.771771,-84.395796|33.772949,-84.396066': 139.8,
  '33.771771,-84.395796|33.772114,-84.395289': 81.4,
  '33.771771,-84.395796|33.776764,-84.39844': 562.1,
  '33.771771,-84.395796|33.77672,-84.401764': 723.3,
  '33.771771,-84.395796|33.777187,-84.400484': 671,
  '33.771771,-84.395796|33.77622,-84.397959': 480.2,
  '33.771771,-84.395796|33.777622,-84.398785': 673.6,
  '33.776065,-84.397116|33.777576,-84.397352': 189,
  '33.776065,-84.397116|33.772949,-84.396066': 351.1,
  '33.776065,-84.397116|33.772114,-84.395289': 427.5,
  '33.776065,-84.397116|33.776764,-84.39844': 208,
  '33.776065,-84.397116|33.77672,-84.401764': 553.5,
  '33.776065,-84.397116|33.777187,-84.400484': 370.2,
  '33.776065,-84.397116|33.77622,-84.397959': 212.5,
  '33.776065,-84.397116|33.777622,-84.398785': 270.7,
  '33.775803,-84.398189|33.777576,-84.397352': 211.3,
  '33.775803,-84.398189|33.772949,-84.396066': 309.9,
  '33.775803,-84.398189|33.772114,-84.395289': 415.5,
  '33.775803,-84.398189|33.776764,-84.39844': 138.8,
  '33.775803,-84.398189|33.77672,-84.401764': 424.2,
  '33.775803,-84.398189|33.777187,-84.400484': 301.1,
  '33.775803,-84.398189|33.77622,-84.397959': 56.9,
  '33.775803,-84.398189|33.777622,-84.398785': 250.3,
  '33.773568,-84.395957|33.775587,-84.401213': 523.2,
  '33.773568,-84.395957|33.779177,-84.392196': 670.8,
  '33.773568,-84.395957|33.779495,-84.405633': 964.5,
  '33.773568,-84.395957|33.773801,-84.395122': 107.6,
  '33.773568,-84.395957|33.771658,-84.395302': 175,
  '33.773568,-84.395957|33.778759,-84.399597': 654.8,
  '33.773568,-84.395957|33.779004,-84.395849': 504.8,
  '33.773568,-84.395957|33.777107,-84.395817': 322.7,
  '33.773568,-84.395957|33.778011,-84.397065': 480.2,
  '33.773568,-84.395957|33.778513,-84.396825': 503.7,
  '33.774909,-84.396404|33.775587,-84.401213': 405.7,
  '33.774909,-84.396404|33.779177,-84.392196': 595.2,
  '33.774909,-84.396404|33.779495,-84.405633': 829.3,
  '33.774909,-84.396404|33.773801,-84.395122': 255.6,
  '33.774909,-84.396404|33.771658,-84.395302': 385.3,
  '33.774909,-84.396404|33.778759,-84.399597': 507.1,
  '33.774909,-84.396404|33.779004,-84.395849': 397.4,
  '33.774909,-84.396404|33.777107,-84.395817': 202.2,
  '33.774909,-84.396404|33.778011,-84.397065': 308.5,
  '33.774909,-84.396404|33.778513,-84.396825': 341,
  '33.776085,-84.400181|33.775587,-84.401213': 95.2,
  '33.776085,-84.400181|33.779177,-84.392196': 796.6,
  '33.776085,-84.400181|33.779495,-84.405633': 566.9,
  '33.776085,-84.400181|33.773801,-84.395122': 490.9,
  '33.776085,-84.400181|33.771658,-84.395302': 590.1,
  '33.776085,-84.400181|33.778759,-84.399597': 324.4,
  '33.776085,-84.400181|33.779004,-84.395849': 543.7,
  '33.776085,-84.400181|33.777107,-84.395817': 358.8,
  '33.776085,-84.400181|33.778011,-84.397065': 369.4,
  '33.776085,-84.400181|33.778513,-84.396825': 402.7,
  '33.776076,-84.396114|33.775587,-84.401213': 463.2,
  '33.776076,-84.396114|33.779177,-84.392196': 540.9,
  '33.776076,-84.396114|33.779495,-84.405633': 794.7,
  '33.776076,-84.396114|33.773801,-84.395122': 315,
  '33.776076,-84.396114|33.771658,-84.395302': 444.7,
  '33.776076,-84.396114|33.778759,-84.399597': 448.2,
  '33.776076,-84.396114|33.779004,-84.395849': 327,
  '33.776076,-84.396114|33.777107,-84.395817': 113.7,
  '33.776076,-84.396114|33.778011,-84.397065': 244.7,
  '33.776076,-84.396114|33.778513,-84.396825': 277.2,
  '33.776177,-84.395459|33.775587,-84.401213': 537.2,
  '33.776177,-84.395459|33.779177,-84.392196': 465.2,
  '33.776177,-84.395459|33.779495,-84.405633': 848.9,
  '33.776177,-84.395459|33.773801,-84.395122': 299.9,
  '33.776177,-84.395459|33.771658,-84.395302': 429.6,
  '33.776177,-84.395459|33.778759,-84.399597': 463.8,
  '33.776177,-84.395459|33.779004,-84.395849': 260.5,
  '33.776177,-84.395459|33.777107,-84.395817': 83.4,
  '33.776177,-84.395459|33.778011,-84.397065': 235.9,
  '33.776177,-84.395459|33.778513,-84.396825': 259.4,
  '33.776533,-84.387765|33.775587,-84.401213': 1007.5,
  '33.776533,-84.387765|33.779177,-84.392196': 502.7,
  '33.776533,-84.387765|33.779495,-84.405633': 1311.6,
  '33.776533,-84.387765|33.773801,-84.395122': 732.2,
  '33.776533,-84.387765|33.771658,-84.395302': 919.4,
  '33.776533,-84.387765|33.778759,-84.399597': 923.9,
  '33.776533,-84.387765|33.779004,-84.395849': 703.9,
  '33.776533,-84.387765|33.777107,-84.395817': 553.7,
  '33.776533,-84.387765|33.778011,-84.397065': 698.6,
  '33.776533,-84.387765|33.778513,-84.396825': 711.3,
  '33.771771,-84.395796|33.775587,-84.401213': 634.1,
  '33.771771,-84.395796|33.779177,-84.392196': 809.6,
  '33.771771,-84.395796|33.779495,-84.405633': 1101.8,
  '33.771771,-84.395796|33.773801,-84.395122': 210.9,
  '33.771771,-84.395796|33.771658,-84.395302': 73.4,
  '33.771771,-84.395796|33.778759,-84.399597': 792.1,
  '33.771771,-84.395796|33.779004,-84.395849': 643.6,
  '33.771771,-84.395796|33.777107,-84.395817': 461.5,
  '33.771771,-84.395796|33.778011,-84.397065': 619,
  '33.771771,-84.395796|33.778513,-84.396825': 642.5,
  '33.776065,-84.397116|33.775587,-84.401213': 464.3,
  '33.776065,-84.397116|33.779177,-84.392196': 553.5,
  '33.776065,-84.397116|33.779495,-84.405633': 776,
  '33.776065,-84.397116|33.773801,-84.395122': 334.5,
  '33.776065,-84.397116|33.771658,-84.395302': 464.2,
  '33.776065,-84.397116|33.778759,-84.399597': 429.5,
  '33.776065,-84.397116|33.779004,-84.395849': 329.3,
  '33.776065,-84.397116|33.777107,-84.395817': 126.3,
  '33.776065,-84.397116|33.778011,-84.397065': 226,
  '33.776065,-84.397116|33.778513,-84.396825': 258.5,
  '33.775803,-84.398189|33.775587,-84.401213': 335,
  '33.775803,-84.398189|33.779177,-84.392196': 684.2,
  '33.775803,-84.398189|33.779495,-84.405633': 731.9,
  '33.775803,-84.398189|33.773801,-84.395122': 338.7,
  '33.775803,-84.398189|33.771658,-84.395302': 452.2,
  '33.775803,-84.398189|33.778759,-84.399597': 409.1,
  '33.775803,-84.398189|33.779004,-84.395849': 444.6,
  '33.775803,-84.398189|33.777107,-84.395817': 258.9,
  '33.775803,-84.398189|33.778011,-84.397065': 271.5,
  '33.775803,-84.398189|33.778513,-84.396825': 304.8,
  '33.773568,-84.395957|33.779836,-84.396666': 570.1,
  '33.773568,-84.395957|33.77561,-84.38906': 787.5,
  '33.773568,-84.395957|33.780983,-84.404516': 1010,
  '33.773568,-84.395957|33.773714,-84.394047': 152.3,
  '33.773568,-84.395957|33.776532,-84.397307': 337.6,
  '33.773568,-84.395957|33.777062,-84.388997': 718,
  '33.773568,-84.395957|33.774134,-84.39396': 180.8,
  '33.773568,-84.395957|33.77247,-84.391271': 522.8,
  '33.773568,-84.395957|33.779159,-84.403952': 837.3,
  '33.773568,-84.395957|33.7742,-84.394637': 111.8,
  '33.773568,-84.395957|33.779564,-84.404718': 903.6,
  '33.773568,-84.395957|33.778233,-84.404507': 838.1,
  '33.774909,-84.396404|33.779836,-84.396666': 407.4,
  '33.774909,-84.396404|33.77561,-84.38906': 711.9,
  '33.774909,-84.396404|33.780983,-84.404516': 874.8,
  '33.774909,-84.396404|33.773714,-84.394047': 298.8,
  '33.774909,-84.396404|33.776532,-84.397307': 141.7,
  '33.774909,-84.396404|33.777062,-84.388997': 642.4,
  '33.774909,-84.396404|33.774134,-84.39396': 319.4,
  '33.774909,-84.396404|33.77247,-84.391271': 669,
  '33.774909,-84.396404|33.779159,-84.403952': 702.1,
  '33.774909,-84.396404|33.7742,-84.394637': 250.4,
  '33.774909,-84.396404|33.779564,-84.404718': 768.4,
  '33.774909,-84.396404|33.778233,-84.404507': 702.9,
  '33.776085,-84.400181|33.779836,-84.396666': 503.3,
  '33.776085,-84.400181|33.77561,-84.38906': 913.3,
  '33.776085,-84.400181|33.780983,-84.404516': 628.2,
  '33.776085,-84.400181|33.773714,-84.394047': 535.6,
  '33.776085,-84.400181|33.776532,-84.397307': 318.9,
  '33.776085,-84.400181|33.777062,-84.388997': 843.8,
  '33.776085,-84.400181|33.774134,-84.39396': 564.1,
  '33.776085,-84.400181|33.77247,-84.391271': 906.1,
  '33.776085,-84.400181|33.779159,-84.403952': 411.9,
  '33.776085,-84.400181|33.7742,-84.394637': 495.1,
  '33.776085,-84.400181|33.779564,-84.404718': 506,
  '33.776085,-84.400181|33.778233,-84.404507': 412.7,
  '33.776076,-84.396114|33.779836,-84.396666': 343.6,
  '33.776076,-84.396114|33.77561,-84.38906': 657.6,
  '33.776076,-84.396114|33.780983,-84.404516': 840.2,
  '33.776076,-84.396114|33.773714,-84.394047': 358.2,
  '33.776076,-84.396114|33.776532,-84.397307': 77.9,
  '33.776076,-84.396114|33.777062,-84.388997': 588.1,
  '33.776076,-84.396114|33.774134,-84.39396': 378.8,
  '33.776076,-84.396114|33.77247,-84.391271': 726.6,
  '33.776076,-84.396114|33.779159,-84.403952': 681,
  '33.776076,-84.396114|33.7742,-84.394637': 309.8,
  '33.776076,-84.396114|33.779564,-84.404718': 733.8,
  '33.776076,-84.396114|33.778233,-84.404507': 725.7,
  '33.776177,-84.395459|33.779836,-84.396666': 325.8,
  '33.776177,-84.395459|33.77561,-84.38906': 581.9,
  '33.776177,-84.395459|33.780983,-84.404516': 891.6,
  '33.776177,-84.395459|33.773714,-84.394047': 333.3,
  '33.776177,-84.395459|33.776532,-84.397307': 139.9,
  '33.776177,-84.395459|33.777062,-84.388997': 512.4,
  '33.776177,-84.395459|33.774134,-84.39396': 312.5,
  '33.776177,-84.395459|33.77247,-84.391271': 641.9,
  '33.776177,-84.395459|33.779159,-84.403952': 735.2,
  '33.776177,-84.395459|33.7742,-84.394637': 294.7,
  '33.776177,-84.395459|33.779564,-84.404718': 788,
  '33.776177,-84.395459|33.778233,-84.404507': 779.9,
  '33.776533,-84.387765|33.779836,-84.396666': 777.7,
  '33.776533,-84.387765|33.77561,-84.38906': 181.2,
  '33.776533,-84.387765|33.780983,-84.404516': 1354.3,
  '33.776533,-84.387765|33.773714,-84.394047': 698.4,
  '33.776533,-84.387765|33.776532,-84.397307': 665.7,
  '33.776533,-84.387765|33.777062,-84.388997': 113.7,
  '33.776533,-84.387765|33.774134,-84.39396': 673,
  '33.776533,-84.387765|33.77247,-84.391271': 744.6,
  '33.776533,-84.387765|33.779159,-84.403952': 1205.5,
  '33.776533,-84.387765|33.7742,-84.394637': 692.2,
  '33.776533,-84.387765|33.779564,-84.404718': 1250.7,
  '33.776533,-84.387765|33.778233,-84.404507': 1250.2,
  '33.771771,-84.395796|33.779836,-84.396666': 708.9,
  '33.771771,-84.395796|33.77561,-84.38906': 831.2,
  '33.771771,-84.395796|33.780983,-84.404516': 1147.3,
  '33.771771,-84.395796|33.773714,-84.394047': 246.3,
  '33.771771,-84.395796|33.776532,-84.397307': 485.8,
  '33.771771,-84.395796|33.777062,-84.388997': 856.8,
  '33.771771,-84.395796|33.774134,-84.39396': 306.8,
  '33.771771,-84.395796|33.77247,-84.391271': 418.7,
  '33.771771,-84.395796|33.779159,-84.403952': 950.8,
  '33.771771,-84.395796|33.7742,-84.394637': 250.6,
  '33.771771,-84.395796|33.779564,-84.404718': 1040.9,
  '33.771771,-84.395796|33.778233,-84.404507': 951.6,
  '33.776065,-84.397116|33.779836,-84.396666': 324.9,
  '33.776065,-84.397116|33.77561,-84.38906': 670.2,
  '33.776065,-84.397116|33.780983,-84.404516': 821.5,
  '33.776065,-84.397116|33.773714,-84.394047': 377.7,
  '33.776065,-84.397116|33.776532,-84.397307': 59.2,
  '33.776065,-84.397116|33.777062,-84.388997': 600.7,
  '33.776065,-84.397116|33.774134,-84.39396': 398.3,
  '33.776065,-84.397116|33.77247,-84.391271': 740.1,
  '33.776065,-84.397116|33.779159,-84.403952': 662.3,
  '33.776065,-84.397116|33.7742,-84.394637': 329.3,
  '33.776065,-84.397116|33.779564,-84.404718': 715.1,
  '33.776065,-84.397116|33.778233,-84.404507': 707,
  '33.775803,-84.398189|33.779836,-84.396666': 405.4,
  '33.775803,-84.398189|33.77561,-84.38906': 800.9,
  '33.775803,-84.398189|33.780983,-84.404516': 777.4,
  '33.775803,-84.398189|33.773714,-84.394047': 383.4,
  '33.775803,-84.398189|33.776532,-84.397307': 207.4,
  '33.775803,-84.398189|33.777062,-84.388997': 731.4,
  '33.775803,-84.398189|33.774134,-84.39396': 408.4,
  '33.775803,-84.398189|33.77247,-84.391271': 753.9,
  '33.775803,-84.398189|33.779159,-84.403952': 607.8,
  '33.775803,-84.398189|33.7742,-84.394637': 339.4,
  '33.775803,-84.398189|33.779564,-84.404718': 671,
  '33.775803,-84.398189|33.778233,-84.404507': 608.6,
  '33.773568,-84.395957|33.77258,-84.395624': 109.3,
  '33.773568,-84.395957|33.786914,-84.406213': 1531.3,
  '33.773568,-84.395957|33.775778,-84.401885': 527.5,
  '33.773568,-84.395957|33.775041,-84.399287': 351.9,
  '33.773568,-84.395957|33.773978,-84.404311': 771.3,
  '33.773568,-84.395957|33.772075,-84.395277': 141.5,
  '33.773568,-84.395957|33.775178,-84.401879': 514.1,
  '33.773568,-84.395957|33.775381,-84.391451': 440.5,
  '33.773568,-84.395957|33.77535159008218,-84.39513500282604': 191.8,
  '33.773568,-84.395957|33.7738,-84.397': 122.2,
  '33.773568,-84.395957|33.7766,-84.4048': 790.1,
  '33.773568,-84.395957|33.7756,-84.3963': 240.1,
  '33.774909,-84.396404|33.77258,-84.395624': 319.6,
  '33.774909,-84.396404|33.786914,-84.406213': 1396.1,
  '33.774909,-84.396404|33.775778,-84.401885': 417.1,
  '33.774909,-84.396404|33.775041,-84.399287': 241.5,
  '33.774909,-84.396404|33.773978,-84.404311': 745.9,
  '33.774909,-84.396404|33.772075,-84.395277': 351.8,
  '33.774909,-84.396404|33.775178,-84.401879': 403.7,
  '33.774909,-84.396404|33.775381,-84.391451': 398.8,
  '33.774909,-84.396404|33.77535159008218,-84.39513500282604': 122.6,
  '33.774909,-84.396404|33.7738,-84.397': 142.9,
  '33.774909,-84.396404|33.7766,-84.4048': 672.6,
  '33.774909,-84.396404|33.7756,-84.3963': 83.5,
  '33.776085,-84.400181|33.77258,-84.395624': 535.8,
  '33.776085,-84.400181|33.786914,-84.406213': 1149.5,
  '33.776085,-84.400181|33.775778,-84.401885': 114.1,
  '33.776085,-84.400181|33.775041,-84.399287': 212.3,
  '33.776085,-84.400181|33.773978,-84.404311': 533.7,
  '33.776085,-84.400181|33.772075,-84.395277': 556.6,
  '33.776085,-84.400181|33.775178,-84.401879': 217.4,
  '33.776085,-84.400181|33.775381,-84.391451': 677.3,
  '33.776085,-84.400181|33.77535159008218,-84.39513500282604': 401.1,
  '33.776085,-84.400181|33.7738,-84.397': 355.3,
  '33.776085,-84.400181|33.7766,-84.4048': 362.1,
  '33.776085,-84.400181|33.7756,-84.3963': 346.1,
  '33.776076,-84.396114|33.77258,-84.395624': 379,
  '33.776076,-84.396114|33.786914,-84.406213': 1361.5,
  '33.776076,-84.396114|33.775778,-84.401885': 474.6,
  '33.776076,-84.396114|33.775041,-84.399287': 299,
  '33.776076,-84.396114|33.773978,-84.404311': 803.4,
  '33.776076,-84.396114|33.772075,-84.395277': 411.2,
  '33.776076,-84.396114|33.775178,-84.401879': 461.2,
  '33.776076,-84.396114|33.775381,-84.391451': 422.4,
  '33.776076,-84.396114|33.77535159008218,-84.39513500282604': 182,
  '33.776076,-84.396114|33.7738,-84.397': 216.3,
  '33.776076,-84.396114|33.7766,-84.4048': 730.1,
  '33.776076,-84.396114|33.7756,-84.3963': 71.9,
  '33.776177,-84.395459|33.77258,-84.395624': 363.9,
  '33.776177,-84.395459|33.786914,-84.406213': 1408.1,
  '33.776177,-84.395459|33.775778,-84.401885': 556.1,
  '33.776177,-84.395459|33.775041,-84.399287': 399,
  '33.776177,-84.395459|33.773978,-84.404311': 903.4,
  '33.776177,-84.395459|33.772075,-84.395277': 396.1,
  '33.776177,-84.395459|33.775178,-84.401879': 561.2,
  '33.776177,-84.395459|33.775381,-84.391451': 341.7,
  '33.776177,-84.395459|33.77535159008218,-84.39513500282604': 166.9,
  '33.776177,-84.395459|33.7738,-84.397': 300.4,
  '33.776177,-84.395459|33.7766,-84.4048': 804.1,
  '33.776177,-84.395459|33.7756,-84.3963': 129.4,
  '33.776533,-84.387765|33.77258,-84.395624': 853.7,
  '33.776533,-84.387765|33.786914,-84.406213': 1870.8,
  '33.776533,-84.387765|33.775778,-84.401885': 1026.4,
  '33.776533,-84.387765|33.775041,-84.399287': 920.6,
  '33.776533,-84.387765|33.773978,-84.404311': 1425,
  '33.776533,-84.387765|33.772075,-84.395277': 885.9,
  '33.776533,-84.387765|33.775178,-84.401879': 1082.8,
  '33.776533,-84.387765|33.775381,-84.391451': 436.6,
  '33.776533,-84.387765|33.77535159008218,-84.39513500282604': 594.9,
  '33.776533,-84.387765|33.7738,-84.397': 822,
  '33.776533,-84.387765|33.7766,-84.4048': 1274.4,
  '33.776533,-84.387765|33.7756,-84.3963': 662.3,
  '33.771771,-84.395796|33.77258,-84.395624': 88.6,
  '33.771771,-84.395796|33.786914,-84.406213': 1668.6,
  '33.771771,-84.395796|33.775778,-84.401885': 638.4,
  '33.771771,-84.395796|33.775041,-84.399287': 462.8,
  '33.771771,-84.395796|33.773978,-84.404311': 793.7,
  '33.771771,-84.395796|33.772075,-84.395277': 84.6,
  '33.771771,-84.395796|33.775178,-84.401879': 625,
  '33.771771,-84.395796|33.775381,-84.391451': 561.4,
  '33.771771,-84.395796|33.77535159008218,-84.39513500282604': 330.6,
  '33.771771,-84.395796|33.7738,-84.397': 253.5,
  '33.771771,-84.395796|33.7766,-84.4048': 880.7,
  '33.771771,-84.395796|33.7756,-84.3963': 378.9,
  '33.776065,-84.397116|33.77258,-84.395624': 398.5,
  '33.776065,-84.397116|33.786914,-84.406213': 1342.8,
  '33.776065,-84.397116|33.775778,-84.401885': 483.2,
  '33.776065,-84.397116|33.775041,-84.399287': 318.5,
  '33.776065,-84.397116|33.773978,-84.404311': 822.9,
  '33.776065,-84.397116|33.772075,-84.395277': 430.7,
  '33.776065,-84.397116|33.775178,-84.401879': 480.7,
  '33.776065,-84.397116|33.775381,-84.391451': 435,
  '33.776065,-84.397116|33.77535159008218,-84.39513500282604': 201.5,
  '33.776065,-84.397116|33.7738,-84.397': 235.8,
  '33.776065,-84.397116|33.7766,-84.4048': 731.2,
  '33.776065,-84.397116|33.7756,-84.3963': 91.4,
  '33.775803,-84.398189|33.77258,-84.395624': 397.9,
  '33.775803,-84.398189|33.786914,-84.406213': 1298.7,
  '33.775803,-84.398189|33.775778,-84.401885': 353.9,
  '33.775803,-84.398189|33.775041,-84.399287': 197.5,
  '33.775803,-84.398189|33.773978,-84.404311': 701.9,
  '33.775803,-84.398189|33.772075,-84.395277': 418.7,
  '33.775803,-84.398189|33.775178,-84.401879': 359.7,
  '33.775803,-84.398189|33.775381,-84.391451': 487.8,
  '33.775803,-84.398189|33.77535159008218,-84.39513500282604': 211.6,
  '33.775803,-84.398189|33.7738,-84.397': 208.5,
  '33.775803,-84.398189|33.7766,-84.4048': 601.9,
  '33.775803,-84.398189|33.7756,-84.3963': 149.2,
  '33.773568,-84.395957|33.7805,-84.3921': 792.4,
  '33.773568,-84.395957|33.7723,-84.3922': 407.4,
  '33.774909,-84.396404|33.7805,-84.3921': 716.8,
  '33.774909,-84.396404|33.7723,-84.3922': 553.9,
  '33.776085,-84.400181|33.7805,-84.3921': 918.2,
  '33.776085,-84.400181|33.7723,-84.3922': 790.7,
  '33.776076,-84.396114|33.7805,-84.3921': 662.5,
  '33.776076,-84.396114|33.7723,-84.3922': 613.3,
  '33.776177,-84.395459|33.7805,-84.3921': 586.8,
  '33.776177,-84.395459|33.7723,-84.3922': 530.8,
  '33.776533,-84.387765|33.7805,-84.3921': 705.5,
  '33.776533,-84.387765|33.7723,-84.3922': 669.2,
  '33.771771,-84.395796|33.7805,-84.3921': 931.2,
  '33.771771,-84.395796|33.7723,-84.3922': 342.4,
  '33.776065,-84.397116|33.7805,-84.3921': 675.1,
  '33.776065,-84.397116|33.7723,-84.3922': 629,
  '33.775803,-84.398189|33.7805,-84.3921': 805.8,
  '33.775803,-84.398189|33.7723,-84.3922': 638.5,
  '33.777576,-84.397352|33.773568,-84.395957': 467.4,
  '33.777576,-84.397352|33.774909,-84.396404': 271.5,
  '33.777576,-84.397352|33.776085,-84.400181': 309.2,
  '33.777576,-84.397352|33.776076,-84.396114': 207.7,
  '33.777576,-84.397352|33.776177,-84.395459': 255.5,
  '33.777576,-84.397352|33.776533,-84.387765': 718.2,
  '33.777576,-84.397352|33.771771,-84.395796': 608.4,
  '33.777576,-84.397352|33.776065,-84.397116': 189,
  '33.777576,-84.397352|33.775803,-84.398189': 211.3,
  '33.772949,-84.396066|33.773568,-84.395957': 85.3,
  '33.772949,-84.396066|33.774909,-84.396404': 258.2,
  '33.772949,-84.396066|33.776085,-84.400181': 447.8,
  '33.772949,-84.396066|33.776076,-84.396114': 331.6,
  '33.772949,-84.396066|33.776177,-84.395459': 368.9,
  '33.772949,-84.396066|33.776533,-84.387765': 858.7,
  '33.772949,-84.396066|33.771771,-84.395796': 139.8,
  '33.772949,-84.396066|33.776065,-84.397116': 351.1,
  '33.772949,-84.396066|33.775803,-84.398189': 309.9,
  '33.772114,-84.395289|33.773568,-84.395957': 138.3,
  '33.772114,-84.395289|33.774909,-84.396404': 348.6,
  '33.772114,-84.395289|33.776085,-84.400181': 553.4,
  '33.772114,-84.395289|33.776076,-84.396114': 408,
  '33.772114,-84.395289|33.776177,-84.395459': 392.9,
  '33.772114,-84.395289|33.776533,-84.387765': 882.7,
  '33.772114,-84.395289|33.771771,-84.395796': 81.4,
  '33.772114,-84.395289|33.776065,-84.397116': 427.5,
  '33.772114,-84.395289|33.775803,-84.398189': 415.5,
  '33.776764,-84.39844|33.773568,-84.395957': 409.3,
  '33.776764,-84.39844|33.774909,-84.396404': 236.8,
  '33.776764,-84.39844|33.776085,-84.400181': 196.1,
  '33.776764,-84.39844|33.776076,-84.396114': 226.7,
  '33.776764,-84.39844|33.776177,-84.395459': 280.9,
  '33.776764,-84.39844|33.776533,-84.387765': 751.2,
  '33.776764,-84.39844|33.771771,-84.395796': 562.1,
  '33.776764,-84.39844|33.776065,-84.397116': 208,
  '33.776764,-84.39844|33.775803,-84.398189': 138.8,
  '33.77672,-84.401764|33.773568,-84.395957': 612.4,
  '33.77672,-84.401764|33.774909,-84.396404': 494.9,
  '33.77672,-84.401764|33.776085,-84.400181': 184.4,
  '33.77672,-84.401764|33.776076,-84.396114': 552.4,
  '33.77672,-84.401764|33.776177,-84.395459': 626.4,
  '33.77672,-84.401764|33.776533,-84.387765': 1096.7,
  '33.77672,-84.401764|33.771771,-84.395796': 723.3,
  '33.77672,-84.401764|33.776065,-84.397116': 553.5,
  '33.77672,-84.401764|33.775803,-84.398189': 424.2,
  '33.777187,-84.400484|33.773568,-84.395957': 533.7,
  '33.777187,-84.400484|33.774909,-84.396404': 398.5,
  '33.777187,-84.400484|33.776085,-84.400181': 150,
  '33.777187,-84.400484|33.776076,-84.396114': 388.9,
  '33.777187,-84.400484|33.776177,-84.395459': 443.1,
  '33.777187,-84.400484|33.776533,-84.387765': 913.4,
  '33.777187,-84.400484|33.771771,-84.395796': 671,
  '33.777187,-84.400484|33.776065,-84.397116': 370.2,
  '33.777187,-84.400484|33.775803,-84.398189': 301.1,
  '33.77622,-84.397959|33.773568,-84.395957': 328.6,
  '33.77622,-84.397959|33.774909,-84.396404': 156.1,
  '33.77622,-84.397959|33.776085,-84.400181': 182.9,
  '33.77622,-84.397959|33.776076,-84.396114': 206.2,
  '33.77622,-84.397959|33.776177,-84.395459': 285.4,
  '33.77622,-84.397959|33.776533,-84.387765': 755.7,
  '33.77622,-84.397959|33.771771,-84.395796': 480.2,
  '33.77622,-84.397959|33.776065,-84.397116': 212.5,
  '33.77622,-84.397959|33.775803,-84.398189': 56.9,
  '33.777622,-84.398785|33.773568,-84.395957': 520.8,
  '33.777622,-84.398785|33.774909,-84.396404': 348.3,
  '33.777622,-84.398785|33.776085,-84.400181': 230.2,
  '33.777622,-84.398785|33.776076,-84.396114': 289.4,
  '33.777622,-84.398785|33.776177,-84.395459': 343.6,
  '33.777622,-84.398785|33.776533,-84.387765': 813.9,
  '33.777622,-84.398785|33.771771,-84.395796': 673.6,
  '33.777622,-84.398785|33.776065,-84.397116': 270.7,
  '33.777622,-84.398785|33.775803,-84.398189': 250.3,
  '33.777576,-84.397352|33.777576,-84.397352': 0,
  '33.777576,-84.397352|33.772949,-84.396066': 497.7,
  '33.777576,-84.397352|33.772114,-84.395289': 565.6,
  '33.777576,-84.397352|33.776764,-84.39844': 147.9,
  '33.777576,-84.397352|33.77672,-84.401764': 493.4,
  '33.777576,-84.397352|33.777187,-84.400484': 290.9,
  '33.777576,-84.397352|33.77622,-84.397959': 154.4,
  '33.777576,-84.397352|33.777622,-84.398785': 101.2,
  '33.772949,-84.396066|33.777576,-84.397352': 497.7,
  '33.772949,-84.396066|33.772949,-84.396066': 0,
  '33.772949,-84.396066|33.772114,-84.395289': 110.2,
  '33.772949,-84.396066|33.776764,-84.39844': 426.9,
  '33.772949,-84.396066|33.77672,-84.401764': 614.5,
  '33.772949,-84.396066|33.777187,-84.400484': 535.8,
  '33.772949,-84.396066|33.77622,-84.397959': 345,
  '33.772949,-84.396066|33.777622,-84.398785': 538.4,
  '33.772114,-84.395289|33.777576,-84.397352': 565.6,
  '33.772114,-84.395289|33.772949,-84.396066': 110.2,
  '33.772114,-84.395289|33.772114,-84.395289': 0,
  '33.772114,-84.395289|33.776764,-84.39844': 532.5,
  '33.772114,-84.395289|33.77672,-84.401764': 693.7,
  '33.772114,-84.395289|33.777187,-84.400484': 641.4,
  '33.772114,-84.395289|33.77622,-84.397959': 450.6,
  '33.772114,-84.395289|33.777622,-84.398785': 644,
  '33.776764,-84.39844|33.777576,-84.397352': 147.9,
  '33.776764,-84.39844|33.772949,-84.396066': 426.9,
  '33.776764,-84.39844|33.772114,-84.395289': 532.5,
  '33.776764,-84.39844|33.776764,-84.39844': 0,
  '33.776764,-84.39844|33.77672,-84.401764': 380.5,
  '33.776764,-84.39844|33.777187,-84.400484': 210.7,
  '33.776764,-84.39844|33.77622,-84.397959': 81.9,
  '33.776764,-84.39844|33.777622,-84.398785': 154.3,
  '33.77672,-84.401764|33.777576,-84.397352': 493.4,
  '33.77672,-84.401764|33.772949,-84.396066': 614.5,
  '33.77672,-84.401764|33.772114,-84.395289': 693.7,
  '33.77672,-84.401764|33.776764,-84.39844': 380.5,
  '33.77672,-84.401764|33.77672,-84.401764': 0,
  '33.77672,-84.401764|33.777187,-84.400484': 304.9,
  '33.77672,-84.401764|33.77622,-84.397959': 367.3,
  '33.77672,-84.401764|33.777622,-84.398785': 394.9,
  '33.777187,-84.400484|33.777576,-84.397352': 290.9,
  '33.777187,-84.400484|33.772949,-84.396066': 535.8,
  '33.777187,-84.400484|33.772114,-84.395289': 641.4,
  '33.777187,-84.400484|33.776764,-84.39844': 210.7,
  '33.777187,-84.400484|33.77672,-84.401764': 304.9,
  '33.777187,-84.400484|33.777187,-84.400484': 0,
  '33.777187,-84.400484|33.77622,-84.397959': 244.2,
  '33.777187,-84.400484|33.777622,-84.398785': 189.7,
  '33.77622,-84.397959|33.777576,-84.397352': 154.4,
  '33.77622,-84.397959|33.772949,-84.396066': 345,
  '33.77622,-84.397959|33.772114,-84.395289': 450.6,
  '33.77622,-84.397959|33.776764,-84.39844': 81.9,
  '33.77622,-84.397959|33.77672,-84.401764': 367.3,
  '33.77622,-84.397959|33.777187,-84.400484': 244.2,
  '33.77622,-84.397959|33.77622,-84.397959': 0,
  '33.77622,-84.397959|33.777622,-84.398785': 193.4,
  '33.777622,-84.398785|33.777576,-84.397352': 101.2,
  '33.777622,-84.398785|33.772949,-84.396066': 538.4,
  '33.777622,-84.398785|33.772114,-84.395289': 644,
  '33.777622,-84.398785|33.776764,-84.39844': 154.3,
  '33.777622,-84.398785|33.77672,-84.401764': 394.9,
  '33.777622,-84.398785|33.777187,-84.400484': 189.7,
  '33.777622,-84.398785|33.77622,-84.397959': 193.4,
  '33.777622,-84.398785|33.777622,-84.398785': 0,
  '33.777576,-84.397352|33.775587,-84.401213': 404.2,
  '33.777576,-84.397352|33.779177,-84.392196': 590.6,
  '33.777576,-84.397352|33.779495,-84.405633': 643.2,
  '33.777576,-84.397352|33.773801,-84.395122': 472.6,
  '33.777576,-84.397352|33.771658,-84.395302': 602.3,
  '33.777576,-84.397352|33.778759,-84.399597': 260,
  '33.777576,-84.397352|33.779004,-84.395849': 234.5,
  '33.777576,-84.397352|33.777107,-84.395817': 178.5,
  '33.777576,-84.397352|33.778011,-84.397065': 122.4,
  '33.777576,-84.397352|33.778513,-84.396825': 155.7,
  '33.772949,-84.396066|33.775587,-84.401213': 525.3,
  '33.772949,-84.396066|33.779177,-84.392196': 742.8,
  '33.772949,-84.396066|33.779495,-84.405633': 966.6,
  '33.772949,-84.396066|33.773801,-84.395122': 144.1,
  '33.772949,-84.396066|33.771658,-84.395302': 146.9,
  '33.772949,-84.396066|33.778759,-84.399597': 656.9,
  '33.772949,-84.396066|33.779004,-84.395849': 576.8,
  '33.772949,-84.396066|33.777107,-84.395817': 394.7,
  '33.772949,-84.396066|33.778011,-84.397065': 534.7,
  '33.772949,-84.396066|33.778513,-84.396825': 567.2,
  '33.772114,-84.395289|33.775587,-84.401213': 604.5,
  '33.772114,-84.395289|33.779177,-84.392196': 766.8,
  '33.772114,-84.395289|33.779495,-84.405633': 1072.2,
  '33.772114,-84.395289|33.773801,-84.395122': 168.1,
  '33.772114,-84.395289|33.771658,-84.395302': 36.7,
  '33.772114,-84.395289|33.778759,-84.399597': 762.5,
  '33.772114,-84.395289|33.779004,-84.395849': 600.8,
  '33.772114,-84.395289|33.777107,-84.395817': 418.7,
  '33.772114,-84.395289|33.778011,-84.397065': 576.2,
  '33.772114,-84.395289|33.778513,-84.396825': 599.7,
  '33.776764,-84.39844|33.775587,-84.401213': 291.3,
  '33.776764,-84.39844|33.779177,-84.392196': 635.3,
  '33.776764,-84.39844|33.779495,-84.405633': 616.5,
  '33.776764,-84.39844|33.773801,-84.395122': 454.5,
  '33.776764,-84.39844|33.771658,-84.395302': 569.2,
  '33.776764,-84.39844|33.778759,-84.399597': 271.4,
  '33.776764,-84.39844|33.779004,-84.395849': 382.4,
  '33.776764,-84.39844|33.777107,-84.395817': 197.5,
  '33.776764,-84.39844|33.778011,-84.397065': 208.1,
  '33.776764,-84.39844|33.778513,-84.396825': 241.4,
  '33.77672,-84.401764|33.775587,-84.401213': 121.4,
  '33.77672,-84.401764|33.779177,-84.392196': 980.8,
  '33.77672,-84.401764|33.779495,-84.405633': 479.2,
  '33.77672,-84.401764|33.773801,-84.395122': 657.6,
  '33.77672,-84.401764|33.771658,-84.395302': 730.4,
  '33.77672,-84.401764|33.778759,-84.399597': 342.9,
  '33.77672,-84.401764|33.779004,-84.395849': 667.2,
  '33.77672,-84.401764|33.777107,-84.395817': 543,
  '33.77672,-84.401764|33.778011,-84.397065': 487,
  '33.77672,-84.401764|33.778513,-84.396825': 519.1,
  '33.777187,-84.400484|33.775587,-84.401213': 224.6,
  '33.777187,-84.400484|33.779177,-84.392196': 797.5,
  '33.777187,-84.400484|33.779495,-84.405633': 464.2,
  '33.777187,-84.400484|33.773801,-84.395122': 578.9,
  '33.777187,-84.400484|33.771658,-84.395302': 678.1,
  '33.777187,-84.400484|33.778759,-84.399597': 261.5,
  '33.777187,-84.400484|33.779004,-84.395849': 511.2,
  '33.777187,-84.400484|33.777107,-84.395817': 359.7,
  '33.777187,-84.400484|33.778011,-84.397065': 330.1,
  '33.777187,-84.400484|33.778513,-84.396825': 363.4,
  '33.77622,-84.397959|33.775587,-84.401213': 278.1,
  '33.77622,-84.397959|33.779177,-84.392196': 639.8,
  '33.77622,-84.397959|33.779495,-84.405633': 675,
  '33.77622,-84.397959|33.773801,-84.395122': 373.8,
  '33.77622,-84.397959|33.771658,-84.395302': 487.3,
  '33.77622,-84.397959|33.778759,-84.399597': 352.2,
  '33.77622,-84.397959|33.779004,-84.395849': 387.7,
  '33.77622,-84.397959|33.777107,-84.395817': 202,
  '33.77622,-84.397959|33.778011,-84.397065': 214.6,
  '33.77622,-84.397959|33.778513,-84.396825': 247.9,
  '33.777622,-84.398785|33.775587,-84.401213': 308.4,
  '33.777622,-84.398785|33.779177,-84.392196': 691.8,
  '33.777622,-84.398785|33.779495,-84.405633': 543.1,
  '33.777622,-84.398785|33.773801,-84.395122': 554.3,
  '33.777622,-84.398785|33.771658,-84.395302': 680.7,
  '33.777622,-84.398785|33.778759,-84.399597': 161.3,
  '33.777622,-84.398785|33.779004,-84.395849': 335.7,
  '33.777622,-84.398785|33.777107,-84.395817': 260.2,
  '33.777622,-84.398785|33.778011,-84.397065': 161.4,
  '33.777622,-84.398785|33.778513,-84.396825': 194.7,
  '33.777576,-84.397352|33.779836,-84.396666': 230.1,
  '33.777576,-84.397352|33.77561,-84.38906': 719,
  '33.777576,-84.397352|33.780983,-84.404516': 685.9,
  '33.777576,-84.397352|33.773714,-84.394047': 515.8,
  '33.777576,-84.397352|33.776532,-84.397307': 168.7,
  '33.777576,-84.397352|33.777062,-84.388997': 639.5,
  '33.777576,-84.397352|33.774134,-84.39396': 536.4,
  '33.777576,-84.397352|33.77247,-84.391271': 852.4,
  '33.777576,-84.397352|33.779159,-84.403952': 540.1,
  '33.777576,-84.397352|33.7742,-84.394637': 467.4,
  '33.777576,-84.397352|33.779564,-84.404718': 582.3,
  '33.777576,-84.397352|33.778233,-84.404507': 584.8,
  '33.772949,-84.396066|33.779836,-84.396666': 633.6,
  '33.772949,-84.396066|33.77561,-84.38906': 859.5,
  '33.772949,-84.396066|33.780983,-84.404516': 1012.1,
  '33.772949,-84.396066|33.773714,-84.394047': 217.1,
  '33.772949,-84.396066|33.776532,-84.397307': 367.9,
  '33.772949,-84.396066|33.777062,-84.388997': 790,
  '33.772949,-84.396066|33.774134,-84.39396': 252.8,
  '33.772949,-84.396066|33.77247,-84.391271': 502.6,
  '33.772949,-84.396066|33.779159,-84.403952': 839.4,
  '33.772949,-84.396066|33.7742,-84.394637': 183.8,
  '33.772949,-84.396066|33.779564,-84.404718': 905.7,
  '33.772949,-84.396066|33.778233,-84.404507': 840.2,
  '33.772114,-84.395289|33.779836,-84.396666': 666.1,
  '33.772114,-84.395289|33.77561,-84.38906': 834.9,
  '33.772114,-84.395289|33.780983,-84.404516': 1117.7,
  '33.772114,-84.395289|33.773714,-84.394047': 196.3,
  '33.772114,-84.395289|33.776532,-84.397307': 443,
  '33.772114,-84.395289|33.777062,-84.388997': 814,
  '33.772114,-84.395289|33.774134,-84.39396': 256.8,
  '33.772114,-84.395289|33.77247,-84.391271': 422.4,
  '33.772114,-84.395289|33.779159,-84.403952': 921.2,
  '33.772114,-84.395289|33.7742,-84.394637': 207.8,
  '33.772114,-84.395289|33.779564,-84.404718': 1011.3,
  '33.772114,-84.395289|33.778233,-84.404507': 922,
  '33.776764,-84.39844|33.779836,-84.396666': 342,
  '33.776764,-84.39844|33.77561,-84.38906': 752,
  '33.776764,-84.39844|33.780983,-84.404516': 662,
  '33.776764,-84.39844|33.773714,-84.394047': 499.2,
  '33.776764,-84.39844|33.776532,-84.397307': 157.6,
  '33.776764,-84.39844|33.777062,-84.388997': 682.5,
  '33.776764,-84.39844|33.774134,-84.39396': 524.2,
  '33.776764,-84.39844|33.77247,-84.391271': 869.7,
  '33.776764,-84.39844|33.779159,-84.403952': 502.8,
  '33.776764,-84.39844|33.7742,-84.394637': 455.2,
  '33.776764,-84.39844|33.779564,-84.404718': 555.6,
  '33.776764,-84.39844|33.778233,-84.404507': 547.5,
  '33.77672,-84.401764|33.779836,-84.396666': 592.9,
  '33.77672,-84.401764|33.77561,-84.38906': 1097.5,
  '33.77672,-84.401764|33.780983,-84.404516': 576.2,
  '33.77672,-84.401764|33.773714,-84.394047': 702.3,
  '33.77672,-84.401764|33.776532,-84.397307': 503.1,
  '33.77672,-84.401764|33.777062,-84.388997': 1028,
  '33.77672,-84.401764|33.774134,-84.39396': 730.8,
  '33.77672,-84.401764|33.77247,-84.391271': 1072.8,
  '33.77672,-84.401764|33.779159,-84.403952': 324.2,
  '33.77672,-84.401764|33.7742,-84.394637': 661.8,
  '33.77672,-84.401764|33.779564,-84.404718': 418.3,
  '33.77672,-84.401764|33.778233,-84.404507': 290.1,
  '33.777187,-84.400484|33.779836,-84.396666': 464,
  '33.777187,-84.400484|33.77561,-84.38906': 914.2,
  '33.777187,-84.400484|33.780983,-84.404516': 509.7,
  '33.777187,-84.400484|33.773714,-84.394047': 623.6,
  '33.777187,-84.400484|33.776532,-84.397307': 319.8,
  '33.777187,-84.400484|33.777062,-84.388997': 844.7,
  '33.777187,-84.400484|33.774134,-84.39396': 652.1,
  '33.777187,-84.400484|33.77247,-84.391271': 994.1,
  '33.777187,-84.400484|33.779159,-84.403952': 350.5,
  '33.777187,-84.400484|33.7742,-84.394637': 583.1,
  '33.777187,-84.400484|33.779564,-84.404718': 403.3,
  '33.777187,-84.400484|33.778233,-84.404507': 395.2,
  '33.77622,-84.397959|33.779836,-84.396666': 348.5,
  '33.77622,-84.397959|33.77561,-84.38906': 756.5,
  '33.77622,-84.397959|33.780983,-84.404516': 720.5,
  '33.77622,-84.397959|33.773714,-84.394047': 418.5,
  '33.77622,-84.397959|33.776532,-84.397307': 162.1,
  '33.77622,-84.397959|33.777062,-84.388997': 687,
  '33.77622,-84.397959|33.774134,-84.39396': 443.5,
  '33.77622,-84.397959|33.77247,-84.391271': 789,
  '33.77622,-84.397959|33.779159,-84.403952': 550.9,
  '33.77622,-84.397959|33.7742,-84.394637': 374.5,
  '33.77622,-84.397959|33.779564,-84.404718': 614.1,
  '33.77622,-84.397959|33.778233,-84.404507': 551.7,
  '33.777622,-84.398785|33.779836,-84.396666': 295.3,
  '33.777622,-84.398785|33.77561,-84.38906': 814.7,
  '33.777622,-84.398785|33.780983,-84.404516': 585.8,
  '33.777622,-84.398785|33.773714,-84.394047': 597.5,
  '33.777622,-84.398785|33.776532,-84.397307': 220.3,
  '33.777622,-84.398785|33.777062,-84.388997': 740.7,
  '33.777622,-84.398785|33.774134,-84.39396': 618.1,
  '33.777622,-84.398785|33.77247,-84.391271': 948.1,
  '33.777622,-84.398785|33.779159,-84.403952': 440,
  '33.777622,-84.398785|33.7742,-84.394637': 549.1,
  '33.777622,-84.398785|33.779564,-84.404718': 482.2,
  '33.777622,-84.398785|33.778233,-84.404507': 484.7,
  '33.777576,-84.397352|33.77258,-84.395624': 536.6,
  '33.777576,-84.397352|33.786914,-84.406213': 1202.4,
  '33.777576,-84.397352|33.775778,-84.401885': 423.1,
  '33.777576,-84.397352|33.775041,-84.399287': 387,
  '33.777576,-84.397352|33.773978,-84.404311': 842.7,
  '33.777576,-84.397352|33.772075,-84.395277': 568.8,
  '33.777576,-84.397352|33.775178,-84.401879': 526.4,
  '33.777576,-84.397352|33.775381,-84.391451': 547.3,
  '33.777576,-84.397352|33.77535159008218,-84.39513500282604': 339.6,
  '33.777576,-84.397352|33.7738,-84.397': 382.4,
  '33.777576,-84.397352|33.7766,-84.4048': 646.4,
  '33.777576,-84.397352|33.7756,-84.3963': 238,
  '33.772949,-84.396066|33.77258,-84.395624': 109.1,
  '33.772949,-84.396066|33.786914,-84.406213': 1533.4,
  '33.772949,-84.396066|33.775778,-84.401885': 529.6,
  '33.772949,-84.396066|33.775041,-84.399287': 354,
  '33.772949,-84.396066|33.773978,-84.404311': 735.8,
  '33.772949,-84.396066|33.772075,-84.395277': 113.4,
  '33.772949,-84.396066|33.775178,-84.401879': 516.2,
  '33.772949,-84.396066|33.775381,-84.391451': 511.9,
  '33.772949,-84.396066|33.77535159008218,-84.39513500282604': 263.8,
  '33.772949,-84.396066|33.7738,-84.397': 115.3,
  '33.772949,-84.396066|33.7766,-84.4048': 792.2,
  '33.772949,-84.396066|33.7756,-84.3963': 309.7,
  '33.772114,-84.395289|33.77258,-84.395624': 45.8,
  '33.772114,-84.395289|33.786914,-84.406213': 1639,
  '33.772114,-84.395289|33.775778,-84.401885': 608.8,
  '33.772114,-84.395289|33.775041,-84.399287': 433.2,
  '33.772114,-84.395289|33.773978,-84.404311': 764.1,
  '33.772114,-84.395289|33.772075,-84.395277': 3.2,
  '33.772114,-84.395289|33.775178,-84.401879': 595.4,
  '33.772114,-84.395289|33.775381,-84.391451': 511.4,
  '33.772114,-84.395289|33.77535159008218,-84.39513500282604': 287.8,
  '33.772114,-84.395289|33.7738,-84.397': 223.9,
  '33.772114,-84.395289|33.7766,-84.4048': 851.1,
  '33.772114,-84.395289|33.7756,-84.3963': 336.1,
  '33.776764,-84.39844|33.77258,-84.395624': 514.9,
  '33.776764,-84.39844|33.786914,-84.406213': 1183.3,
  '33.776764,-84.39844|33.775778,-84.401885': 310.2,
  '33.776764,-84.39844|33.775041,-84.399287': 296.7,
  '33.776764,-84.39844|33.773978,-84.404311': 729.8,
  '33.776764,-84.39844|33.772075,-84.395277': 535.7,
  '33.776764,-84.39844|33.775178,-84.401879': 413.5,
  '33.776764,-84.39844|33.775381,-84.391451': 580.3,
  '33.776764,-84.39844|33.77535159008218,-84.39513500282604': 327.4,
  '33.776764,-84.39844|33.7738,-84.397': 324.3,
  '33.776764,-84.39844|33.7766,-84.4048': 558.2,
  '33.776764,-84.39844|33.7756,-84.3963': 257,
  '33.77672,-84.401764|33.77258,-84.395624': 693.4,
  '33.77672,-84.401764|33.786914,-84.406213': 1107.2,
  '33.77672,-84.401764|33.775778,-84.401885': 140.3,
  '33.77672,-84.401764|33.775041,-84.399287': 315.1,
  '33.77672,-84.401764|33.773978,-84.404311': 478.9,
  '33.77672,-84.401764|33.772075,-84.395277': 696.9,
  '33.77672,-84.401764|33.775178,-84.401879': 162.6,
  '33.77672,-84.401764|33.775381,-84.391451': 861.7,
  '33.77672,-84.401764|33.77535159008218,-84.39513500282604': 585.5,
  '33.77672,-84.401764|33.7738,-84.397': 522,
  '33.77672,-84.401764|33.7766,-84.4048': 259.9,
  '33.77672,-84.401764|33.7756,-84.3963': 530.5,
  '33.777187,-84.400484|33.77258,-84.395624': 623.8,
  '33.777187,-84.400484|33.786914,-84.406213': 1031,
  '33.777187,-84.400484|33.775778,-84.401885': 243.5,
  '33.777187,-84.400484|33.775041,-84.399287': 341.7,
  '33.777187,-84.400484|33.773978,-84.404311': 663.1,
  '33.777187,-84.400484|33.772075,-84.395277': 644.6,
  '33.777187,-84.400484|33.775178,-84.401879': 346.8,
  '33.777187,-84.400484|33.775381,-84.391451': 742.5,
  '33.777187,-84.400484|33.77535159008218,-84.39513500282604': 489.1,
  '33.777187,-84.400484|33.7738,-84.397': 443.3,
  '33.777187,-84.400484|33.7766,-84.4048': 456.3,
  '33.777187,-84.400484|33.7756,-84.3963': 419.2,
  '33.77622,-84.397959|33.77258,-84.395624': 433,
  '33.77622,-84.397959|33.786914,-84.406213': 1241.8,
  '33.77622,-84.397959|33.775778,-84.401885': 297,
  '33.77622,-84.397959|33.775041,-84.399287': 232.6,
  '33.77622,-84.397959|33.773978,-84.404311': 716.6,
  '33.77622,-84.397959|33.772075,-84.395277': 453.8,
  '33.77622,-84.397959|33.775178,-84.401879': 394.8,
  '33.77622,-84.397959|33.775381,-84.391451': 522.9,
  '33.77622,-84.397959|33.77535159008218,-84.39513500282604': 246.7,
  '33.77622,-84.397959|33.7738,-84.397': 243.6,
  '33.77622,-84.397959|33.7766,-84.4048': 545,
  '33.77622,-84.397959|33.7756,-84.3963': 184.3,
  '33.777622,-84.398785|33.77258,-84.395624': 618.3,
  '33.777622,-84.398785|33.786914,-84.406213': 1102.3,
  '33.777622,-84.398785|33.775778,-84.401885': 327.3,
  '33.777622,-84.398785|33.775041,-84.399287': 349.4,
  '33.777622,-84.398785|33.773978,-84.404311': 746.9,
  '33.777622,-84.398785|33.772075,-84.395277': 647.2,
  '33.777622,-84.398785|33.775178,-84.401879': 430.6,
  '33.777622,-84.398785|33.775381,-84.391451': 643,
  '33.777622,-84.398785|33.77535159008218,-84.39513500282604': 421.3,
  '33.777622,-84.398785|33.7738,-84.397': 435.8,
  '33.777622,-84.398785|33.7766,-84.4048': 546.3,
  '33.777622,-84.398785|33.7756,-84.3963': 319.7,
  '33.777576,-84.397352|33.7805,-84.3921': 701.4,
  '33.777576,-84.397352|33.7723,-84.3922': 741.3,
  '33.772949,-84.396066|33.7805,-84.3921': 864.4,
  '33.772949,-84.396066|33.7723,-84.3922': 426.3,
  '33.772114,-84.395289|33.7805,-84.3921': 888.4,
  '33.772114,-84.395289|33.7723,-84.3922': 346.1,
  '33.776764,-84.39844|33.7805,-84.3921': 756.9,
  '33.776764,-84.39844|33.7723,-84.3922': 754.3,
  '33.77672,-84.401764|33.7805,-84.3921': 1052.8,
  '33.77672,-84.401764|33.7723,-84.3922': 957.4,
  '33.777187,-84.400484|33.7805,-84.3921': 919.1,
  '33.777187,-84.400484|33.7723,-84.3922': 878.7,
  '33.77622,-84.397959|33.7805,-84.3921': 761.4,
  '33.77622,-84.397959|33.7723,-84.3922': 673.6,
  '33.777622,-84.398785|33.7805,-84.3921': 766.6,
  '33.777622,-84.398785|33.7723,-84.3922': 837,
  '33.775587,-84.401213|33.773568,-84.395957': 523.2,
  '33.775587,-84.401213|33.774909,-84.396404': 405.7,
  '33.775587,-84.401213|33.776085,-84.400181': 95.2,
  '33.775587,-84.401213|33.776076,-84.396114': 463.2,
  '33.775587,-84.401213|33.776177,-84.395459': 537.2,
  '33.775587,-84.401213|33.776533,-84.387765': 1007.5,
  '33.775587,-84.401213|33.771771,-84.395796': 634.1,
  '33.775587,-84.401213|33.776065,-84.397116': 464.3,
  '33.775587,-84.401213|33.775803,-84.398189': 335,
  '33.779177,-84.392196|33.773568,-84.395957': 670.8,
  '33.779177,-84.392196|33.774909,-84.396404': 595.2,
  '33.779177,-84.392196|33.776085,-84.400181': 796.6,
  '33.779177,-84.392196|33.776076,-84.396114': 540.9,
  '33.779177,-84.392196|33.776177,-84.395459': 465.2,
  '33.779177,-84.392196|33.776533,-84.387765': 502.7,
  '33.779177,-84.392196|33.771771,-84.395796': 809.6,
  '33.779177,-84.392196|33.776065,-84.397116': 553.5,
  '33.779177,-84.392196|33.775803,-84.398189': 684.2,
  '33.779495,-84.405633|33.773568,-84.395957': 964.5,
  '33.779495,-84.405633|33.774909,-84.396404': 829.3,
  '33.779495,-84.405633|33.776085,-84.400181': 566.9,
  '33.779495,-84.405633|33.776076,-84.396114': 794.7,
  '33.779495,-84.405633|33.776177,-84.395459': 848.9,
  '33.779495,-84.405633|33.776533,-84.387765': 1311.6,
  '33.779495,-84.405633|33.771771,-84.395796': 1101.8,
  '33.779495,-84.405633|33.776065,-84.397116': 776,
  '33.779495,-84.405633|33.775803,-84.398189': 731.9,
  '33.773801,-84.395122|33.773568,-84.395957': 107.6,
  '33.773801,-84.395122|33.774909,-84.396404': 255.6,
  '33.773801,-84.395122|33.776085,-84.400181': 490.9,
  '33.773801,-84.395122|33.776076,-84.396114': 315,
  '33.773801,-84.395122|33.776177,-84.395459': 299.9,
  '33.773801,-84.395122|33.776533,-84.387765': 732.2,
  '33.773801,-84.395122|33.771771,-84.395796': 210.9,
  '33.773801,-84.395122|33.776065,-84.397116': 334.5,
  '33.773801,-84.395122|33.775803,-84.398189': 338.7,
  '33.771658,-84.395302|33.773568,-84.395957': 175,
  '33.771658,-84.395302|33.774909,-84.396404': 385.3,
  '33.771658,-84.395302|33.776085,-84.400181': 590.1,
  '33.771658,-84.395302|33.776076,-84.396114': 444.7,
  '33.771658,-84.395302|33.776177,-84.395459': 429.6,
  '33.771658,-84.395302|33.776533,-84.387765': 919.4,
  '33.771658,-84.395302|33.771771,-84.395796': 73.4,
  '33.771658,-84.395302|33.776065,-84.397116': 464.2,
  '33.771658,-84.395302|33.775803,-84.398189': 452.2,
  '33.778759,-84.399597|33.773568,-84.395957': 654.8,
  '33.778759,-84.399597|33.774909,-84.396404': 507.1,
  '33.778759,-84.399597|33.776085,-84.400181': 324.4,
  '33.778759,-84.399597|33.776076,-84.396114': 448.2,
  '33.778759,-84.399597|33.776177,-84.395459': 463.8,
  '33.778759,-84.399597|33.776533,-84.387765': 923.9,
  '33.778759,-84.399597|33.771771,-84.395796': 792.1,
  '33.778759,-84.399597|33.776065,-84.397116': 429.5,
  '33.778759,-84.399597|33.775803,-84.398189': 409.1,
  '33.779004,-84.395849|33.773568,-84.395957': 504.8,
  '33.779004,-84.395849|33.774909,-84.396404': 397.4,
  '33.779004,-84.395849|33.776085,-84.400181': 543.7,
  '33.779004,-84.395849|33.776076,-84.396114': 327,
  '33.779004,-84.395849|33.776177,-84.395459': 260.5,
  '33.779004,-84.395849|33.776533,-84.387765': 703.9,
  '33.779004,-84.395849|33.771771,-84.395796': 643.6,
  '33.779004,-84.395849|33.776065,-84.397116': 329.3,
  '33.779004,-84.395849|33.775803,-84.398189': 444.6,
  '33.777107,-84.395817|33.773568,-84.395957': 322.7,
  '33.777107,-84.395817|33.774909,-84.396404': 202.2,
  '33.777107,-84.395817|33.776085,-84.400181': 358.8,
  '33.777107,-84.395817|33.776076,-84.396114': 113.7,
  '33.777107,-84.395817|33.776177,-84.395459': 83.4,
  '33.777107,-84.395817|33.776533,-84.387765': 553.7,
  '33.777107,-84.395817|33.771771,-84.395796': 461.5,
  '33.777107,-84.395817|33.776065,-84.397116': 126.3,
  '33.777107,-84.395817|33.775803,-84.398189': 258.9,
  '33.778011,-84.397065|33.773568,-84.395957': 480.2,
  '33.778011,-84.397065|33.774909,-84.396404': 308.5,
  '33.778011,-84.397065|33.776085,-84.400181': 369.4,
  '33.778011,-84.397065|33.776076,-84.396114': 244.7,
  '33.778011,-84.397065|33.776177,-84.395459': 235.9,
  '33.778011,-84.397065|33.776533,-84.387765': 698.6,
  '33.778011,-84.397065|33.771771,-84.395796': 619,
  '33.778011,-84.397065|33.776065,-84.397116': 226,
  '33.778011,-84.397065|33.775803,-84.398189': 271.5,
  '33.778513,-84.396825|33.773568,-84.395957': 503.7,
  '33.778513,-84.396825|33.774909,-84.396404': 341,
  '33.778513,-84.396825|33.776085,-84.400181': 402.7,
  '33.778513,-84.396825|33.776076,-84.396114': 277.2,
  '33.778513,-84.396825|33.776177,-84.395459': 259.4,
  '33.778513,-84.396825|33.776533,-84.387765': 711.3,
  '33.778513,-84.396825|33.771771,-84.395796': 642.5,
  '33.778513,-84.396825|33.776065,-84.397116': 258.5,
  '33.778513,-84.396825|33.775803,-84.398189': 304.8,
  '33.775587,-84.401213|33.777576,-84.397352': 404.2,
  '33.775587,-84.401213|33.772949,-84.396066': 525.3,
  '33.775587,-84.401213|33.772114,-84.395289': 604.5,
  '33.775587,-84.401213|33.776764,-84.39844': 291.3,
  '33.775587,-84.401213|33.77672,-84.401764': 121.4,
  '33.775587,-84.401213|33.777187,-84.400484': 224.6,
  '33.775587,-84.401213|33.77622,-84.397959': 278.1,
  '33.775587,-84.401213|33.777622,-84.398785': 308.4,
  '33.779177,-84.392196|33.777576,-84.397352': 590.6,
  '33.779177,-84.392196|33.772949,-84.396066': 742.8,
  '33.779177,-84.392196|33.772114,-84.395289': 766.8,
  '33.779177,-84.392196|33.776764,-84.39844': 635.3,
  '33.779177,-84.392196|33.77672,-84.401764': 980.8,
  '33.779177,-84.392196|33.777187,-84.400484': 797.5,
  '33.779177,-84.392196|33.77622,-84.397959': 639.8,
  '33.779177,-84.392196|33.777622,-84.398785': 691.8,
  '33.779495,-84.405633|33.777576,-84.397352': 643.2,
  '33.779495,-84.405633|33.772949,-84.396066': 966.6,
  '33.779495,-84.405633|33.772114,-84.395289': 1072.2,
  '33.779495,-84.405633|33.776764,-84.39844': 616.5,
  '33.779495,-84.405633|33.77672,-84.401764': 479.2,
  '33.779495,-84.405633|33.777187,-84.400484': 464.2,
  '33.779495,-84.405633|33.77622,-84.397959': 675,
  '33.779495,-84.405633|33.777622,-84.398785': 543.1,
  '33.773801,-84.395122|33.777576,-84.397352': 472.6,
  '33.773801,-84.395122|33.772949,-84.396066': 144.1,
  '33.773801,-84.395122|33.772114,-84.395289': 168.1,
  '33.773801,-84.395122|33.776764,-84.39844': 454.5,
  '33.773801,-84.395122|33.77672,-84.401764': 657.6,
  '33.773801,-84.395122|33.777187,-84.400484': 578.9,
  '33.773801,-84.395122|33.77622,-84.397959': 373.8,
  '33.773801,-84.395122|33.777622,-84.398785': 554.3,
  '33.771658,-84.395302|33.777576,-84.397352': 602.3,
  '33.771658,-84.395302|33.772949,-84.396066': 146.9,
  '33.771658,-84.395302|33.772114,-84.395289': 36.7,
  '33.771658,-84.395302|33.776764,-84.39844': 569.2,
  '33.771658,-84.395302|33.77672,-84.401764': 730.4,
  '33.771658,-84.395302|33.777187,-84.400484': 678.1,
  '33.771658,-84.395302|33.77622,-84.397959': 487.3,
  '33.771658,-84.395302|33.777622,-84.398785': 680.7,
  '33.778759,-84.399597|33.777576,-84.397352': 260,
  '33.778759,-84.399597|33.772949,-84.396066': 656.9,
  '33.778759,-84.399597|33.772114,-84.395289': 762.5,
  '33.778759,-84.399597|33.776764,-84.39844': 271.4,
  '33.778759,-84.399597|33.77672,-84.401764': 342.9,
  '33.778759,-84.399597|33.777187,-84.400484': 261.5,
  '33.778759,-84.399597|33.77622,-84.397959': 352.2,
  '33.778759,-84.399597|33.777622,-84.398785': 161.3,
  '33.779004,-84.395849|33.777576,-84.397352': 234.5,
  '33.779004,-84.395849|33.772949,-84.396066': 576.8,
  '33.779004,-84.395849|33.772114,-84.395289': 600.8,
  '33.779004,-84.395849|33.776764,-84.39844': 382.4,
  '33.779004,-84.395849|33.77672,-84.401764': 667.2,
  '33.779004,-84.395849|33.777187,-84.400484': 511.2,
  '33.779004,-84.395849|33.77622,-84.397959': 387.7,
  '33.779004,-84.395849|33.777622,-84.398785': 335.7,
  '33.777107,-84.395817|33.777576,-84.397352': 178.5,
  '33.777107,-84.395817|33.772949,-84.396066': 394.7,
  '33.777107,-84.395817|33.772114,-84.395289': 418.7,
  '33.777107,-84.395817|33.776764,-84.39844': 197.5,
  '33.777107,-84.395817|33.77672,-84.401764': 543,
  '33.777107,-84.395817|33.777187,-84.400484': 359.7,
  '33.777107,-84.395817|33.77622,-84.397959': 202,
  '33.777107,-84.395817|33.777622,-84.398785': 260.2,
  '33.778011,-84.397065|33.777576,-84.397352': 122.4,
  '33.778011,-84.397065|33.772949,-84.396066': 534.7,
  '33.778011,-84.397065|33.772114,-84.395289': 576.2,
  '33.778011,-84.397065|33.776764,-84.39844': 208.1,
  '33.778011,-84.397065|33.77672,-84.401764': 487,
  '33.778011,-84.397065|33.777187,-84.400484': 330.1,
  '33.778011,-84.397065|33.77622,-84.397959': 214.6,
  '33.778011,-84.397065|33.777622,-84.398785': 161.4,
  '33.778513,-84.396825|33.777576,-84.397352': 155.7,
  '33.778513,-84.396825|33.772949,-84.396066': 567.2,
  '33.778513,-84.396825|33.772114,-84.395289': 599.7,
  '33.778513,-84.396825|33.776764,-84.39844': 241.4,
  '33.778513,-84.396825|33.77672,-84.401764': 519.1,
  '33.778513,-84.396825|33.777187,-84.400484': 363.4,
  '33.778513,-84.396825|33.77622,-84.397959': 247.9,
  '33.778513,-84.396825|33.777622,-84.398785': 194.7,
  '33.775587,-84.401213|33.775587,-84.401213': 0,
  '33.775587,-84.401213|33.779177,-84.392196': 891.6,
  '33.775587,-84.401213|33.779495,-84.405633': 580.5,
  '33.775587,-84.401213|33.773801,-84.395122': 568.4,
  '33.775587,-84.401213|33.771658,-84.395302': 641.2,
  '33.775587,-84.401213|33.778759,-84.399597': 402,
  '33.775587,-84.401213|33.779004,-84.395849': 629.9,
  '33.775587,-84.401213|33.777107,-84.395817': 453.8,
  '33.775587,-84.401213|33.778011,-84.397065': 448.8,
  '33.775587,-84.401213|33.778513,-84.396825': 482.1,
  '33.779177,-84.392196|33.775587,-84.401213': 891.6,
  '33.779177,-84.392196|33.779177,-84.392196': 0,
  '33.779177,-84.392196|33.779495,-84.405633': 1179.3,
  '33.779177,-84.392196|33.773801,-84.395122': 616.3,
  '33.779177,-84.392196|33.771658,-84.395302': 803.5,
  '33.779177,-84.392196|33.778759,-84.399597': 788.2,
  '33.779177,-84.392196|33.779004,-84.395849': 568.2,
  '33.779177,-84.392196|33.777107,-84.395817': 437.8,
  '33.779177,-84.392196|33.778011,-84.397065': 571,
  '33.779177,-84.392196|33.778513,-84.396825': 575.6,
  '33.779495,-84.405633|33.775587,-84.401213': 580.5,
  '33.779495,-84.405633|33.779177,-84.392196': 1179.3,
  '33.779495,-84.405633|33.779495,-84.405633': 0,
  '33.779495,-84.405633|33.773801,-84.395122': 1009.7,
  '33.779495,-84.405633|33.771658,-84.395302': 1108.9,
  '33.779495,-84.405633|33.778759,-84.399597': 441.5,
  '33.779495,-84.405633|33.779004,-84.395849': 807,
  '33.779495,-84.405633|33.777107,-84.395817': 765.5,
  '33.779495,-84.405633|33.778011,-84.397065': 635.2,
  '33.779495,-84.405633|33.778513,-84.396825': 656.5,
  '33.773801,-84.395122|33.775587,-84.401213': 568.4,
  '33.773801,-84.395122|33.779177,-84.392196': 616.3,
  '33.773801,-84.395122|33.779495,-84.405633': 1009.7,
  '33.773801,-84.395122|33.773801,-84.395122': 0,
  '33.773801,-84.395122|33.771658,-84.395302': 204.8,
  '33.773801,-84.395122|33.778759,-84.399597': 700,
  '33.773801,-84.395122|33.779004,-84.395849': 507.8,
  '33.773801,-84.395122|33.777107,-84.395817': 325.7,
  '33.773801,-84.395122|33.778011,-84.397065': 483.2,
  '33.773801,-84.395122|33.778513,-84.396825': 506.7,
  '33.771658,-84.395302|33.775587,-84.401213': 641.2,
  '33.771658,-84.395302|33.779177,-84.392196': 803.5,
  '33.771658,-84.395302|33.779495,-84.405633': 1108.9,
  '33.771658,-84.395302|33.773801,-84.395122': 204.8,
  '33.771658,-84.395302|33.771658,-84.395302': 0,
  '33.771658,-84.395302|33.778759,-84.399597': 799.2,
  '33.771658,-84.395302|33.779004,-84.395849': 637.5,
  '33.771658,-84.395302|33.777107,-84.395817': 455.4,
  '33.771658,-84.395302|33.778011,-84.397065': 612.9,
  '33.771658,-84.395302|33.778513,-84.396825': 636.4,
  '33.778759,-84.399597|33.775587,-84.401213': 402,
  '33.778759,-84.399597|33.779177,-84.392196': 788.2,
  '33.778759,-84.399597|33.779495,-84.405633': 441.5,
  '33.778759,-84.399597|33.773801,-84.395122': 700,
  '33.778759,-84.399597|33.771658,-84.395302': 799.2,
  '33.778759,-84.399597|33.778759,-84.399597': 0,
  '33.778759,-84.399597|33.779004,-84.395849': 415,
  '33.778759,-84.399597|33.777107,-84.395817': 419,
  '33.778759,-84.399597|33.778011,-84.397065': 250.1,
  '33.778759,-84.399597|33.778513,-84.396825': 264.5,
  '33.779004,-84.395849|33.775587,-84.401213': 629.9,
  '33.779004,-84.395849|33.779177,-84.392196': 568.2,
  '33.779004,-84.395849|33.779495,-84.405633': 807,
  '33.779004,-84.395849|33.773801,-84.395122': 507.8,
  '33.779004,-84.395849|33.771658,-84.395302': 637.5,
  '33.779004,-84.395849|33.778759,-84.399597': 415,
  '33.779004,-84.395849|33.779004,-84.395849': 0,
  '33.779004,-84.395849|33.777107,-84.395817': 223.9,
  '33.779004,-84.395849|33.778011,-84.397065': 204.6,
  '33.779004,-84.395849|33.778513,-84.396825': 197.9,
  '33.777107,-84.395817|33.775587,-84.401213': 453.8,
  '33.777107,-84.395817|33.779177,-84.392196': 437.8,
  '33.777107,-84.395817|33.779495,-84.405633': 765.5,
  '33.777107,-84.395817|33.773801,-84.395122': 325.7,
  '33.777107,-84.395817|33.771658,-84.395302': 455.4,
  '33.777107,-84.395817|33.778759,-84.399597': 419,
  '33.777107,-84.395817|33.779004,-84.395849': 223.9,
  '33.777107,-84.395817|33.777107,-84.395817': 0,
  '33.777107,-84.395817|33.778011,-84.397065': 199.3,
  '33.777107,-84.395817|33.778513,-84.396825': 222.8,
  '33.778011,-84.397065|33.775587,-84.401213': 448.8,
  '33.778011,-84.397065|33.779177,-84.392196': 571,
  '33.778011,-84.397065|33.779495,-84.405633': 635.2,
  '33.778011,-84.397065|33.773801,-84.395122': 483.2,
  '33.778011,-84.397065|33.771658,-84.395302': 612.9,
  '33.778011,-84.397065|33.778759,-84.399597': 250.1,
  '33.778011,-84.397065|33.779004,-84.395849': 204.6,
  '33.778011,-84.397065|33.777107,-84.395817': 199.3,
  '33.778011,-84.397065|33.778011,-84.397065': 0,
  '33.778011,-84.397065|33.778513,-84.396825': 83.8,
  '33.778513,-84.396825|33.775587,-84.401213': 482.1,
  '33.778513,-84.396825|33.779177,-84.392196': 575.6,
  '33.778513,-84.396825|33.779495,-84.405633': 656.5,
  '33.778513,-84.396825|33.773801,-84.395122': 506.7,
  '33.778513,-84.396825|33.771658,-84.395302': 636.4,
  '33.778513,-84.396825|33.778759,-84.399597': 264.5,
  '33.778513,-84.396825|33.779004,-84.395849': 197.9,
  '33.778513,-84.396825|33.777107,-84.395817': 222.8,
  '33.778513,-84.396825|33.778011,-84.397065': 83.8,
  '33.778513,-84.396825|33.778513,-84.396825': 0,
  '33.775587,-84.401213|33.779836,-84.396666': 582.7,
  '33.775587,-84.401213|33.77561,-84.38906': 1008.3,
  '33.775587,-84.401213|33.780983,-84.404516': 677.5,
  '33.775587,-84.401213|33.773714,-84.394047': 613.1,
  '33.775587,-84.401213|33.776532,-84.397307': 413.9,
  '33.775587,-84.401213|33.777062,-84.388997': 938.8,
  '33.775587,-84.401213|33.774134,-84.39396': 641.6,
  '33.775587,-84.401213|33.77247,-84.391271': 983.6,
  '33.775587,-84.401213|33.779159,-84.403952': 425.5,
  '33.775587,-84.401213|33.7742,-84.394637': 572.6,
  '33.775587,-84.401213|33.779564,-84.404718': 519.6,
  '33.775587,-84.401213|33.778233,-84.404507': 393.3,
  '33.779177,-84.392196|33.779836,-84.396666': 564,
  '33.779177,-84.392196|33.77561,-84.38906': 503.5,
  '33.779177,-84.392196|33.780983,-84.404516': 1200.6,
  '33.779177,-84.392196|33.773714,-84.394047': 598.7,
  '33.779177,-84.392196|33.776532,-84.397307': 549.8,
  '33.779177,-84.392196|33.777062,-84.388997': 415.9,
  '33.779177,-84.392196|33.774134,-84.39396': 573.9,
  '33.779177,-84.392196|33.77247,-84.391271': 672,
  '33.779177,-84.392196|33.779159,-84.403952': 1076.2,
  '33.779177,-84.392196|33.7742,-84.394637': 576.3,
  '33.779177,-84.392196|33.779564,-84.404718': 1118.4,
  '33.779177,-84.392196|33.778233,-84.404507': 1120.9,
  '33.779495,-84.405633|33.779836,-84.396666': 647.6,
  '33.779495,-84.405633|33.77561,-84.38906': 1312.4,
  '33.779495,-84.405633|33.780983,-84.404516': 236.6,
  '33.779495,-84.405633|33.773714,-84.394047': 1054.4,
  '33.779495,-84.405633|33.776532,-84.397307': 725.6,
  '33.779495,-84.405633|33.777062,-84.388997': 1228.2,
  '33.779495,-84.405633|33.774134,-84.39396': 1082.9,
  '33.779495,-84.405633|33.77247,-84.391271': 1424.9,
  '33.779495,-84.405633|33.779159,-84.403952': 162.3,
  '33.779495,-84.405633|33.7742,-84.394637': 1013.9,
  '33.779495,-84.405633|33.779564,-84.404718': 60.9,
  '33.779495,-84.405633|33.778233,-84.404507': 208.1,
  '33.773801,-84.395122|33.779836,-84.396666': 573.1,
  '33.773801,-84.395122|33.77561,-84.38906': 733,
  '33.773801,-84.395122|33.780983,-84.404516': 1055.2,
  '33.773801,-84.395122|33.773714,-84.394047': 73,
  '33.773801,-84.395122|33.776532,-84.397307': 350,
  '33.773801,-84.395122|33.777062,-84.388997': 663.5,
  '33.773801,-84.395122|33.774134,-84.39396': 108.7,
  '33.773801,-84.395122|33.77247,-84.391271': 447,
  '33.773801,-84.395122|33.779159,-84.403952': 882.5,
  '33.773801,-84.395122|33.7742,-84.394637': 40,
  '33.773801,-84.395122|33.779564,-84.404718': 948.8,
  '33.773801,-84.395122|33.778233,-84.404507': 883.3,
  '33.771658,-84.395302|33.779836,-84.396666': 702.8,
  '33.771658,-84.395302|33.77561,-84.38906': 798.2,
  '33.771658,-84.395302|33.780983,-84.404516': 1154.4,
  '33.771658,-84.395302|33.773714,-84.394047': 232.7,
  '33.771658,-84.395302|33.776532,-84.397307': 479.7,
  '33.771658,-84.395302|33.777062,-84.388997': 850.7,
  '33.771658,-84.395302|33.774134,-84.39396': 293.2,
  '33.771658,-84.395302|33.77247,-84.391271': 385.7,
  '33.771658,-84.395302|33.779159,-84.403952': 957.9,
  '33.771658,-84.395302|33.7742,-84.394637': 244.5,
  '33.771658,-84.395302|33.779564,-84.404718': 1048,
  '33.771658,-84.395302|33.778233,-84.404507': 958.7,
  '33.778759,-84.399597|33.779836,-84.396666': 270.9,
  '33.778759,-84.399597|33.77561,-84.38906': 924.7,
  '33.778759,-84.399597|33.780983,-84.404516': 482.9,
  '33.778759,-84.399597|33.773714,-84.394047': 744.7,
  '33.778759,-84.399597|33.776532,-84.397307': 379.1,
  '33.778759,-84.399597|33.777062,-84.388997': 837.1,
  '33.778759,-84.399597|33.774134,-84.39396': 768.4,
  '33.778759,-84.399597|33.77247,-84.391271': 1060.7,
  '33.778759,-84.399597|33.779159,-84.403952': 367.3,
  '33.778759,-84.399597|33.7742,-84.394637': 704.2,
  '33.778759,-84.399597|33.779564,-84.404718': 380.6,
  '33.778759,-84.399597|33.778233,-84.404507': 412,
  '33.779004,-84.395849|33.779836,-84.396666': 263.9,
  '33.779004,-84.395849|33.77561,-84.38906': 704.7,
  '33.779004,-84.395849|33.780983,-84.404516': 848.9,
  '33.779004,-84.395849|33.773714,-84.394047': 551,
  '33.779004,-84.395849|33.776532,-84.397307': 309,
  '33.779004,-84.395849|33.777062,-84.388997': 617.1,
  '33.779004,-84.395849|33.774134,-84.39396': 565.1,
  '33.779004,-84.395849|33.77247,-84.391271': 841.3,
  '33.779004,-84.395849|33.779159,-84.403952': 704.6,
  '33.779004,-84.395849|33.7742,-84.394637': 502.6,
  '33.779004,-84.395849|33.779564,-84.404718': 746.1,
  '33.779004,-84.395849|33.778233,-84.404507': 749.3,
  '33.777107,-84.395817|33.779836,-84.396666': 289.2,
  '33.777107,-84.395817|33.77561,-84.38906': 554.5,
  '33.777107,-84.395817|33.780983,-84.404516': 811,
  '33.777107,-84.395817|33.773714,-84.394047': 368.9,
  '33.777107,-84.395817|33.776532,-84.397307': 112,
  '33.777107,-84.395817|33.777062,-84.388997': 485,
  '33.777107,-84.395817|33.774134,-84.39396': 388,
  '33.777107,-84.395817|33.77247,-84.391271': 687.9,
  '33.777107,-84.395817|33.779159,-84.403952': 651.8,
  '33.777107,-84.395817|33.7742,-84.394637': 320.5,
  '33.777107,-84.395817|33.779564,-84.404718': 704.6,
  '33.777107,-84.395817|33.778233,-84.404507': 696.5,
  '33.778011,-84.397065|33.779836,-84.396666': 184.4,
  '33.778011,-84.397065|33.77561,-84.38906': 699.4,
  '33.778011,-84.397065|33.780983,-84.404516': 677.9,
  '33.778011,-84.397065|33.773714,-84.394047': 526.4,
  '33.778011,-84.397065|33.776532,-84.397307': 205.7,
  '33.778011,-84.397065|33.777062,-84.388997': 619.9,
  '33.778011,-84.397065|33.774134,-84.39396': 540.5,
  '33.778011,-84.397065|33.77247,-84.391271': 832.8,
  '33.778011,-84.397065|33.779159,-84.403952': 532.1,
  '33.778011,-84.397065|33.7742,-84.394637': 478,
  '33.778011,-84.397065|33.779564,-84.404718': 574.3,
  '33.778011,-84.397065|33.778233,-84.404507': 576.8,
  '33.778513,-84.396825|33.779836,-84.396666': 111.3,
  '33.778513,-84.396825|33.77561,-84.38906': 712.1,
  '33.778513,-84.396825|33.780983,-84.404516': 698.4,
  '33.778513,-84.396825|33.773714,-84.394047': 549.9,
  '33.778513,-84.396825|33.776532,-84.397307': 238.2,
  '33.778513,-84.396825|33.777062,-84.388997': 624.5,
  '33.778513,-84.396825|33.774134,-84.39396': 564,
  '33.778513,-84.396825|33.77247,-84.391271': 848.7,
  '33.778513,-84.396825|33.779159,-84.403952': 554.1,
  '33.778513,-84.396825|33.7742,-84.394637': 501.5,
  '33.778513,-84.396825|33.779564,-84.404718': 595.6,
  '33.778513,-84.396825|33.778233,-84.404507': 598.8,
  '33.775587,-84.401213|33.77258,-84.395624': 604.2,
  '33.775587,-84.401213|33.786914,-84.406213': 1208.5,
  '33.775587,-84.401213|33.775778,-84.401885': 38.5,
  '33.775587,-84.401213|33.775041,-84.399287': 225.9,
  '33.775587,-84.401213|33.773978,-84.404311': 453.9,
  '33.775587,-84.401213|33.772075,-84.395277': 607.7,
  '33.775587,-84.401213|33.775178,-84.401879': 137.6,
  '33.775587,-84.401213|33.775381,-84.391451': 772.5,
  '33.775587,-84.401213|33.77535159008218,-84.39513500282604': 496.3,
  '33.775587,-84.401213|33.7738,-84.397': 432.8,
  '33.775587,-84.401213|33.7766,-84.4048': 299.1,
  '33.775587,-84.401213|33.7756,-84.3963': 441.3,
  '33.779177,-84.392196|33.77258,-84.395624': 737.8,
  '33.779177,-84.392196|33.786914,-84.406213': 1701.1,
  '33.779177,-84.392196|33.775778,-84.401885': 910.5,
  '33.779177,-84.392196|33.775041,-84.399287': 804.7,
  '33.779177,-84.392196|33.773978,-84.404311': 1309.1,
  '33.779177,-84.392196|33.772075,-84.395277': 770,
  '33.779177,-84.392196|33.775178,-84.401879': 966.9,
  '33.779177,-84.392196|33.775381,-84.391451': 346.1,
  '33.779177,-84.392196|33.77535159008218,-84.39513500282604': 479,
  '33.779177,-84.392196|33.7738,-84.397': 706.1,
  '33.779177,-84.392196|33.7766,-84.4048': 1158.5,
  '33.779177,-84.392196|33.7756,-84.3963': 546.4,
  '33.779495,-84.405633|33.77258,-84.395624': 1054.6,
  '33.779495,-84.405633|33.786914,-84.406213': 874.3,
  '33.779495,-84.405633|33.775778,-84.401885': 599.4,
  '33.779495,-84.405633|33.775041,-84.399287': 697.6,
  '33.779495,-84.405633|33.773978,-84.404311': 890.7,
  '33.779495,-84.405633|33.772075,-84.395277': 1075.4,
  '33.779495,-84.405633|33.775178,-84.401879': 594.9,
  '33.779495,-84.405633|33.775381,-84.391451': 1140.7,
  '33.779495,-84.405633|33.77535159008218,-84.39513500282604': 919.9,
  '33.779495,-84.405633|33.7738,-84.397': 874.1,
  '33.779495,-84.405633|33.7766,-84.4048': 376.8,
  '33.779495,-84.405633|33.7756,-84.3963': 825,
  '33.773801,-84.395122|33.77258,-84.395624': 139.1,
  '33.773801,-84.395122|33.786914,-84.406213': 1576.5,
  '33.773801,-84.395122|33.775778,-84.401885': 572.7,
  '33.773801,-84.395122|33.775041,-84.399287': 397.1,
  '33.773801,-84.395122|33.773978,-84.404311': 830.1,
  '33.773801,-84.395122|33.772075,-84.395277': 171.3,
  '33.773801,-84.395122|33.775178,-84.401879': 559.3,
  '33.773801,-84.395122|33.775381,-84.391451': 367.8,
  '33.773801,-84.395122|33.77535159008218,-84.39513500282604': 194.8,
  '33.773801,-84.395122|33.7738,-84.397': 167.4,
  '33.773801,-84.395122|33.7766,-84.4048': 835.3,
  '33.773801,-84.395122|33.7756,-84.3963': 243.1,
  '33.771658,-84.395302|33.77258,-84.395624': 82.5,
  '33.771658,-84.395302|33.786914,-84.406213': 1675.7,
  '33.771658,-84.395302|33.775778,-84.401885': 645.5,
  '33.771658,-84.395302|33.775041,-84.399287': 469.9,
  '33.771658,-84.395302|33.773978,-84.404311': 787,
  '33.771658,-84.395302|33.772075,-84.395277': 33.5,
  '33.771658,-84.395302|33.775178,-84.401879': 632.1,
  '33.771658,-84.395302|33.775381,-84.391451': 547.8,
  '33.771658,-84.395302|33.77535159008218,-84.39513500282604': 324.5,
  '33.771658,-84.395302|33.7738,-84.397': 260.6,
  '33.771658,-84.395302|33.7766,-84.4048': 887.8,
  '33.771658,-84.395302|33.7756,-84.3963': 372.8,
  '33.778759,-84.399597|33.77258,-84.395624': 744.9,
  '33.778759,-84.399597|33.786914,-84.406213': 998.6,
  '33.778759,-84.399597|33.775778,-84.401885': 420.9,
  '33.778759,-84.399597|33.775041,-84.399287': 466.5,
  '33.778759,-84.399597|33.773978,-84.404311': 773.9,
  '33.778759,-84.399597|33.772075,-84.395277': 765.7,
  '33.778759,-84.399597|33.775178,-84.401879': 458.6,
  '33.778759,-84.399597|33.775381,-84.391451': 755.6,
  '33.778759,-84.399597|33.77535159008218,-84.39513500282604': 578.1,
  '33.778759,-84.399597|33.7738,-84.397': 564.4,
  '33.778759,-84.399597|33.7766,-84.4048': 485.5,
  '33.778759,-84.399597|33.7756,-84.3963': 478.5,
  '33.779004,-84.395849|33.77258,-84.395624': 571.8,
  '33.779004,-84.395849|33.786914,-84.406213': 1364.6,
  '33.779004,-84.395849|33.775778,-84.401885': 648.8,
  '33.779004,-84.395849|33.775041,-84.399287': 605.4,
  '33.779004,-84.395849|33.773978,-84.404311': 1068.4,
  '33.779004,-84.395849|33.772075,-84.395277': 604,
  '33.779004,-84.395849|33.775178,-84.401879': 752.1,
  '33.779004,-84.395849|33.775381,-84.391451': 536.2,
  '33.779004,-84.395849|33.77535159008218,-84.39513500282604': 374.8,
  '33.779004,-84.395849|33.7738,-84.397': 508.3,
  '33.779004,-84.395849|33.7766,-84.4048': 817.8,
  '33.779004,-84.395849|33.7756,-84.3963': 337.3,
  '33.777107,-84.395817|33.77258,-84.395624': 389.7,
  '33.777107,-84.395817|33.786914,-84.406213': 1332.3,
  '33.777107,-84.395817|33.775778,-84.401885': 472.7,
  '33.777107,-84.395817|33.775041,-84.399287': 395.8,
  '33.777107,-84.395817|33.773978,-84.404311': 892.3,
  '33.777107,-84.395817|33.772075,-84.395277': 421.9,
  '33.777107,-84.395817|33.775178,-84.401879': 558,
  '33.777107,-84.395817|33.775381,-84.391451': 382.8,
  '33.777107,-84.395817|33.77535159008218,-84.39513500282604': 192.7,
  '33.777107,-84.395817|33.7738,-84.397': 313.1,
  '33.777107,-84.395817|33.7766,-84.4048': 720.7,
  '33.777107,-84.395817|33.7756,-84.3963': 155.2,
  '33.778011,-84.397065|33.77258,-84.395624': 547.2,
  '33.778011,-84.397065|33.786914,-84.406213': 1194.4,
  '33.778011,-84.397065|33.775778,-84.401885': 467.7,
  '33.778011,-84.397065|33.775041,-84.399287': 447.2,
  '33.778011,-84.397065|33.773978,-84.404311': 887.3,
  '33.778011,-84.397065|33.772075,-84.395277': 579.4,
  '33.778011,-84.397065|33.775178,-84.401879': 571,
  '33.778011,-84.397065|33.775381,-84.391451': 527.7,
  '33.778011,-84.397065|33.77535159008218,-84.39513500282604': 350.2,
  '33.778011,-84.397065|33.7738,-84.397': 419.4,
  '33.778011,-84.397065|33.7766,-84.4048': 638.4,
  '33.778011,-84.397065|33.7756,-84.3963': 275,
  '33.778513,-84.396825|33.77258,-84.395624': 570.7,
  '33.778513,-84.396825|33.786914,-84.406213': 1214.1,
  '33.778513,-84.396825|33.775778,-84.401885': 501,
  '33.778513,-84.396825|33.775041,-84.399287': 480.5,
  '33.778513,-84.396825|33.773978,-84.404311': 920.6,
  '33.778513,-84.396825|33.772075,-84.395277': 602.9,
  '33.778513,-84.396825|33.775178,-84.401879': 604.3,
  '33.778513,-84.396825|33.775381,-84.391451': 543.6,
  '33.778513,-84.396825|33.77535159008218,-84.39513500282604': 373.7,
  '33.778513,-84.396825|33.7738,-84.397': 451.9,
  '33.778513,-84.396825|33.7766,-84.4048': 669.7,
  '33.778513,-84.396825|33.7756,-84.3963': 307.5,
  '33.775587,-84.401213|33.7805,-84.3921': 1013.2,
  '33.775587,-84.401213|33.7723,-84.3922': 868.2,
  '33.779177,-84.392196|33.7805,-84.3921': 394.7,
  '33.779177,-84.392196|33.7723,-84.3922': 572,
  '33.779495,-84.405633|33.7805,-84.3921': 1107.5,
  '33.779495,-84.405633|33.7723,-84.3922': 1309.5,
  '33.773801,-84.395122|33.7805,-84.3921': 737.9,
  '33.773801,-84.395122|33.7723,-84.3922': 331.5,
  '33.771658,-84.395302|33.7805,-84.3921': 925.1,
  '33.771658,-84.395302|33.7723,-84.3922': 309.4,
  '33.778759,-84.399597|33.7805,-84.3921': 730.8,
  '33.778759,-84.399597|33.7723,-84.3922': 949.6,
  '33.779004,-84.395849|33.7805,-84.3921': 623.4,
  '33.779004,-84.395849|33.7723,-84.3922': 730.2,
  '33.777107,-84.395817|33.7805,-84.3921': 559.4,
  '33.777107,-84.395817|33.7723,-84.3922': 576.8,
  '33.778011,-84.397065|33.7805,-84.3921': 655.7,
  '33.778011,-84.397065|33.7723,-84.3922': 721.7,
  '33.778513,-84.396825|33.7805,-84.3921': 582.6,
  '33.778513,-84.396825|33.7723,-84.3922': 737.6,
  '33.779836,-84.396666|33.773568,-84.395957': 570.1,
  '33.779836,-84.396666|33.774909,-84.396404': 407.4,
  '33.779836,-84.396666|33.776085,-84.400181': 503.3,
  '33.779836,-84.396666|33.776076,-84.396114': 343.6,
  '33.779836,-84.396666|33.776177,-84.395459': 325.8,
  '33.779836,-84.396666|33.776533,-84.387765': 777.7,
  '33.779836,-84.396666|33.771771,-84.395796': 708.9,
  '33.779836,-84.396666|33.776065,-84.397116': 324.9,
  '33.779836,-84.396666|33.775803,-84.398189': 405.4,
  '33.77561,-84.38906|33.773568,-84.395957': 787.5,
  '33.77561,-84.38906|33.774909,-84.396404': 711.9,
  '33.77561,-84.38906|33.776085,-84.400181': 913.3,
  '33.77561,-84.38906|33.776076,-84.396114': 657.6,
  '33.77561,-84.38906|33.776177,-84.395459': 581.9,
  '33.77561,-84.38906|33.776533,-84.387765': 181.2,
  '33.77561,-84.38906|33.771771,-84.395796': 831.2,
  '33.77561,-84.38906|33.776065,-84.397116': 670.2,
  '33.77561,-84.38906|33.775803,-84.398189': 800.9,
  '33.780983,-84.404516|33.773568,-84.395957': 1010,
  '33.780983,-84.404516|33.774909,-84.396404': 874.8,
  '33.780983,-84.404516|33.776085,-84.400181': 628.2,
  '33.780983,-84.404516|33.776076,-84.396114': 840.2,
  '33.780983,-84.404516|33.776177,-84.395459': 891.6,
  '33.780983,-84.404516|33.776533,-84.387765': 1354.3,
  '33.780983,-84.404516|33.771771,-84.395796': 1147.3,
  '33.780983,-84.404516|33.776065,-84.397116': 821.5,
  '33.780983,-84.404516|33.775803,-84.398189': 777.4,
  '33.773714,-84.394047|33.773568,-84.395957': 152.3,
  '33.773714,-84.394047|33.774909,-84.396404': 298.8,
  '33.773714,-84.394047|33.776085,-84.400181': 535.6,
  '33.773714,-84.394047|33.776076,-84.396114': 358.2,
  '33.773714,-84.394047|33.776177,-84.395459': 333.3,
  '33.773714,-84.394047|33.776533,-84.387765': 698.4,
  '33.773714,-84.394047|33.771771,-84.395796': 246.3,
  '33.773714,-84.394047|33.776065,-84.397116': 377.7,
  '33.773714,-84.394047|33.775803,-84.398189': 383.4,
  '33.776532,-84.397307|33.773568,-84.395957': 337.6,
  '33.776532,-84.397307|33.774909,-84.396404': 141.7,
  '33.776532,-84.397307|33.776085,-84.400181': 318.9,
  '33.776532,-84.397307|33.776076,-84.396114': 77.9,
  '33.776532,-84.397307|33.776177,-84.395459': 139.9,
  '33.776532,-84.397307|33.776533,-84.387765': 665.7,
  '33.776532,-84.397307|33.771771,-84.395796': 485.8,
  '33.776532,-84.397307|33.776065,-84.397116': 59.2,
  '33.776532,-84.397307|33.775803,-84.398189': 207.4,
  '33.777062,-84.388997|33.773568,-84.395957': 718,
  '33.777062,-84.388997|33.774909,-84.396404': 642.4,
  '33.777062,-84.388997|33.776085,-84.400181': 843.8,
  '33.777062,-84.388997|33.776076,-84.396114': 588.1,
  '33.777062,-84.388997|33.776177,-84.395459': 512.4,
  '33.777062,-84.388997|33.776533,-84.387765': 113.7,
  '33.777062,-84.388997|33.771771,-84.395796': 856.8,
  '33.777062,-84.388997|33.776065,-84.397116': 600.7,
  '33.777062,-84.388997|33.775803,-84.398189': 731.4,
  '33.774134,-84.39396|33.773568,-84.395957': 180.8,
  '33.774134,-84.39396|33.774909,-84.396404': 319.4,
  '33.774134,-84.39396|33.776085,-84.400181': 564.1,
  '33.774134,-84.39396|33.776076,-84.396114': 378.8,
  '33.774134,-84.39396|33.776177,-84.395459': 312.5,
  '33.774134,-84.39396|33.776533,-84.387765': 673,
  '33.774134,-84.39396|33.771771,-84.395796': 306.8,
  '33.774134,-84.39396|33.776065,-84.397116': 398.3,
  '33.774134,-84.39396|33.775803,-84.398189': 408.4,
  '33.77247,-84.391271|33.773568,-84.395957': 522.8,
  '33.77247,-84.391271|33.774909,-84.396404': 669,
  '33.77247,-84.391271|33.776085,-84.400181': 906.1,
  '33.77247,-84.391271|33.776076,-84.396114': 726.6,
  '33.77247,-84.391271|33.776177,-84.395459': 641.9,
  '33.77247,-84.391271|33.776533,-84.387765': 744.6,
  '33.77247,-84.391271|33.771771,-84.395796': 418.7,
  '33.77247,-84.391271|33.776065,-84.397116': 740.1,
  '33.77247,-84.391271|33.775803,-84.398189': 753.9,
  '33.779159,-84.403952|33.773568,-84.395957': 837.3,
  '33.779159,-84.403952|33.774909,-84.396404': 702.1,
  '33.779159,-84.403952|33.776085,-84.400181': 411.9,
  '33.779159,-84.403952|33.776076,-84.396114': 681,
  '33.779159,-84.403952|33.776177,-84.395459': 735.2,
  '33.779159,-84.403952|33.776533,-84.387765': 1205.5,
  '33.779159,-84.403952|33.771771,-84.395796': 950.8,
  '33.779159,-84.403952|33.776065,-84.397116': 662.3,
  '33.779159,-84.403952|33.775803,-84.398189': 607.8,
  '33.7742,-84.394637|33.773568,-84.395957': 111.8,
  '33.7742,-84.394637|33.774909,-84.396404': 250.4,
  '33.7742,-84.394637|33.776085,-84.400181': 495.1,
  '33.7742,-84.394637|33.776076,-84.396114': 309.8,
  '33.7742,-84.394637|33.776177,-84.395459': 294.7,
  '33.7742,-84.394637|33.776533,-84.387765': 692.2,
  '33.7742,-84.394637|33.771771,-84.395796': 250.6,
  '33.7742,-84.394637|33.776065,-84.397116': 329.3,
  '33.7742,-84.394637|33.775803,-84.398189': 339.4,
  '33.779564,-84.404718|33.773568,-84.395957': 903.6,
  '33.779564,-84.404718|33.774909,-84.396404': 768.4,
  '33.779564,-84.404718|33.776085,-84.400181': 506,
  '33.779564,-84.404718|33.776076,-84.396114': 733.8,
  '33.779564,-84.404718|33.776177,-84.395459': 788,
  '33.779564,-84.404718|33.776533,-84.387765': 1250.7,
  '33.779564,-84.404718|33.771771,-84.395796': 1040.9,
  '33.779564,-84.404718|33.776065,-84.397116': 715.1,
  '33.779564,-84.404718|33.775803,-84.398189': 671,
  '33.778233,-84.404507|33.773568,-84.395957': 838.1,
  '33.778233,-84.404507|33.774909,-84.396404': 702.9,
  '33.778233,-84.404507|33.776085,-84.400181': 412.7,
  '33.778233,-84.404507|33.776076,-84.396114': 725.7,
  '33.778233,-84.404507|33.776177,-84.395459': 779.9,
  '33.778233,-84.404507|33.776533,-84.387765': 1250.2,
  '33.778233,-84.404507|33.771771,-84.395796': 951.6,
  '33.778233,-84.404507|33.776065,-84.397116': 707,
  '33.778233,-84.404507|33.775803,-84.398189': 608.6,
  '33.779836,-84.396666|33.777576,-84.397352': 230.1,
  '33.779836,-84.396666|33.772949,-84.396066': 633.6,
  '33.779836,-84.396666|33.772114,-84.395289': 666.1,
  '33.779836,-84.396666|33.776764,-84.39844': 342,
  '33.779836,-84.396666|33.77672,-84.401764': 592.9,
  '33.779836,-84.396666|33.777187,-84.400484': 464,
  '33.779836,-84.396666|33.77622,-84.397959': 348.5,
  '33.779836,-84.396666|33.777622,-84.398785': 295.3,
  '33.77561,-84.38906|33.777576,-84.397352': 719,
  '33.77561,-84.38906|33.772949,-84.396066': 859.5,
  '33.77561,-84.38906|33.772114,-84.395289': 834.9,
  '33.77561,-84.38906|33.776764,-84.39844': 752,
  '33.77561,-84.38906|33.77672,-84.401764': 1097.5,
  '33.77561,-84.38906|33.777187,-84.400484': 914.2,
  '33.77561,-84.38906|33.77622,-84.397959': 756.5,
  '33.77561,-84.38906|33.777622,-84.398785': 814.7,
  '33.780983,-84.404516|33.777576,-84.397352': 685.9,
  '33.780983,-84.404516|33.772949,-84.396066': 1012.1,
  '33.780983,-84.404516|33.772114,-84.395289': 1117.7,
  '33.780983,-84.404516|33.776764,-84.39844': 662,
  '33.780983,-84.404516|33.77672,-84.401764': 576.2,
  '33.780983,-84.404516|33.777187,-84.400484': 509.7,
  '33.780983,-84.404516|33.77622,-84.397959': 720.5,
  '33.780983,-84.404516|33.777622,-84.398785': 585.8,
  '33.773714,-84.394047|33.777576,-84.397352': 515.8,
  '33.773714,-84.394047|33.772949,-84.396066': 217.1,
  '33.773714,-84.394047|33.772114,-84.395289': 196.3,
  '33.773714,-84.394047|33.776764,-84.39844': 499.2,
  '33.773714,-84.394047|33.77672,-84.401764': 702.3,
  '33.773714,-84.394047|33.777187,-84.400484': 623.6,
  '33.773714,-84.394047|33.77622,-84.397959': 418.5,
  '33.773714,-84.394047|33.777622,-84.398785': 597.5,
  '33.776532,-84.397307|33.777576,-84.397352': 168.7,
  '33.776532,-84.397307|33.772949,-84.396066': 367.9,
  '33.776532,-84.397307|33.772114,-84.395289': 443,
  '33.776532,-84.397307|33.776764,-84.39844': 157.6,
  '33.776532,-84.397307|33.77672,-84.401764': 503.1,
  '33.776532,-84.397307|33.777187,-84.400484': 319.8,
  '33.776532,-84.397307|33.77622,-84.397959': 162.1,
  '33.776532,-84.397307|33.777622,-84.398785': 220.3,
  '33.777062,-84.388997|33.777576,-84.397352': 639.5,
  '33.777062,-84.388997|33.772949,-84.396066': 790,
  '33.777062,-84.388997|33.772114,-84.395289': 814,
  '33.777062,-84.388997|33.776764,-84.39844': 682.5,
  '33.777062,-84.388997|33.77672,-84.401764': 1028,
  '33.777062,-84.388997|33.777187,-84.400484': 844.7,
  '33.777062,-84.388997|33.77622,-84.397959': 687,
  '33.777062,-84.388997|33.777622,-84.398785': 740.7,
  '33.774134,-84.39396|33.777576,-84.397352': 536.4,
  '33.774134,-84.39396|33.772949,-84.396066': 252.8,
  '33.774134,-84.39396|33.772114,-84.395289': 256.8,
  '33.774134,-84.39396|33.776764,-84.39844': 524.2,
  '33.774134,-84.39396|33.77672,-84.401764': 730.8,
  '33.774134,-84.39396|33.777187,-84.400484': 652.1,
  '33.774134,-84.39396|33.77622,-84.397959': 443.5,
  '33.774134,-84.39396|33.777622,-84.398785': 618.1,
  '33.77247,-84.391271|33.777576,-84.397352': 852.4,
  '33.77247,-84.391271|33.772949,-84.396066': 502.6,
  '33.77247,-84.391271|33.772114,-84.395289': 422.4,
  '33.77247,-84.391271|33.776764,-84.39844': 869.7,
  '33.77247,-84.391271|33.77672,-84.401764': 1072.8,
  '33.77247,-84.391271|33.777187,-84.400484': 994.1,
  '33.77247,-84.391271|33.77622,-84.397959': 789,
  '33.77247,-84.391271|33.777622,-84.398785': 948.1,
  '33.779159,-84.403952|33.777576,-84.397352': 540.1,
  '33.779159,-84.403952|33.772949,-84.396066': 839.4,
  '33.779159,-84.403952|33.772114,-84.395289': 921.2,
  '33.779159,-84.403952|33.776764,-84.39844': 502.8,
  '33.779159,-84.403952|33.77672,-84.401764': 324.2,
  '33.779159,-84.403952|33.777187,-84.400484': 350.5,
  '33.779159,-84.403952|33.77622,-84.397959': 550.9,
  '33.779159,-84.403952|33.777622,-84.398785': 440,
  '33.7742,-84.394637|33.777576,-84.397352': 467.4,
  '33.7742,-84.394637|33.772949,-84.396066': 183.8,
  '33.7742,-84.394637|33.772114,-84.395289': 207.8,
  '33.7742,-84.394637|33.776764,-84.39844': 455.2,
  '33.7742,-84.394637|33.77672,-84.401764': 661.8,
  '33.7742,-84.394637|33.777187,-84.400484': 583.1,
  '33.7742,-84.394637|33.77622,-84.397959': 374.5,
  '33.7742,-84.394637|33.777622,-84.398785': 549.1,
  '33.779564,-84.404718|33.777576,-84.397352': 582.3,
  '33.779564,-84.404718|33.772949,-84.396066': 905.7,
  '33.779564,-84.404718|33.772114,-84.395289': 1011.3,
  '33.779564,-84.404718|33.776764,-84.39844': 555.6,
  '33.779564,-84.404718|33.77672,-84.401764': 418.3,
  '33.779564,-84.404718|33.777187,-84.400484': 403.3,
  '33.779564,-84.404718|33.77622,-84.397959': 614.1,
  '33.779564,-84.404718|33.777622,-84.398785': 482.2,
  '33.778233,-84.404507|33.777576,-84.397352': 584.8,
  '33.778233,-84.404507|33.772949,-84.396066': 840.2,
  '33.778233,-84.404507|33.772114,-84.395289': 922,
  '33.778233,-84.404507|33.776764,-84.39844': 547.5,
  '33.778233,-84.404507|33.77672,-84.401764': 290.1,
  '33.778233,-84.404507|33.777187,-84.400484': 395.2,
  '33.778233,-84.404507|33.77622,-84.397959': 551.7,
  '33.778233,-84.404507|33.777622,-84.398785': 484.7,
  '33.779836,-84.396666|33.775587,-84.401213': 582.7,
  '33.779836,-84.396666|33.779177,-84.392196': 564,
  '33.779836,-84.396666|33.779495,-84.405633': 647.6,
  '33.779836,-84.396666|33.773801,-84.395122': 573.1,
  '33.779836,-84.396666|33.771658,-84.395302': 702.8,
  '33.779836,-84.396666|33.778759,-84.399597': 270.9,
  '33.779836,-84.396666|33.779004,-84.395849': 263.9,
  '33.779836,-84.396666|33.777107,-84.395817': 289.2,
  '33.779836,-84.396666|33.778011,-84.397065': 184.4,
  '33.779836,-84.396666|33.778513,-84.396825': 111.3,
  '33.77561,-84.38906|33.775587,-84.401213': 1008.3,
  '33.77561,-84.38906|33.779177,-84.392196': 503.5,
  '33.77561,-84.38906|33.779495,-84.405633': 1312.4,
  '33.77561,-84.38906|33.773801,-84.395122': 733,
  '33.77561,-84.38906|33.771658,-84.395302': 798.2,
  '33.77561,-84.38906|33.778759,-84.399597': 924.7,
  '33.77561,-84.38906|33.779004,-84.395849': 704.7,
  '33.77561,-84.38906|33.777107,-84.395817': 554.5,
  '33.77561,-84.38906|33.778011,-84.397065': 699.4,
  '33.77561,-84.38906|33.778513,-84.396825': 712.1,
  '33.780983,-84.404516|33.775587,-84.401213': 677.5,
  '33.780983,-84.404516|33.779177,-84.392196': 1200.6,
  '33.780983,-84.404516|33.779495,-84.405633': 236.6,
  '33.780983,-84.404516|33.773801,-84.395122': 1055.2,
  '33.780983,-84.404516|33.771658,-84.395302': 1154.4,
  '33.780983,-84.404516|33.778759,-84.399597': 482.9,
  '33.780983,-84.404516|33.779004,-84.395849': 848.9,
  '33.780983,-84.404516|33.777107,-84.395817': 811,
  '33.780983,-84.404516|33.778011,-84.397065': 677.9,
  '33.780983,-84.404516|33.778513,-84.396825': 698.4,
  '33.773714,-84.394047|33.775587,-84.401213': 613.1,
  '33.773714,-84.394047|33.779177,-84.392196': 598.7,
  '33.773714,-84.394047|33.779495,-84.405633': 1054.4,
  '33.773714,-84.394047|33.773801,-84.395122': 73,
  '33.773714,-84.394047|33.771658,-84.395302': 232.7,
  '33.773714,-84.394047|33.778759,-84.399597': 744.7,
  '33.773714,-84.394047|33.779004,-84.395849': 551,
  '33.773714,-84.394047|33.777107,-84.395817': 368.9,
  '33.773714,-84.394047|33.778011,-84.397065': 526.4,
  '33.773714,-84.394047|33.778513,-84.396825': 549.9,
  '33.776532,-84.397307|33.775587,-84.401213': 413.9,
  '33.776532,-84.397307|33.779177,-84.392196': 549.8,
  '33.776532,-84.397307|33.779495,-84.405633': 725.6,
  '33.776532,-84.397307|33.773801,-84.395122': 350,
  '33.776532,-84.397307|33.771658,-84.395302': 479.7,
  '33.776532,-84.397307|33.778759,-84.399597': 379.1,
  '33.776532,-84.397307|33.779004,-84.395849': 309,
  '33.776532,-84.397307|33.777107,-84.395817': 112,
  '33.776532,-84.397307|33.778011,-84.397065': 205.7,
  '33.776532,-84.397307|33.778513,-84.396825': 238.2,
  '33.777062,-84.388997|33.775587,-84.401213': 938.8,
  '33.777062,-84.388997|33.779177,-84.392196': 415.9,
  '33.777062,-84.388997|33.779495,-84.405633': 1228.2,
  '33.777062,-84.388997|33.773801,-84.395122': 663.5,
  '33.777062,-84.388997|33.771658,-84.395302': 850.7,
  '33.777062,-84.388997|33.778759,-84.399597': 837.1,
  '33.777062,-84.388997|33.779004,-84.395849': 617.1,
  '33.777062,-84.388997|33.777107,-84.395817': 485,
  '33.777062,-84.388997|33.778011,-84.397065': 619.9,
  '33.777062,-84.388997|33.778513,-84.396825': 624.5,
  '33.774134,-84.39396|33.775587,-84.401213': 641.6,
  '33.774134,-84.39396|33.779177,-84.392196': 573.9,
  '33.774134,-84.39396|33.779495,-84.405633': 1082.9,
  '33.774134,-84.39396|33.773801,-84.395122': 108.7,
  '33.774134,-84.39396|33.771658,-84.395302': 293.2,
  '33.774134,-84.39396|33.778759,-84.399597': 768.4,
  '33.774134,-84.39396|33.779004,-84.395849': 565.1,
  '33.774134,-84.39396|33.777107,-84.395817': 388,
  '33.774134,-84.39396|33.778011,-84.397065': 540.5,
  '33.774134,-84.39396|33.778513,-84.396825': 564,
  '33.77247,-84.391271|33.775587,-84.401213': 983.6,
  '33.77247,-84.391271|33.779177,-84.392196': 672,
  '33.77247,-84.391271|33.779495,-84.405633': 1424.9,
  '33.77247,-84.391271|33.773801,-84.395122': 447,
  '33.77247,-84.391271|33.771658,-84.395302': 385.7,
  '33.77247,-84.391271|33.778759,-84.399597': 1060.7,
  '33.77247,-84.391271|33.779004,-84.395849': 841.3,
  '33.77247,-84.391271|33.777107,-84.395817': 687.9,
  '33.77247,-84.391271|33.778011,-84.397065': 832.8,
  '33.77247,-84.391271|33.778513,-84.396825': 848.7,
  '33.779159,-84.403952|33.775587,-84.401213': 425.5,
  '33.779159,-84.403952|33.779177,-84.392196': 1076.2,
  '33.779159,-84.403952|33.779495,-84.405633': 162.3,
  '33.779159,-84.403952|33.773801,-84.395122': 882.5,
  '33.779159,-84.403952|33.771658,-84.395302': 957.9,
  '33.779159,-84.403952|33.778759,-84.399597': 367.3,
  '33.779159,-84.403952|33.779004,-84.395849': 704.6,
  '33.779159,-84.403952|33.777107,-84.395817': 651.8,
  '33.779159,-84.403952|33.778011,-84.397065': 532.1,
  '33.779159,-84.403952|33.778513,-84.396825': 554.1,
  '33.7742,-84.394637|33.775587,-84.401213': 572.6,
  '33.7742,-84.394637|33.779177,-84.392196': 576.3,
  '33.7742,-84.394637|33.779495,-84.405633': 1013.9,
  '33.7742,-84.394637|33.773801,-84.395122': 40,
  '33.7742,-84.394637|33.771658,-84.395302': 244.5,
  '33.7742,-84.394637|33.778759,-84.399597': 704.2,
  '33.7742,-84.394637|33.779004,-84.395849': 502.6,
  '33.7742,-84.394637|33.777107,-84.395817': 320.5,
  '33.7742,-84.394637|33.778011,-84.397065': 478,
  '33.7742,-84.394637|33.778513,-84.396825': 501.5,
  '33.779564,-84.404718|33.775587,-84.401213': 519.6,
  '33.779564,-84.404718|33.779177,-84.392196': 1118.4,
  '33.779564,-84.404718|33.779495,-84.405633': 60.9,
  '33.779564,-84.404718|33.773801,-84.395122': 948.8,
  '33.779564,-84.404718|33.771658,-84.395302': 1048,
  '33.779564,-84.404718|33.778759,-84.399597': 380.6,
  '33.779564,-84.404718|33.779004,-84.395849': 746.1,
  '33.779564,-84.404718|33.777107,-84.395817': 704.6,
  '33.779564,-84.404718|33.778011,-84.397065': 574.3,
  '33.779564,-84.404718|33.778513,-84.396825': 595.6,
  '33.778233,-84.404507|33.775587,-84.401213': 393.3,
  '33.778233,-84.404507|33.779177,-84.392196': 1120.9,
  '33.778233,-84.404507|33.779495,-84.405633': 208.1,
  '33.778233,-84.404507|33.773801,-84.395122': 883.3,
  '33.778233,-84.404507|33.771658,-84.395302': 958.7,
  '33.778233,-84.404507|33.778759,-84.399597': 412,
  '33.778233,-84.404507|33.779004,-84.395849': 749.3,
  '33.778233,-84.404507|33.777107,-84.395817': 696.5,
  '33.778233,-84.404507|33.778011,-84.397065': 576.8,
  '33.778233,-84.404507|33.778513,-84.396825': 598.8,
  '33.779836,-84.396666|33.779836,-84.396666': 0,
  '33.779836,-84.396666|33.77561,-84.38906': 778.5,
  '33.779836,-84.396666|33.780983,-84.404516': 683.3,
  '33.779836,-84.396666|33.773714,-84.394047': 616.3,
  '33.779836,-84.396666|33.776532,-84.397307': 304.6,
  '33.779836,-84.396666|33.777062,-84.388997': 690.9,
  '33.779836,-84.396666|33.774134,-84.39396': 630.4,
  '33.779836,-84.396666|33.77247,-84.391271': 915.1,
  '33.779836,-84.396666|33.779159,-84.403952': 592.1,
  '33.779836,-84.396666|33.7742,-84.394637': 567.9,
  '33.779836,-84.396666|33.779564,-84.404718': 586.7,
  '33.779836,-84.396666|33.778233,-84.404507': 658.8,
  '33.77561,-84.38906|33.779836,-84.396666': 778.5,
  '33.77561,-84.38906|33.77561,-84.38906': 0,
  '33.77561,-84.38906|33.780983,-84.404516': 1355.1,
  '33.77561,-84.38906|33.773714,-84.394047': 699.2,
  '33.77561,-84.38906|33.776532,-84.397307': 666.5,
  '33.77561,-84.38906|33.777062,-84.388997': 116.2,
  '33.77561,-84.38906|33.774134,-84.39396': 673.8,
  '33.77561,-84.38906|33.77247,-84.391271': 569.3,
  '33.77561,-84.38906|33.779159,-84.403952': 1206.3,
  '33.77561,-84.38906|33.7742,-84.394637': 693,
  '33.77561,-84.38906|33.779564,-84.404718': 1251.5,
  '33.77561,-84.38906|33.778233,-84.404507': 1251,
  '33.780983,-84.404516|33.779836,-84.396666': 683.3,
  '33.780983,-84.404516|33.77561,-84.38906': 1355.1,
  '33.780983,-84.404516|33.780983,-84.404516': 0,
  '33.780983,-84.404516|33.773714,-84.394047': 1099.9,
  '33.780983,-84.404516|33.776532,-84.397307': 771.1,
  '33.780983,-84.404516|33.777062,-84.388997': 1270.9,
  '33.780983,-84.404516|33.774134,-84.39396': 1128.4,
  '33.780983,-84.404516|33.77247,-84.391271': 1470.4,
  '33.780983,-84.404516|33.779159,-84.403952': 283.8,
  '33.780983,-84.404516|33.7742,-84.394637': 1059.4,
  '33.780983,-84.404516|33.779564,-84.404718': 258.8,
  '33.780983,-84.404516|33.778233,-84.404507': 340.8,
  '33.773714,-84.394047|33.779836,-84.396666': 616.3,
  '33.773714,-84.394047|33.77561,-84.38906': 699.2,
  '33.773714,-84.394047|33.780983,-84.404516': 1099.9,
  '33.773714,-84.394047|33.773714,-84.394047': 0,
  '33.773714,-84.394047|33.776532,-84.397307': 393.2,
  '33.773714,-84.394047|33.777062,-84.388997': 632.4,
  '33.773714,-84.394047|33.774134,-84.39396': 60.5,
  '33.773714,-84.394047|33.77247,-84.391271': 398.8,
  '33.773714,-84.394047|33.779159,-84.403952': 927.2,
  '33.773714,-84.394047|33.7742,-84.394637': 83,
  '33.773714,-84.394047|33.779564,-84.404718': 993.5,
  '33.773714,-84.394047|33.778233,-84.404507': 928,
  '33.776532,-84.397307|33.779836,-84.396666': 304.6,
  '33.776532,-84.397307|33.77561,-84.38906': 666.5,
  '33.776532,-84.397307|33.780983,-84.404516': 771.1,
  '33.776532,-84.397307|33.773714,-84.394047': 393.2,
  '33.776532,-84.397307|33.776532,-84.397307': 0,
  '33.776532,-84.397307|33.777062,-84.388997': 597,
  '33.776532,-84.397307|33.774134,-84.39396': 413.8,
  '33.776532,-84.397307|33.77247,-84.391271': 748.3,
  '33.776532,-84.397307|33.779159,-84.403952': 611.9,
  '33.776532,-84.397307|33.7742,-84.394637': 344.8,
  '33.776532,-84.397307|33.779564,-84.404718': 664.7,
  '33.776532,-84.397307|33.778233,-84.404507': 656.6,
  '33.777062,-84.388997|33.779836,-84.396666': 690.9,
  '33.777062,-84.388997|33.77561,-84.38906': 116.2,
  '33.777062,-84.388997|33.780983,-84.404516': 1270.9,
  '33.777062,-84.388997|33.773714,-84.394047': 632.4,
  '33.777062,-84.388997|33.776532,-84.397307': 597,
  '33.777062,-84.388997|33.777062,-84.388997': 0,
  '33.777062,-84.388997|33.774134,-84.39396': 607,
  '33.777062,-84.388997|33.77247,-84.391271': 685.5,
  '33.777062,-84.388997|33.779159,-84.403952': 1125.1,
  '33.777062,-84.388997|33.7742,-84.394637': 623.5,
  '33.777062,-84.388997|33.779564,-84.404718': 1167.3,
  '33.777062,-84.388997|33.778233,-84.404507': 1169.8,
  '33.774134,-84.39396|33.779836,-84.396666': 630.4,
  '33.774134,-84.39396|33.77561,-84.38906': 673.8,
  '33.774134,-84.39396|33.780983,-84.404516': 1128.4,
  '33.774134,-84.39396|33.773714,-84.394047': 60.5,
  '33.774134,-84.39396|33.776532,-84.397307': 413.8,
  '33.774134,-84.39396|33.777062,-84.388997': 607,
  '33.774134,-84.39396|33.774134,-84.39396': 0,
  '33.774134,-84.39396|33.77247,-84.391271': 383.6,
  '33.774134,-84.39396|33.779159,-84.403952': 955.7,
  '33.774134,-84.39396|33.7742,-84.394637': 103.6,
  '33.774134,-84.39396|33.779564,-84.404718': 1022,
  '33.774134,-84.39396|33.778233,-84.404507': 956.5,
  '33.77247,-84.391271|33.779836,-84.396666': 915.1,
  '33.77247,-84.391271|33.77561,-84.38906': 569.3,
  '33.77247,-84.391271|33.780983,-84.404516': 1470.4,
  '33.77247,-84.391271|33.773714,-84.394047': 398.8,
  '33.77247,-84.391271|33.776532,-84.397307': 748.3,
  '33.77247,-84.391271|33.777062,-84.388997': 685.5,
  '33.77247,-84.391271|33.774134,-84.39396': 383.6,
  '33.77247,-84.391271|33.77247,-84.391271': 0,
  '33.77247,-84.391271|33.779159,-84.403952': 1297.7,
  '33.77247,-84.391271|33.7742,-84.394637': 453.2,
  '33.77247,-84.391271|33.779564,-84.404718': 1364,
  '33.77247,-84.391271|33.778233,-84.404507': 1298.5,
  '33.779159,-84.403952|33.779836,-84.396666': 592.1,
  '33.779159,-84.403952|33.77561,-84.38906': 1206.3,
  '33.779159,-84.403952|33.780983,-84.404516': 283.8,
  '33.779159,-84.403952|33.773714,-84.394047': 927.2,
  '33.779159,-84.403952|33.776532,-84.397307': 611.9,
  '33.779159,-84.403952|33.777062,-84.388997': 1125.1,
  '33.779159,-84.403952|33.774134,-84.39396': 955.7,
  '33.779159,-84.403952|33.77247,-84.391271': 1297.7,
  '33.779159,-84.403952|33.779159,-84.403952': 0,
  '33.779159,-84.403952|33.7742,-84.394637': 886.7,
  '33.779159,-84.403952|33.779564,-84.404718': 101.4,
  '33.779159,-84.403952|33.778233,-84.404507': 113.7,
  '33.7742,-84.394637|33.779836,-84.396666': 567.9,
  '33.7742,-84.394637|33.77561,-84.38906': 693,
  '33.7742,-84.394637|33.780983,-84.404516': 1059.4,
  '33.7742,-84.394637|33.773714,-84.394047': 83,
  '33.7742,-84.394637|33.776532,-84.397307': 344.8,
  '33.7742,-84.394637|33.777062,-84.388997': 623.5,
  '33.7742,-84.394637|33.774134,-84.39396': 103.6,
  '33.7742,-84.394637|33.77247,-84.391271': 453.2,
  '33.7742,-84.394637|33.779159,-84.403952': 886.7,
  '33.7742,-84.394637|33.7742,-84.394637': 0,
  '33.7742,-84.394637|33.779564,-84.404718': 953,
  '33.7742,-84.394637|33.778233,-84.404507': 887.5,
  '33.779564,-84.404718|33.779836,-84.396666': 586.7,
  '33.779564,-84.404718|33.77561,-84.38906': 1251.5,
  '33.779564,-84.404718|33.780983,-84.404516': 258.8,
  '33.779564,-84.404718|33.773714,-84.394047': 993.5,
  '33.779564,-84.404718|33.776532,-84.397307': 664.7,
  '33.779564,-84.404718|33.777062,-84.388997': 1167.3,
  '33.779564,-84.404718|33.774134,-84.39396': 1022,
  '33.779564,-84.404718|33.77247,-84.391271': 1364,
  '33.779564,-84.404718|33.779159,-84.403952': 101.4,
  '33.779564,-84.404718|33.7742,-84.394637': 953,
  '33.779564,-84.404718|33.779564,-84.404718': 0,
  '33.779564,-84.404718|33.778233,-84.404507': 147.2,
  '33.778233,-84.404507|33.779836,-84.396666': 658.8,
  '33.778233,-84.404507|33.77561,-84.38906': 1251,
  '33.778233,-84.404507|33.780983,-84.404516': 340.8,
  '33.778233,-84.404507|33.773714,-84.394047': 928,
  '33.778233,-84.404507|33.776532,-84.397307': 656.6,
  '33.778233,-84.404507|33.777062,-84.388997': 1169.8,
  '33.778233,-84.404507|33.774134,-84.39396': 956.5,
  '33.778233,-84.404507|33.77247,-84.391271': 1298.5,
  '33.778233,-84.404507|33.779159,-84.403952': 113.7,
  '33.778233,-84.404507|33.7742,-84.394637': 887.5,
  '33.778233,-84.404507|33.779564,-84.404718': 147.2,
  '33.778233,-84.404507|33.778233,-84.404507': 0,
  '33.779836,-84.396666|33.77258,-84.395624': 637.1,
  '33.779836,-84.396666|33.786914,-84.406213': 1198,
  '33.779836,-84.396666|33.775778,-84.401885': 601.6,
  '33.779836,-84.396666|33.775041,-84.399287': 581.1,
  '33.779836,-84.396666|33.773978,-84.404311': 1020.7,
  '33.779836,-84.396666|33.772075,-84.395277': 669.3,
  '33.779836,-84.396666|33.775178,-84.401879': 704.9,
  '33.779836,-84.396666|33.775381,-84.391451': 610,
  '33.779836,-84.396666|33.77535159008218,-84.39513500282604': 440.1,
  '33.779836,-84.396666|33.7738,-84.397': 518.3,
  '33.779836,-84.396666|33.7766,-84.4048': 732.3,
  '33.779836,-84.396666|33.7756,-84.3963': 373.9,
  '33.77561,-84.38906|33.77258,-84.395624': 846.4,
  '33.77561,-84.38906|33.786914,-84.406213': 1871.6,
  '33.77561,-84.38906|33.775778,-84.401885': 1027.2,
  '33.77561,-84.38906|33.775041,-84.399287': 921.4,
  '33.77561,-84.38906|33.773978,-84.404311': 1425.8,
  '33.77561,-84.38906|33.772075,-84.395277': 831.7,
  '33.77561,-84.38906|33.775178,-84.401879': 1083.6,
  '33.77561,-84.38906|33.775381,-84.391451': 437.4,
  '33.77561,-84.38906|33.77535159008218,-84.39513500282604': 595.7,
  '33.77561,-84.38906|33.7738,-84.397': 822.8,
  '33.77561,-84.38906|33.7766,-84.4048': 1275.2,
  '33.77561,-84.38906|33.7756,-84.3963': 663.1,
  '33.780983,-84.404516|33.77258,-84.395624': 1100.1,
  '33.780983,-84.404516|33.786914,-84.406213': 661.8,
  '33.780983,-84.404516|33.775778,-84.401885': 696.4,
  '33.780983,-84.404516|33.775041,-84.399287': 794.6,
  '33.780983,-84.404516|33.773978,-84.404311': 1003.5,
  '33.780983,-84.404516|33.772075,-84.395277': 1120.9,
  '33.780983,-84.404516|33.775178,-84.401879': 691.9,
  '33.780983,-84.404516|33.775381,-84.391451': 1183.4,
  '33.780983,-84.404516|33.77535159008218,-84.39513500282604': 965.4,
  '33.780983,-84.404516|33.7738,-84.397': 919.6,
  '33.780983,-84.404516|33.7766,-84.4048': 536.4,
  '33.780983,-84.404516|33.7756,-84.3963': 870.5,
  '33.773714,-84.394047|33.77258,-84.395624': 198.5,
  '33.773714,-84.394047|33.786914,-84.406213': 1621.2,
  '33.773714,-84.394047|33.775778,-84.401885': 617.4,
  '33.773714,-84.394047|33.775041,-84.399287': 441.8,
  '33.773714,-84.394047|33.773978,-84.404311': 892.8,
  '33.773714,-84.394047|33.772075,-84.395277': 199.5,
  '33.773714,-84.394047|33.775178,-84.401879': 604,
  '33.773714,-84.394047|33.775381,-84.391451': 319.6,
  '33.773714,-84.394047|33.77535159008218,-84.39513500282604': 202.7,
  '33.773714,-84.394047|33.7738,-84.397': 212.1,
  '33.773714,-84.394047|33.7766,-84.4048': 880,
  '33.773714,-84.394047|33.7756,-84.3963': 286.3,
  '33.776532,-84.397307|33.77258,-84.395624': 414,
  '33.776532,-84.397307|33.786914,-84.406213': 1292.4,
  '33.776532,-84.397307|33.775778,-84.401885': 432.8,
  '33.776532,-84.397307|33.775041,-84.399287': 335.3,
  '33.776532,-84.397307|33.773978,-84.404311': 839.7,
  '33.776532,-84.397307|33.772075,-84.395277': 446.2,
  '33.776532,-84.397307|33.775178,-84.401879': 497.5,
  '33.776532,-84.397307|33.775381,-84.391451': 443.2,
  '33.776532,-84.397307|33.77535159008218,-84.39513500282604': 217,
  '33.776532,-84.397307|33.7738,-84.397': 252.6,
  '33.776532,-84.397307|33.7766,-84.4048': 680.8,
  '33.776532,-84.397307|33.7756,-84.3963': 108.2,
  '33.777062,-84.388997|33.77258,-84.395624': 785,
  '33.777062,-84.388997|33.786914,-84.406213': 1786.7,
  '33.777062,-84.388997|33.775778,-84.401885': 957.7,
  '33.777062,-84.388997|33.775041,-84.399287': 851.9,
  '33.777062,-84.388997|33.773978,-84.404311': 1356.3,
  '33.777062,-84.388997|33.772075,-84.395277': 817.2,
  '33.777062,-84.388997|33.775178,-84.401879': 1014.1,
  '33.777062,-84.388997|33.775381,-84.391451': 370.6,
  '33.777062,-84.388997|33.77535159008218,-84.39513500282604': 526.2,
  '33.777062,-84.388997|33.7738,-84.397': 753.3,
  '33.777062,-84.388997|33.7766,-84.4048': 1205.7,
  '33.777062,-84.388997|33.7756,-84.3963': 593.6,
  '33.774134,-84.39396|33.77258,-84.395624': 247.8,
  '33.774134,-84.39396|33.786914,-84.406213': 1649.7,
  '33.774134,-84.39396|33.775778,-84.401885': 645.9,
  '33.774134,-84.39396|33.775041,-84.399287': 470.3,
  '33.774134,-84.39396|33.773978,-84.404311': 921.3,
  '33.774134,-84.39396|33.772075,-84.395277': 260,
  '33.774134,-84.39396|33.775178,-84.401879': 632.5,
  '33.774134,-84.39396|33.775381,-84.391451': 294.2,
  '33.774134,-84.39396|33.77535159008218,-84.39513500282604': 223.3,
  '33.774134,-84.39396|33.7738,-84.397': 240.6,
  '33.774134,-84.39396|33.7766,-84.4048': 908.5,
  '33.774134,-84.39396|33.7756,-84.3963': 306.9,
  '33.77247,-84.391271|33.77258,-84.395624': 433.9,
  '33.77247,-84.391271|33.786914,-84.406213': 1991.7,
  '33.77247,-84.391271|33.775778,-84.401885': 987.9,
  '33.77247,-84.391271|33.775041,-84.399287': 812.3,
  '33.77247,-84.391271|33.773978,-84.404311': 1132.3,
  '33.77247,-84.391271|33.772075,-84.395277': 419.2,
  '33.77247,-84.391271|33.775178,-84.401879': 974.5,
  '33.77247,-84.391271|33.775381,-84.391451': 383.7,
  '33.77247,-84.391271|33.77535159008218,-84.39513500282604': 572.9,
  '33.77247,-84.391271|33.7738,-84.397': 582.6,
  '33.77247,-84.391271|33.7766,-84.4048': 1244.3,
  '33.77247,-84.391271|33.7756,-84.3963': 654.7,
  '33.779159,-84.403952|33.77258,-84.395624': 920.9,
  '33.779159,-84.403952|33.786914,-84.406213': 871.6,
  '33.779159,-84.403952|33.775778,-84.401885': 444.4,
  '33.779159,-84.403952|33.775041,-84.399287': 542.6,
  '33.779159,-84.403952|33.773978,-84.404311': 750,
  '33.779159,-84.403952|33.772075,-84.395277': 924.4,
  '33.779159,-84.403952|33.775178,-84.401879': 439.9,
  '33.779159,-84.403952|33.775381,-84.391451': 1034.6,
  '33.779159,-84.403952|33.77535159008218,-84.39513500282604': 792.7,
  '33.779159,-84.403952|33.7738,-84.397': 746.9,
  '33.779159,-84.403952|33.7766,-84.4048': 309.3,
  '33.779159,-84.403952|33.7756,-84.3963': 711.3,
  '33.7742,-84.394637|33.77258,-84.395624': 178.8,
  '33.7742,-84.394637|33.786914,-84.406213': 1580.7,
  '33.7742,-84.394637|33.775778,-84.401885': 576.9,
  '33.7742,-84.394637|33.775041,-84.399287': 401.3,
  '33.7742,-84.394637|33.773978,-84.404311': 852.3,
  '33.7742,-84.394637|33.772075,-84.395277': 211,
  '33.7742,-84.394637|33.775178,-84.401879': 563.5,
  '33.7742,-84.394637|33.775381,-84.391451': 363.8,
  '33.7742,-84.394637|33.77535159008218,-84.39513500282604': 180.3,
  '33.7742,-84.394637|33.7738,-84.397': 171.6,
  '33.7742,-84.394637|33.7766,-84.4048': 839.5,
  '33.7742,-84.394637|33.7756,-84.3963': 237.9,
  '33.779564,-84.404718|33.77258,-84.395624': 993.7,
  '33.779564,-84.404718|33.786914,-84.406213': 851.4,
  '33.779564,-84.404718|33.775778,-84.401885': 538.5,
  '33.779564,-84.404718|33.775041,-84.399287': 636.7,
  '33.779564,-84.404718|33.773978,-84.404311': 840.5,
  '33.779564,-84.404718|33.772075,-84.395277': 1014.5,
  '33.779564,-84.404718|33.775178,-84.401879': 534,
  '33.779564,-84.404718|33.775381,-84.391451': 1079.8,
  '33.779564,-84.404718|33.77535159008218,-84.39513500282604': 859,
  '33.779564,-84.404718|33.7738,-84.397': 813.2,
  '33.779564,-84.404718|33.7766,-84.4048': 343.4,
  '33.779564,-84.404718|33.7756,-84.3963': 764.1,
  '33.778233,-84.404507|33.77258,-84.395624': 921.7,
  '33.778233,-84.404507|33.786914,-84.406213': 933.4,
  '33.778233,-84.404507|33.775778,-84.401885': 411.8,
  '33.778233,-84.404507|33.775041,-84.399287': 543.4,
  '33.778233,-84.404507|33.773978,-84.404311': 703.1,
  '33.778233,-84.404507|33.772075,-84.395277': 925.2,
  '33.778233,-84.404507|33.775178,-84.401879': 399.8,
  '33.778233,-84.404507|33.775381,-84.391451': 1069.7,
  '33.778233,-84.404507|33.77535159008218,-84.39513500282604': 793.5,
  '33.778233,-84.404507|33.7738,-84.397': 747.7,
  '33.778233,-84.404507|33.7766,-84.4048': 206,
  '33.778233,-84.404507|33.7756,-84.3963': 734.8,
  '33.779836,-84.396666|33.7805,-84.3921': 471.3,
  '33.779836,-84.396666|33.7723,-84.3922': 804,
  '33.77561,-84.38906|33.7805,-84.3921': 706.3,
  '33.77561,-84.38906|33.7723,-84.3922': 632.9,
  '33.780983,-84.404516|33.7805,-84.3921': 951.4,
  '33.780983,-84.404516|33.7723,-84.3922': 1355,
  '33.773714,-84.394047|33.7805,-84.3921': 720.3,
  '33.773714,-84.394047|33.7723,-84.3922': 283.3,
  '33.776532,-84.397307|33.7805,-84.3921': 671.4,
  '33.776532,-84.397307|33.7723,-84.3922': 637.2,
  '33.777062,-84.388997|33.7805,-84.3921': 607.8,
  '33.777062,-84.388997|33.7723,-84.3922': 603.2,
  '33.774134,-84.39396|33.7805,-84.3921': 699.2,
  '33.774134,-84.39396|33.7723,-84.3922': 269.8,
  '33.77247,-84.391271|33.7805,-84.3921': 874.8,
  '33.77247,-84.391271|33.7723,-84.3922': 220.4,
  '33.779159,-84.403952|33.7805,-84.3921': 1052,
  '33.779159,-84.403952|33.7723,-84.3922': 1182.3,
  '33.7742,-84.394637|33.7805,-84.3921': 697.9,
  '33.7742,-84.394637|33.7723,-84.3922': 338.1,
  '33.779564,-84.404718|33.7805,-84.3921': 1046.6,
  '33.779564,-84.404718|33.7723,-84.3922': 1248.6,
  '33.778233,-84.404507|33.7805,-84.3921': 1118.7,
  '33.778233,-84.404507|33.7723,-84.3922': 1183.1,
  '33.77258,-84.395624|33.773568,-84.395957': 109.3,
  '33.77258,-84.395624|33.774909,-84.396404': 319.6,
  '33.77258,-84.395624|33.776085,-84.400181': 535.8,
  '33.77258,-84.395624|33.776076,-84.396114': 379,
  '33.77258,-84.395624|33.776177,-84.395459': 363.9,
  '33.77258,-84.395624|33.776533,-84.387765': 853.7,
  '33.77258,-84.395624|33.771771,-84.395796': 88.6,
  '33.77258,-84.395624|33.776065,-84.397116': 398.5,
  '33.77258,-84.395624|33.775803,-84.398189': 397.9,
  '33.786914,-84.406213|33.773568,-84.395957': 1531.3,
  '33.786914,-84.406213|33.774909,-84.396404': 1396.1,
  '33.786914,-84.406213|33.776085,-84.400181': 1149.5,
  '33.786914,-84.406213|33.776076,-84.396114': 1361.5,
  '33.786914,-84.406213|33.776177,-84.395459': 1408.1,
  '33.786914,-84.406213|33.776533,-84.387765': 1870.8,
  '33.786914,-84.406213|33.771771,-84.395796': 1668.6,
  '33.786914,-84.406213|33.776065,-84.397116': 1342.8,
  '33.786914,-84.406213|33.775803,-84.398189': 1298.7,
  '33.775778,-84.401885|33.773568,-84.395957': 527.5,
  '33.775778,-84.401885|33.774909,-84.396404': 417.1,
  '33.775778,-84.401885|33.776085,-84.400181': 114.1,
  '33.775778,-84.401885|33.776076,-84.396114': 474.6,
  '33.775778,-84.401885|33.776177,-84.395459': 556.1,
  '33.775778,-84.401885|33.776533,-84.387765': 1026.4,
  '33.775778,-84.401885|33.771771,-84.395796': 638.4,
  '33.775778,-84.401885|33.776065,-84.397116': 483.2,
  '33.775778,-84.401885|33.775803,-84.398189': 353.9,
  '33.775041,-84.399287|33.773568,-84.395957': 351.9,
  '33.775041,-84.399287|33.774909,-84.396404': 241.5,
  '33.775041,-84.399287|33.776085,-84.400181': 212.3,
  '33.775041,-84.399287|33.776076,-84.396114': 299,
  '33.775041,-84.399287|33.776177,-84.395459': 399,
  '33.775041,-84.399287|33.776533,-84.387765': 920.6,
  '33.775041,-84.399287|33.771771,-84.395796': 462.8,
  '33.775041,-84.399287|33.776065,-84.397116': 318.5,
  '33.775041,-84.399287|33.775803,-84.398189': 197.5,
  '33.773978,-84.404311|33.773568,-84.395957': 771.3,
  '33.773978,-84.404311|33.774909,-84.396404': 745.9,
  '33.773978,-84.404311|33.776085,-84.400181': 533.7,
  '33.773978,-84.404311|33.776076,-84.396114': 803.4,
  '33.773978,-84.404311|33.776177,-84.395459': 903.4,
  '33.773978,-84.404311|33.776533,-84.387765': 1425,
  '33.773978,-84.404311|33.771771,-84.395796': 793.7,
  '33.773978,-84.404311|33.776065,-84.397116': 822.9,
  '33.773978,-84.404311|33.775803,-84.398189': 701.9,
  '33.772075,-84.395277|33.773568,-84.395957': 141.5,
  '33.772075,-84.395277|33.774909,-84.396404': 351.8,
  '33.772075,-84.395277|33.776085,-84.400181': 556.6,
  '33.772075,-84.395277|33.776076,-84.396114': 411.2,
  '33.772075,-84.395277|33.776177,-84.395459': 396.1,
  '33.772075,-84.395277|33.776533,-84.387765': 885.9,
  '33.772075,-84.395277|33.771771,-84.395796': 84.6,
  '33.772075,-84.395277|33.776065,-84.397116': 430.7,
  '33.772075,-84.395277|33.775803,-84.398189': 418.7,
  '33.775178,-84.401879|33.773568,-84.395957': 514.1,
  '33.775178,-84.401879|33.774909,-84.396404': 403.7,
  '33.775178,-84.401879|33.776085,-84.400181': 217.4,
  '33.775178,-84.401879|33.776076,-84.396114': 461.2,
  '33.775178,-84.401879|33.776177,-84.395459': 561.2,
  '33.775178,-84.401879|33.776533,-84.387765': 1082.8,
  '33.775178,-84.401879|33.771771,-84.395796': 625,
  '33.775178,-84.401879|33.776065,-84.397116': 480.7,
  '33.775178,-84.401879|33.775803,-84.398189': 359.7,
  '33.775381,-84.391451|33.773568,-84.395957': 440.5,
  '33.775381,-84.391451|33.774909,-84.396404': 398.8,
  '33.775381,-84.391451|33.776085,-84.400181': 677.3,
  '33.775381,-84.391451|33.776076,-84.396114': 422.4,
  '33.775381,-84.391451|33.776177,-84.395459': 341.7,
  '33.775381,-84.391451|33.776533,-84.387765': 436.6,
  '33.775381,-84.391451|33.771771,-84.395796': 561.4,
  '33.775381,-84.391451|33.776065,-84.397116': 435,
  '33.775381,-84.391451|33.775803,-84.398189': 487.8,
  '33.77535159008218,-84.39513500282604|33.773568,-84.395957': 191.8,
  '33.77535159008218,-84.39513500282604|33.774909,-84.396404': 122.6,
  '33.77535159008218,-84.39513500282604|33.776085,-84.400181': 401.1,
  '33.77535159008218,-84.39513500282604|33.776076,-84.396114': 182,
  '33.77535159008218,-84.39513500282604|33.776177,-84.395459': 166.9,
  '33.77535159008218,-84.39513500282604|33.776533,-84.387765': 594.9,
  '33.77535159008218,-84.39513500282604|33.771771,-84.395796': 330.6,
  '33.77535159008218,-84.39513500282604|33.776065,-84.397116': 201.5,
  '33.77535159008218,-84.39513500282604|33.775803,-84.398189': 211.6,
  '33.7738,-84.397|33.773568,-84.395957': 122.2,
  '33.7738,-84.397|33.774909,-84.396404': 142.9,
  '33.7738,-84.397|33.776085,-84.400181': 355.3,
  '33.7738,-84.397|33.776076,-84.396114': 216.3,
  '33.7738,-84.397|33.776177,-84.395459': 300.4,
  '33.7738,-84.397|33.776533,-84.387765': 822,
  '33.7738,-84.397|33.771771,-84.395796': 253.5,
  '33.7738,-84.397|33.776065,-84.397116': 235.8,
  '33.7738,-84.397|33.775803,-84.398189': 208.5,
  '33.7766,-84.4048|33.773568,-84.395957': 790.1,
  '33.7766,-84.4048|33.774909,-84.396404': 672.6,
  '33.7766,-84.4048|33.776085,-84.400181': 362.1,
  '33.7766,-84.4048|33.776076,-84.396114': 730.1,
  '33.7766,-84.4048|33.776177,-84.395459': 804.1,
  '33.7766,-84.4048|33.776533,-84.387765': 1274.4,
  '33.7766,-84.4048|33.771771,-84.395796': 880.7,
  '33.7766,-84.4048|33.776065,-84.397116': 731.2,
  '33.7766,-84.4048|33.775803,-84.398189': 601.9,
  '33.7756,-84.3963|33.773568,-84.395957': 240.1,
  '33.7756,-84.3963|33.774909,-84.396404': 83.5,
  '33.7756,-84.3963|33.776085,-84.400181': 346.1,
  '33.7756,-84.3963|33.776076,-84.396114': 71.9,
  '33.7756,-84.3963|33.776177,-84.395459': 129.4,
  '33.7756,-84.3963|33.776533,-84.387765': 662.3,
  '33.7756,-84.3963|33.771771,-84.395796': 378.9,
  '33.7756,-84.3963|33.776065,-84.397116': 91.4,
  '33.7756,-84.3963|33.775803,-84.398189': 149.2,
  '33.77258,-84.395624|33.777576,-84.397352': 536.6,
  '33.77258,-84.395624|33.772949,-84.396066': 109.1,
  '33.77258,-84.395624|33.772114,-84.395289': 45.8,
  '33.77258,-84.395624|33.776764,-84.39844': 514.9,
  '33.77258,-84.395624|33.77672,-84.401764': 693.4,
  '33.77258,-84.395624|33.777187,-84.400484': 623.8,
  '33.77258,-84.395624|33.77622,-84.397959': 433,
  '33.77258,-84.395624|33.777622,-84.398785': 618.3,
  '33.786914,-84.406213|33.777576,-84.397352': 1202.4,
  '33.786914,-84.406213|33.772949,-84.396066': 1533.4,
  '33.786914,-84.406213|33.772114,-84.395289': 1639,
  '33.786914,-84.406213|33.776764,-84.39844': 1183.3,
  '33.786914,-84.406213|33.77672,-84.401764': 1107.2,
  '33.786914,-84.406213|33.777187,-84.400484': 1031,
  '33.786914,-84.406213|33.77622,-84.397959': 1241.8,
  '33.786914,-84.406213|33.777622,-84.398785': 1102.3,
  '33.775778,-84.401885|33.777576,-84.397352': 423.1,
  '33.775778,-84.401885|33.772949,-84.396066': 529.6,
  '33.775778,-84.401885|33.772114,-84.395289': 608.8,
  '33.775778,-84.401885|33.776764,-84.39844': 310.2,
  '33.775778,-84.401885|33.77672,-84.401764': 140.3,
  '33.775778,-84.401885|33.777187,-84.400484': 243.5,
  '33.775778,-84.401885|33.77622,-84.397959': 297,
  '33.775778,-84.401885|33.777622,-84.398785': 327.3,
  '33.775041,-84.399287|33.777576,-84.397352': 387,
  '33.775041,-84.399287|33.772949,-84.396066': 354,
  '33.775041,-84.399287|33.772114,-84.395289': 433.2,
  '33.775041,-84.399287|33.776764,-84.39844': 296.7,
  '33.775041,-84.399287|33.77672,-84.401764': 315.1,
  '33.775041,-84.399287|33.777187,-84.400484': 341.7,
  '33.775041,-84.399287|33.77622,-84.397959': 232.6,
  '33.775041,-84.399287|33.777622,-84.398785': 349.4,
  '33.773978,-84.404311|33.777576,-84.397352': 842.7,
  '33.773978,-84.404311|33.772949,-84.396066': 735.8,
  '33.773978,-84.404311|33.772114,-84.395289': 764.1,
  '33.773978,-84.404311|33.776764,-84.39844': 729.8,
  '33.773978,-84.404311|33.77672,-84.401764': 478.9,
  '33.773978,-84.404311|33.777187,-84.400484': 663.1,
  '33.773978,-84.404311|33.77622,-84.397959': 716.6,
  '33.773978,-84.404311|33.777622,-84.398785': 746.9,
  '33.772075,-84.395277|33.777576,-84.397352': 568.8,
  '33.772075,-84.395277|33.772949,-84.396066': 113.4,
  '33.772075,-84.395277|33.772114,-84.395289': 3.2,
  '33.772075,-84.395277|33.776764,-84.39844': 535.7,
  '33.772075,-84.395277|33.77672,-84.401764': 696.9,
  '33.772075,-84.395277|33.777187,-84.400484': 644.6,
  '33.772075,-84.395277|33.77622,-84.397959': 453.8,
  '33.772075,-84.395277|33.777622,-84.398785': 647.2,
  '33.775178,-84.401879|33.777576,-84.397352': 526.4,
  '33.775178,-84.401879|33.772949,-84.396066': 516.2,
  '33.775178,-84.401879|33.772114,-84.395289': 595.4,
  '33.775178,-84.401879|33.776764,-84.39844': 413.5,
  '33.775178,-84.401879|33.77672,-84.401764': 162.6,
  '33.775178,-84.401879|33.777187,-84.400484': 346.8,
  '33.775178,-84.401879|33.77622,-84.397959': 394.8,
  '33.775178,-84.401879|33.777622,-84.398785': 430.6,
  '33.775381,-84.391451|33.777576,-84.397352': 547.3,
  '33.775381,-84.391451|33.772949,-84.396066': 511.9,
  '33.775381,-84.391451|33.772114,-84.395289': 511.4,
  '33.775381,-84.391451|33.776764,-84.39844': 580.3,
  '33.775381,-84.391451|33.77672,-84.401764': 861.7,
  '33.775381,-84.391451|33.777187,-84.400484': 742.5,
  '33.775381,-84.391451|33.77622,-84.397959': 522.9,
  '33.775381,-84.391451|33.777622,-84.398785': 643,
  '33.77535159008218,-84.39513500282604|33.777576,-84.397352': 339.6,
  '33.77535159008218,-84.39513500282604|33.772949,-84.396066': 263.8,
  '33.77535159008218,-84.39513500282604|33.772114,-84.395289': 287.8,
  '33.77535159008218,-84.39513500282604|33.776764,-84.39844': 327.4,
  '33.77535159008218,-84.39513500282604|33.77672,-84.401764': 585.5,
  '33.77535159008218,-84.39513500282604|33.777187,-84.400484': 489.1,
  '33.77535159008218,-84.39513500282604|33.77622,-84.397959': 246.7,
  '33.77535159008218,-84.39513500282604|33.777622,-84.398785': 421.3,
  '33.7738,-84.397|33.777576,-84.397352': 382.4,
  '33.7738,-84.397|33.772949,-84.396066': 115.3,
  '33.7738,-84.397|33.772114,-84.395289': 223.9,
  '33.7738,-84.397|33.776764,-84.39844': 324.3,
  '33.7738,-84.397|33.77672,-84.401764': 522,
  '33.7738,-84.397|33.777187,-84.400484': 443.3,
  '33.7738,-84.397|33.77622,-84.397959': 243.6,
  '33.7738,-84.397|33.777622,-84.398785': 435.8,
  '33.7766,-84.4048|33.777576,-84.397352': 646.4,
  '33.7766,-84.4048|33.772949,-84.396066': 792.2,
  '33.7766,-84.4048|33.772114,-84.395289': 851.1,
  '33.7766,-84.4048|33.776764,-84.39844': 558.2,
  '33.7766,-84.4048|33.77672,-84.401764': 259.9,
  '33.7766,-84.4048|33.777187,-84.400484': 456.3,
  '33.7766,-84.4048|33.77622,-84.397959': 545,
  '33.7766,-84.4048|33.777622,-84.398785': 546.3,
  '33.7756,-84.3963|33.777576,-84.397352': 238,
  '33.7756,-84.3963|33.772949,-84.396066': 309.7,
  '33.7756,-84.3963|33.772114,-84.395289': 336.1,
  '33.7756,-84.3963|33.776764,-84.39844': 257,
  '33.7756,-84.3963|33.77672,-84.401764': 530.5,
  '33.7756,-84.3963|33.777187,-84.400484': 419.2,
  '33.7756,-84.3963|33.77622,-84.397959': 184.3,
  '33.7756,-84.3963|33.777622,-84.398785': 319.7,
  '33.77258,-84.395624|33.775587,-84.401213': 604.2,
  '33.77258,-84.395624|33.779177,-84.392196': 737.8,
  '33.77258,-84.395624|33.779495,-84.405633': 1054.6,
  '33.77258,-84.395624|33.773801,-84.395122': 139.1,
  '33.77258,-84.395624|33.771658,-84.395302': 82.5,
  '33.77258,-84.395624|33.778759,-84.399597': 744.9,
  '33.77258,-84.395624|33.779004,-84.395849': 571.8,
  '33.77258,-84.395624|33.777107,-84.395817': 389.7,
  '33.77258,-84.395624|33.778011,-84.397065': 547.2,
  '33.77258,-84.395624|33.778513,-84.396825': 570.7,
  '33.786914,-84.406213|33.775587,-84.401213': 1208.5,
  '33.786914,-84.406213|33.779177,-84.392196': 1701.1,
  '33.786914,-84.406213|33.779495,-84.405633': 874.3,
  '33.786914,-84.406213|33.773801,-84.395122': 1576.5,
  '33.786914,-84.406213|33.771658,-84.395302': 1675.7,
  '33.786914,-84.406213|33.778759,-84.399597': 998.6,
  '33.786914,-84.406213|33.779004,-84.395849': 1364.6,
  '33.786914,-84.406213|33.777107,-84.395817': 1332.3,
  '33.786914,-84.406213|33.778011,-84.397065': 1194.4,
  '33.786914,-84.406213|33.778513,-84.396825': 1214.1,
  '33.775778,-84.401885|33.775587,-84.401213': 38.5,
  '33.775778,-84.401885|33.779177,-84.392196': 910.5,
  '33.775778,-84.401885|33.779495,-84.405633': 599.4,
  '33.775778,-84.401885|33.773801,-84.395122': 572.7,
  '33.775778,-84.401885|33.771658,-84.395302': 645.5,
  '33.775778,-84.401885|33.778759,-84.399597': 420.9,
  '33.775778,-84.401885|33.779004,-84.395849': 648.8,
  '33.775778,-84.401885|33.777107,-84.395817': 472.7,
  '33.775778,-84.401885|33.778011,-84.397065': 467.7,
  '33.775778,-84.401885|33.778513,-84.396825': 501,
  '33.775041,-84.399287|33.775587,-84.401213': 225.9,
  '33.775041,-84.399287|33.779177,-84.392196': 804.7,
  '33.775041,-84.399287|33.779495,-84.405633': 697.6,
  '33.775041,-84.399287|33.773801,-84.395122': 397.1,
  '33.775041,-84.399287|33.771658,-84.395302': 469.9,
  '33.775041,-84.399287|33.778759,-84.399597': 466.5,
  '33.775041,-84.399287|33.779004,-84.395849': 605.4,
  '33.775041,-84.399287|33.777107,-84.395817': 395.8,
  '33.775041,-84.399287|33.778011,-84.397065': 447.2,
  '33.775041,-84.399287|33.778513,-84.396825': 480.5,
  '33.773978,-84.404311|33.775587,-84.401213': 453.9,
  '33.773978,-84.404311|33.779177,-84.392196': 1309.1,
  '33.773978,-84.404311|33.779495,-84.405633': 890.7,
  '33.773978,-84.404311|33.773801,-84.395122': 830.1,
  '33.773978,-84.404311|33.771658,-84.395302': 787,
  '33.773978,-84.404311|33.778759,-84.399597': 773.9,
  '33.773978,-84.404311|33.779004,-84.395849': 1068.4,
  '33.773978,-84.404311|33.777107,-84.395817': 892.3,
  '33.773978,-84.404311|33.778011,-84.397065': 887.3,
  '33.773978,-84.404311|33.778513,-84.396825': 920.6,
  '33.772075,-84.395277|33.775587,-84.401213': 607.7,
  '33.772075,-84.395277|33.779177,-84.392196': 770,
  '33.772075,-84.395277|33.779495,-84.405633': 1075.4,
  '33.772075,-84.395277|33.773801,-84.395122': 171.3,
  '33.772075,-84.395277|33.771658,-84.395302': 33.5,
  '33.772075,-84.395277|33.778759,-84.399597': 765.7,
  '33.772075,-84.395277|33.779004,-84.395849': 604,
  '33.772075,-84.395277|33.777107,-84.395817': 421.9,
  '33.772075,-84.395277|33.778011,-84.397065': 579.4,
  '33.772075,-84.395277|33.778513,-84.396825': 602.9,
  '33.775178,-84.401879|33.775587,-84.401213': 137.6,
  '33.775178,-84.401879|33.779177,-84.392196': 966.9,
  '33.775178,-84.401879|33.779495,-84.405633': 594.9,
  '33.775178,-84.401879|33.773801,-84.395122': 559.3,
  '33.775178,-84.401879|33.771658,-84.395302': 632.1,
  '33.775178,-84.401879|33.778759,-84.399597': 458.6,
  '33.775178,-84.401879|33.779004,-84.395849': 752.1,
  '33.775178,-84.401879|33.777107,-84.395817': 558,
  '33.775178,-84.401879|33.778011,-84.397065': 571,
  '33.775178,-84.401879|33.778513,-84.396825': 604.3,
  '33.775381,-84.391451|33.775587,-84.401213': 772.5,
  '33.775381,-84.391451|33.779177,-84.392196': 346.1,
  '33.775381,-84.391451|33.779495,-84.405633': 1140.7,
  '33.775381,-84.391451|33.773801,-84.395122': 367.8,
  '33.775381,-84.391451|33.771658,-84.395302': 547.8,
  '33.775381,-84.391451|33.778759,-84.399597': 755.6,
  '33.775381,-84.391451|33.779004,-84.395849': 536.2,
  '33.775381,-84.391451|33.777107,-84.395817': 382.8,
  '33.775381,-84.391451|33.778011,-84.397065': 527.7,
  '33.775381,-84.391451|33.778513,-84.396825': 543.6,
  '33.77535159008218,-84.39513500282604|33.775587,-84.401213': 496.3,
  '33.77535159008218,-84.39513500282604|33.779177,-84.392196': 479,
  '33.77535159008218,-84.39513500282604|33.779495,-84.405633': 919.9,
  '33.77535159008218,-84.39513500282604|33.773801,-84.395122': 194.8,
  '33.77535159008218,-84.39513500282604|33.771658,-84.395302': 324.5,
  '33.77535159008218,-84.39513500282604|33.778759,-84.399597': 578.1,
  '33.77535159008218,-84.39513500282604|33.779004,-84.395849': 374.8,
  '33.77535159008218,-84.39513500282604|33.777107,-84.395817': 192.7,
  '33.77535159008218,-84.39513500282604|33.778011,-84.397065': 350.2,
  '33.77535159008218,-84.39513500282604|33.778513,-84.396825': 373.7,
  '33.7738,-84.397|33.775587,-84.401213': 432.8,
  '33.7738,-84.397|33.779177,-84.392196': 706.1,
  '33.7738,-84.397|33.779495,-84.405633': 874.1,
  '33.7738,-84.397|33.773801,-84.395122': 167.4,
  '33.7738,-84.397|33.771658,-84.395302': 260.6,
  '33.7738,-84.397|33.778759,-84.399597': 564.4,
  '33.7738,-84.397|33.779004,-84.395849': 508.3,
  '33.7738,-84.397|33.777107,-84.395817': 313.1,
  '33.7738,-84.397|33.778011,-84.397065': 419.4,
  '33.7738,-84.397|33.778513,-84.396825': 451.9,
  '33.7766,-84.4048|33.775587,-84.401213': 299.1,
  '33.7766,-84.4048|33.779177,-84.392196': 1158.5,
  '33.7766,-84.4048|33.779495,-84.405633': 376.8,
  '33.7766,-84.4048|33.773801,-84.395122': 835.3,
  '33.7766,-84.4048|33.771658,-84.395302': 887.8,
  '33.7766,-84.4048|33.778759,-84.399597': 485.5,
  '33.7766,-84.4048|33.779004,-84.395849': 817.8,
  '33.7766,-84.4048|33.777107,-84.395817': 720.7,
  '33.7766,-84.4048|33.778011,-84.397065': 638.4,
  '33.7766,-84.4048|33.778513,-84.396825': 669.7,
  '33.7756,-84.3963|33.775587,-84.401213': 441.3,
  '33.7756,-84.3963|33.779177,-84.392196': 546.4,
  '33.7756,-84.3963|33.779495,-84.405633': 825,
  '33.7756,-84.3963|33.773801,-84.395122': 243.1,
  '33.7756,-84.3963|33.771658,-84.395302': 372.8,
  '33.7756,-84.3963|33.778759,-84.399597': 478.5,
  '33.7756,-84.3963|33.779004,-84.395849': 337.3,
  '33.7756,-84.3963|33.777107,-84.395817': 155.2,
  '33.7756,-84.3963|33.778011,-84.397065': 275,
  '33.7756,-84.3963|33.778513,-84.396825': 307.5,
  '33.77258,-84.395624|33.779836,-84.396666': 637.1,
  '33.77258,-84.395624|33.77561,-84.38906': 846.4,
  '33.77258,-84.395624|33.780983,-84.404516': 1100.1,
  '33.77258,-84.395624|33.773714,-84.394047': 198.5,
  '33.77258,-84.395624|33.776532,-84.397307': 414,
  '33.77258,-84.395624|33.777062,-84.388997': 785,
  '33.77258,-84.395624|33.774134,-84.39396': 247.8,
  '33.77258,-84.395624|33.77247,-84.391271': 433.9,
  '33.77258,-84.395624|33.779159,-84.403952': 920.9,
  '33.77258,-84.395624|33.7742,-84.394637': 178.8,
  '33.77258,-84.395624|33.779564,-84.404718': 993.7,
  '33.77258,-84.395624|33.778233,-84.404507': 921.7,
  '33.786914,-84.406213|33.779836,-84.396666': 1198,
  '33.786914,-84.406213|33.77561,-84.38906': 1871.6,
  '33.786914,-84.406213|33.780983,-84.404516': 661.8,
  '33.786914,-84.406213|33.773714,-84.394047': 1621.2,
  '33.786914,-84.406213|33.776532,-84.397307': 1292.4,
  '33.786914,-84.406213|33.777062,-84.388997': 1786.7,
  '33.786914,-84.406213|33.774134,-84.39396': 1649.7,
  '33.786914,-84.406213|33.77247,-84.391271': 1991.7,
  '33.786914,-84.406213|33.779159,-84.403952': 871.6,
  '33.786914,-84.406213|33.7742,-84.394637': 1580.7,
  '33.786914,-84.406213|33.779564,-84.404718': 851.4,
  '33.786914,-84.406213|33.778233,-84.404507': 933.4,
  '33.775778,-84.401885|33.779836,-84.396666': 601.6,
  '33.775778,-84.401885|33.77561,-84.38906': 1027.2,
  '33.775778,-84.401885|33.780983,-84.404516': 696.4,
  '33.775778,-84.401885|33.773714,-84.394047': 617.4,
  '33.775778,-84.401885|33.776532,-84.397307': 432.8,
  '33.775778,-84.401885|33.777062,-84.388997': 957.7,
  '33.775778,-84.401885|33.774134,-84.39396': 645.9,
  '33.775778,-84.401885|33.77247,-84.391271': 987.9,
  '33.775778,-84.401885|33.779159,-84.403952': 444.4,
  '33.775778,-84.401885|33.7742,-84.394637': 576.9,
  '33.775778,-84.401885|33.779564,-84.404718': 538.5,
  '33.775778,-84.401885|33.778233,-84.404507': 411.8,
  '33.775041,-84.399287|33.779836,-84.396666': 581.1,
  '33.775041,-84.399287|33.77561,-84.38906': 921.4,
  '33.775041,-84.399287|33.780983,-84.404516': 794.6,
  '33.775041,-84.399287|33.773714,-84.394047': 441.8,
  '33.775041,-84.399287|33.776532,-84.397307': 335.3,
  '33.775041,-84.399287|33.777062,-84.388997': 851.9,
  '33.775041,-84.399287|33.774134,-84.39396': 470.3,
  '33.775041,-84.399287|33.77247,-84.391271': 812.3,
  '33.775041,-84.399287|33.779159,-84.403952': 542.6,
  '33.775041,-84.399287|33.7742,-84.394637': 401.3,
  '33.775041,-84.399287|33.779564,-84.404718': 636.7,
  '33.775041,-84.399287|33.778233,-84.404507': 543.4,
  '33.773978,-84.404311|33.779836,-84.396666': 1020.7,
  '33.773978,-84.404311|33.77561,-84.38906': 1425.8,
  '33.773978,-84.404311|33.780983,-84.404516': 1003.5,
  '33.773978,-84.404311|33.773714,-84.394047': 892.8,
  '33.773978,-84.404311|33.776532,-84.397307': 839.7,
  '33.773978,-84.404311|33.777062,-84.388997': 1356.3,
  '33.773978,-84.404311|33.774134,-84.39396': 921.3,
  '33.773978,-84.404311|33.77247,-84.391271': 1132.3,
  '33.773978,-84.404311|33.779159,-84.403952': 750,
  '33.773978,-84.404311|33.7742,-84.394637': 852.3,
  '33.773978,-84.404311|33.779564,-84.404718': 840.5,
  '33.773978,-84.404311|33.778233,-84.404507': 703.1,
  '33.772075,-84.395277|33.779836,-84.396666': 669.3,
  '33.772075,-84.395277|33.77561,-84.38906': 831.7,
  '33.772075,-84.395277|33.780983,-84.404516': 1120.9,
  '33.772075,-84.395277|33.773714,-84.394047': 199.5,
  '33.772075,-84.395277|33.776532,-84.397307': 446.2,
  '33.772075,-84.395277|33.777062,-84.388997': 817.2,
  '33.772075,-84.395277|33.774134,-84.39396': 260,
  '33.772075,-84.395277|33.77247,-84.391271': 419.2,
  '33.772075,-84.395277|33.779159,-84.403952': 924.4,
  '33.772075,-84.395277|33.7742,-84.394637': 211,
  '33.772075,-84.395277|33.779564,-84.404718': 1014.5,
  '33.772075,-84.395277|33.778233,-84.404507': 925.2,
  '33.775178,-84.401879|33.779836,-84.396666': 704.9,
  '33.775178,-84.401879|33.77561,-84.38906': 1083.6,
  '33.775178,-84.401879|33.780983,-84.404516': 691.9,
  '33.775178,-84.401879|33.773714,-84.394047': 604,
  '33.775178,-84.401879|33.776532,-84.397307': 497.5,
  '33.775178,-84.401879|33.777062,-84.388997': 1014.1,
  '33.775178,-84.401879|33.774134,-84.39396': 632.5,
  '33.775178,-84.401879|33.77247,-84.391271': 974.5,
  '33.775178,-84.401879|33.779159,-84.403952': 439.9,
  '33.775178,-84.401879|33.7742,-84.394637': 563.5,
  '33.775178,-84.401879|33.779564,-84.404718': 534,
  '33.775178,-84.401879|33.778233,-84.404507': 399.8,
  '33.775381,-84.391451|33.779836,-84.396666': 610,
  '33.775381,-84.391451|33.77561,-84.38906': 437.4,
  '33.775381,-84.391451|33.780983,-84.404516': 1183.4,
  '33.775381,-84.391451|33.773714,-84.394047': 319.6,
  '33.775381,-84.391451|33.776532,-84.397307': 443.2,
  '33.775381,-84.391451|33.777062,-84.388997': 370.6,
  '33.775381,-84.391451|33.774134,-84.39396': 294.2,
  '33.775381,-84.391451|33.77247,-84.391271': 383.7,
  '33.775381,-84.391451|33.779159,-84.403952': 1034.6,
  '33.775381,-84.391451|33.7742,-84.394637': 363.8,
  '33.775381,-84.391451|33.779564,-84.404718': 1079.8,
  '33.775381,-84.391451|33.778233,-84.404507': 1069.7,
  '33.77535159008218,-84.39513500282604|33.779836,-84.396666': 440.1,
  '33.77535159008218,-84.39513500282604|33.77561,-84.38906': 595.7,
  '33.77535159008218,-84.39513500282604|33.780983,-84.404516': 965.4,
  '33.77535159008218,-84.39513500282604|33.773714,-84.394047': 202.7,
  '33.77535159008218,-84.39513500282604|33.776532,-84.397307': 217,
  '33.77535159008218,-84.39513500282604|33.777062,-84.388997': 526.2,
  '33.77535159008218,-84.39513500282604|33.774134,-84.39396': 223.3,
  '33.77535159008218,-84.39513500282604|33.77247,-84.391271': 572.9,
  '33.77535159008218,-84.39513500282604|33.779159,-84.403952': 792.7,
  '33.77535159008218,-84.39513500282604|33.7742,-84.394637': 180.3,
  '33.77535159008218,-84.39513500282604|33.779564,-84.404718': 859,
  '33.77535159008218,-84.39513500282604|33.778233,-84.404507': 793.5,
  '33.7738,-84.397|33.779836,-84.396666': 518.3,
  '33.7738,-84.397|33.77561,-84.38906': 822.8,
  '33.7738,-84.397|33.780983,-84.404516': 919.6,
  '33.7738,-84.397|33.773714,-84.394047': 212.1,
  '33.7738,-84.397|33.776532,-84.397307': 252.6,
  '33.7738,-84.397|33.777062,-84.388997': 753.3,
  '33.7738,-84.397|33.774134,-84.39396': 240.6,
  '33.7738,-84.397|33.77247,-84.391271': 582.6,
  '33.7738,-84.397|33.779159,-84.403952': 746.9,
  '33.7738,-84.397|33.7742,-84.394637': 171.6,
  '33.7738,-84.397|33.779564,-84.404718': 813.2,
  '33.7738,-84.397|33.778233,-84.404507': 747.7,
  '33.7766,-84.4048|33.779836,-84.396666': 732.3,
  '33.7766,-84.4048|33.77561,-84.38906': 1275.2,
  '33.7766,-84.4048|33.780983,-84.404516': 536.4,
  '33.7766,-84.4048|33.773714,-84.394047': 880,
  '33.7766,-84.4048|33.776532,-84.397307': 680.8,
  '33.7766,-84.4048|33.777062,-84.388997': 1205.7,
  '33.7766,-84.4048|33.774134,-84.39396': 908.5,
  '33.7766,-84.4048|33.77247,-84.391271': 1244.3,
  '33.7766,-84.4048|33.779159,-84.403952': 309.3,
  '33.7766,-84.4048|33.7742,-84.394637': 839.5,
  '33.7766,-84.4048|33.779564,-84.404718': 343.4,
  '33.7766,-84.4048|33.778233,-84.404507': 206,
  '33.7756,-84.3963|33.779836,-84.396666': 373.9,
  '33.7756,-84.3963|33.77561,-84.38906': 663.1,
  '33.7756,-84.3963|33.780983,-84.404516': 870.5,
  '33.7756,-84.3963|33.773714,-84.394047': 286.3,
  '33.7756,-84.3963|33.776532,-84.397307': 108.2,
  '33.7756,-84.3963|33.777062,-84.388997': 593.6,
  '33.7756,-84.3963|33.774134,-84.39396': 306.9,
  '33.7756,-84.3963|33.77247,-84.391271': 654.7,
  '33.7756,-84.3963|33.779159,-84.403952': 711.3,
  '33.7756,-84.3963|33.7742,-84.394637': 237.9,
  '33.7756,-84.3963|33.779564,-84.404718': 764.1,
  '33.7756,-84.3963|33.778233,-84.404507': 734.8,
  '33.77258,-84.395624|33.77258,-84.395624': 0,
  '33.77258,-84.395624|33.786914,-84.406213': 1621.4,
  '33.77258,-84.395624|33.775778,-84.401885': 608.5,
  '33.77258,-84.395624|33.775041,-84.399287': 432.9,
  '33.77258,-84.395624|33.773978,-84.404311': 763.8,
  '33.77258,-84.395624|33.772075,-84.395277': 49,
  '33.77258,-84.395624|33.775178,-84.401879': 595.1,
  '33.77258,-84.395624|33.775381,-84.391451': 506.9,
  '33.77258,-84.395624|33.77535159008218,-84.39513500282604': 258.8,
  '33.77258,-84.395624|33.7738,-84.397': 203.3,
  '33.77258,-84.395624|33.7766,-84.4048': 850.8,
  '33.77258,-84.395624|33.7756,-84.3963': 307.1,
  '33.786914,-84.406213|33.77258,-84.395624': 1621.4,
  '33.786914,-84.406213|33.786914,-84.406213': 0,
  '33.786914,-84.406213|33.775778,-84.401885': 1227.4,
  '33.786914,-84.406213|33.775041,-84.399287': 1325.6,
  '33.786914,-84.406213|33.773978,-84.404311': 1517.6,
  '33.786914,-84.406213|33.772075,-84.395277': 1642.2,
  '33.786914,-84.406213|33.775178,-84.401879': 1222.9,
  '33.786914,-84.406213|33.775381,-84.391451': 1699.9,
  '33.786914,-84.406213|33.77535159008218,-84.39513500282604': 1486.7,
  '33.786914,-84.406213|33.7738,-84.397': 1440.9,
  '33.786914,-84.406213|33.7766,-84.4048': 1129,
  '33.786914,-84.406213|33.7756,-84.3963': 1391.8,
  '33.775778,-84.401885|33.77258,-84.395624': 608.5,
  '33.775778,-84.401885|33.786914,-84.406213': 1227.4,
  '33.775778,-84.401885|33.775778,-84.401885': 0,
  '33.775778,-84.401885|33.775041,-84.399287': 230.2,
  '33.775778,-84.401885|33.773978,-84.404311': 423.5,
  '33.775778,-84.401885|33.772075,-84.395277': 612,
  '33.775778,-84.401885|33.775178,-84.401879': 107.2,
  '33.775778,-84.401885|33.775381,-84.391451': 783.9,
  '33.775778,-84.401885|33.77535159008218,-84.39513500282604': 507.7,
  '33.775778,-84.401885|33.7738,-84.397': 437.1,
  '33.775778,-84.401885|33.7766,-84.4048': 311,
  '33.775778,-84.401885|33.7756,-84.3963': 452.7,
  '33.775041,-84.399287|33.77258,-84.395624': 432.9,
  '33.775041,-84.399287|33.786914,-84.406213': 1325.6,
  '33.775041,-84.399287|33.775778,-84.401885': 230.2,
  '33.775041,-84.399287|33.775041,-84.399287': 0,
  '33.775041,-84.399287|33.773978,-84.404311': 559,
  '33.775041,-84.399287|33.772075,-84.395277': 436.4,
  '33.775041,-84.399287|33.775178,-84.401879': 216.8,
  '33.775041,-84.399287|33.775381,-84.391451': 608.3,
  '33.775041,-84.399287|33.77535159008218,-84.39513500282604': 332.1,
  '33.775041,-84.399287|33.7738,-84.397': 261.5,
  '33.775041,-84.399287|33.7766,-84.4048': 492.8,
  '33.775041,-84.399287|33.7756,-84.3963': 277.1,
  '33.773978,-84.404311|33.77258,-84.395624': 763.8,
  '33.773978,-84.404311|33.786914,-84.406213': 1517.6,
  '33.773978,-84.404311|33.775778,-84.401885': 423.5,
  '33.773978,-84.404311|33.775041,-84.399287': 559,
  '33.773978,-84.404311|33.773978,-84.404311': 0,
  '33.773978,-84.404311|33.772075,-84.395277': 767.3,
  '33.773978,-84.404311|33.775178,-84.401879': 368.8,
  '33.773978,-84.404311|33.775381,-84.391451': 1112.7,
  '33.773978,-84.404311|33.77535159008218,-84.39513500282604': 836.5,
  '33.773978,-84.404311|33.7738,-84.397': 680.7,
  '33.773978,-84.404311|33.7766,-84.4048': 589.3,
  '33.773978,-84.404311|33.7756,-84.3963': 781.5,
  '33.772075,-84.395277|33.77258,-84.395624': 49,
  '33.772075,-84.395277|33.786914,-84.406213': 1642.2,
  '33.772075,-84.395277|33.775778,-84.401885': 612,
  '33.772075,-84.395277|33.775041,-84.399287': 436.4,
  '33.772075,-84.395277|33.773978,-84.404311': 767.3,
  '33.772075,-84.395277|33.772075,-84.395277': 0,
  '33.772075,-84.395277|33.775178,-84.401879': 598.6,
  '33.772075,-84.395277|33.775381,-84.391451': 514.6,
  '33.772075,-84.395277|33.77535159008218,-84.39513500282604': 291,
  '33.772075,-84.395277|33.7738,-84.397': 227.1,
  '33.772075,-84.395277|33.7766,-84.4048': 854.3,
  '33.772075,-84.395277|33.7756,-84.3963': 339.3,
  '33.775178,-84.401879|33.77258,-84.395624': 595.1,
  '33.775178,-84.401879|33.786914,-84.406213': 1222.9,
  '33.775178,-84.401879|33.775778,-84.401885': 107.2,
  '33.775178,-84.401879|33.775041,-84.399287': 216.8,
  '33.775178,-84.401879|33.773978,-84.404311': 368.8,
  '33.775178,-84.401879|33.772075,-84.395277': 598.6,
  '33.775178,-84.401879|33.775178,-84.401879': 0,
  '33.775178,-84.401879|33.775381,-84.391451': 770.5,
  '33.775178,-84.401879|33.77535159008218,-84.39513500282604': 494.3,
  '33.775178,-84.401879|33.7738,-84.397': 423.7,
  '33.775178,-84.401879|33.7766,-84.4048': 299,
  '33.775178,-84.401879|33.7756,-84.3963': 439.3,
  '33.775381,-84.391451|33.77258,-84.395624': 506.9,
  '33.775381,-84.391451|33.786914,-84.406213': 1699.9,
  '33.775381,-84.391451|33.775778,-84.401885': 783.9,
  '33.775381,-84.391451|33.775041,-84.399287': 608.3,
  '33.775381,-84.391451|33.773978,-84.404311': 1112.7,
  '33.775381,-84.391451|33.772075,-84.395277': 514.6,
  '33.775381,-84.391451|33.775178,-84.401879': 770.5,
  '33.775381,-84.391451|33.775381,-84.391451': 0,
  '33.775381,-84.391451|33.77535159008218,-84.39513500282604': 282.1,
  '33.775381,-84.391451|33.7738,-84.397': 500.3,
  '33.775381,-84.391451|33.7766,-84.4048': 1039.4,
  '33.775381,-84.391451|33.7756,-84.3963': 354.5,
  '33.77535159008218,-84.39513500282604|33.77258,-84.395624': 258.8,
  '33.77535159008218,-84.39513500282604|33.786914,-84.406213': 1486.7,
  '33.77535159008218,-84.39513500282604|33.775778,-84.401885': 507.7,
  '33.77535159008218,-84.39513500282604|33.775041,-84.399287': 332.1,
  '33.77535159008218,-84.39513500282604|33.773978,-84.404311': 836.5,
  '33.77535159008218,-84.39513500282604|33.772075,-84.395277': 291,
  '33.77535159008218,-84.39513500282604|33.775178,-84.401879': 494.3,
  '33.77535159008218,-84.39513500282604|33.775381,-84.391451': 282.1,
  '33.77535159008218,-84.39513500282604|33.77535159008218,-84.39513500282604': 0,
  '33.77535159008218,-84.39513500282604|33.7738,-84.397': 233.5,
  '33.77535159008218,-84.39513500282604|33.7766,-84.4048': 763.2,
  '33.77535159008218,-84.39513500282604|33.7756,-84.3963': 110.1,
  '33.7738,-84.397|33.77258,-84.395624': 203.3,
  '33.7738,-84.397|33.786914,-84.406213': 1440.9,
  '33.7738,-84.397|33.775778,-84.401885': 437.1,
  '33.7738,-84.397|33.775041,-84.399287': 261.5,
  '33.7738,-84.397|33.773978,-84.404311': 680.7,
  '33.7738,-84.397|33.772075,-84.395277': 227.1,
  '33.7738,-84.397|33.775178,-84.401879': 423.7,
  '33.7738,-84.397|33.775381,-84.391451': 500.3,
  '33.7738,-84.397|33.77535159008218,-84.39513500282604': 233.5,
  '33.7738,-84.397|33.7738,-84.397': 0,
  '33.7738,-84.397|33.7766,-84.4048': 699.7,
  '33.7738,-84.397|33.7756,-84.3963': 194.4,
  '33.7766,-84.4048|33.77258,-84.395624': 850.8,
  '33.7766,-84.4048|33.786914,-84.406213': 1129,
  '33.7766,-84.4048|33.775778,-84.401885': 311,
  '33.7766,-84.4048|33.775041,-84.399287': 492.8,
  '33.7766,-84.4048|33.773978,-84.404311': 589.3,
  '33.7766,-84.4048|33.772075,-84.395277': 854.3,
  '33.7766,-84.4048|33.775178,-84.401879': 299,
  '33.7766,-84.4048|33.775381,-84.391451': 1039.4,
  '33.7766,-84.4048|33.77535159008218,-84.39513500282604': 763.2,
  '33.7766,-84.4048|33.7738,-84.397': 699.7,
  '33.7766,-84.4048|33.7766,-84.4048': 0,
  '33.7766,-84.4048|33.7756,-84.3963': 708.2,
  '33.7756,-84.3963|33.77258,-84.395624': 307.1,
  '33.7756,-84.3963|33.786914,-84.406213': 1391.8,
  '33.7756,-84.3963|33.775778,-84.401885': 452.7,
  '33.7756,-84.3963|33.775041,-84.399287': 277.1,
  '33.7756,-84.3963|33.773978,-84.404311': 781.5,
  '33.7756,-84.3963|33.772075,-84.395277': 339.3,
  '33.7756,-84.3963|33.775178,-84.401879': 439.3,
  '33.7756,-84.3963|33.775381,-84.391451': 354.5,
  '33.7756,-84.3963|33.77535159008218,-84.39513500282604': 110.1,
  '33.7756,-84.3963|33.7738,-84.397': 194.4,
  '33.7756,-84.3963|33.7766,-84.4048': 708.2,
  '33.7756,-84.3963|33.7756,-84.3963': 0,
  '33.77258,-84.395624|33.7805,-84.3921': 859.4,
  '33.77258,-84.395624|33.7723,-84.3922': 357.6,
  '33.786914,-84.406213|33.7805,-84.3921': 1451.9,
  '33.786914,-84.406213|33.7723,-84.3922': 1876.3,
  '33.775778,-84.401885|33.7805,-84.3921': 1032.1,
  '33.775778,-84.401885|33.7723,-84.3922': 872.5,
  '33.775041,-84.399287|33.7805,-84.3921': 926.3,
  '33.775041,-84.399287|33.7723,-84.3922': 696.9,
  '33.773978,-84.404311|33.7805,-84.3921': 1430.7,
  '33.773978,-84.404311|33.7723,-84.3922': 1056,
  '33.772075,-84.395277|33.7805,-84.3921': 891.6,
  '33.772075,-84.395277|33.7723,-84.3922': 342.9,
  '33.775178,-84.401879|33.7805,-84.3921': 1088.5,
  '33.775178,-84.401879|33.7723,-84.3922': 859.1,
  '33.775381,-84.391451|33.7805,-84.3921': 548.9,
  '33.775381,-84.391451|33.7723,-84.3922': 290.4,
  '33.77535159008218,-84.39513500282604|33.7805,-84.3921': 600.6,
  '33.77535159008218,-84.39513500282604|33.7723,-84.3922': 457.8,
  '33.7738,-84.397|33.7805,-84.3921': 827.7,
  '33.7738,-84.397|33.7723,-84.3922': 467.2,
  '33.7766,-84.4048|33.7805,-84.3921': 1192.2,
  '33.7766,-84.4048|33.7723,-84.3922': 1135.1,
  '33.7756,-84.3963|33.7805,-84.3921': 668,
  '33.7756,-84.3963|33.7723,-84.3922': 541.4,
  '33.7805,-84.3921|33.773568,-84.395957': 792.4,
  '33.7805,-84.3921|33.774909,-84.396404': 716.8,
  '33.7805,-84.3921|33.776085,-84.400181': 918.2,
  '33.7805,-84.3921|33.776076,-84.396114': 662.5,
  '33.7805,-84.3921|33.776177,-84.395459': 586.8,
  '33.7805,-84.3921|33.776533,-84.387765': 705.5,
  '33.7805,-84.3921|33.771771,-84.395796': 931.2,
  '33.7805,-84.3921|33.776065,-84.397116': 675.1,
  '33.7805,-84.3921|33.775803,-84.398189': 805.8,
  '33.7723,-84.3922|33.773568,-84.395957': 407.4,
  '33.7723,-84.3922|33.774909,-84.396404': 553.9,
  '33.7723,-84.3922|33.776085,-84.400181': 790.7,
  '33.7723,-84.3922|33.776076,-84.396114': 613.3,
  '33.7723,-84.3922|33.776177,-84.395459': 530.8,
  '33.7723,-84.3922|33.776533,-84.387765': 669.2,
  '33.7723,-84.3922|33.771771,-84.395796': 342.4,
  '33.7723,-84.3922|33.776065,-84.397116': 629,
  '33.7723,-84.3922|33.775803,-84.398189': 638.5,
  '33.7805,-84.3921|33.777576,-84.397352': 701.4,
  '33.7805,-84.3921|33.772949,-84.396066': 864.4,
  '33.7805,-84.3921|33.772114,-84.395289': 888.4,
  '33.7805,-84.3921|33.776764,-84.39844': 756.9,
  '33.7805,-84.3921|33.77672,-84.401764': 1052.8,
  '33.7805,-84.3921|33.777187,-84.400484': 919.1,
  '33.7805,-84.3921|33.77622,-84.397959': 761.4,
  '33.7805,-84.3921|33.777622,-84.398785': 766.6,
  '33.7723,-84.3922|33.777576,-84.397352': 741.3,
  '33.7723,-84.3922|33.772949,-84.396066': 426.3,
  '33.7723,-84.3922|33.772114,-84.395289': 346.1,
  '33.7723,-84.3922|33.776764,-84.39844': 754.3,
  '33.7723,-84.3922|33.77672,-84.401764': 957.4,
  '33.7723,-84.3922|33.777187,-84.400484': 878.7,
  '33.7723,-84.3922|33.77622,-84.397959': 673.6,
  '33.7723,-84.3922|33.777622,-84.398785': 837,
  '33.7805,-84.3921|33.775587,-84.401213': 1013.2,
  '33.7805,-84.3921|33.779177,-84.392196': 394.7,
  '33.7805,-84.3921|33.779495,-84.405633': 1107.5,
  '33.7805,-84.3921|33.773801,-84.395122': 737.9,
  '33.7805,-84.3921|33.771658,-84.395302': 925.1,
  '33.7805,-84.3921|33.778759,-84.399597': 730.8,
  '33.7805,-84.3921|33.779004,-84.395849': 623.4,
  '33.7805,-84.3921|33.777107,-84.395817': 559.4,
  '33.7805,-84.3921|33.778011,-84.397065': 655.7,
  '33.7805,-84.3921|33.778513,-84.396825': 582.6,
  '33.7723,-84.3922|33.775587,-84.401213': 868.2,
  '33.7723,-84.3922|33.779177,-84.392196': 572,
  '33.7723,-84.3922|33.779495,-84.405633': 1309.5,
  '33.7723,-84.3922|33.773801,-84.395122': 331.5,
  '33.7723,-84.3922|33.771658,-84.395302': 309.4,
  '33.7723,-84.3922|33.778759,-84.399597': 949.6,
  '33.7723,-84.3922|33.779004,-84.395849': 730.2,
  '33.7723,-84.3922|33.777107,-84.395817': 576.8,
  '33.7723,-84.3922|33.778011,-84.397065': 721.7,
  '33.7723,-84.3922|33.778513,-84.396825': 737.6,
  '33.7805,-84.3921|33.779836,-84.396666': 471.3,
  '33.7805,-84.3921|33.77561,-84.38906': 706.3,
  '33.7805,-84.3921|33.780983,-84.404516': 951.4,
  '33.7805,-84.3921|33.773714,-84.394047': 720.3,
  '33.7805,-84.3921|33.776532,-84.397307': 671.4,
  '33.7805,-84.3921|33.777062,-84.388997': 607.8,
  '33.7805,-84.3921|33.774134,-84.39396': 699.2,
  '33.7805,-84.3921|33.77247,-84.391271': 874.8,
  '33.7805,-84.3921|33.779159,-84.403952': 1052,
  '33.7805,-84.3921|33.7742,-84.394637': 697.9,
  '33.7805,-84.3921|33.779564,-84.404718': 1046.6,
  '33.7805,-84.3921|33.778233,-84.404507': 1118.7,
  '33.7723,-84.3922|33.779836,-84.396666': 804,
  '33.7723,-84.3922|33.77561,-84.38906': 632.9,
  '33.7723,-84.3922|33.780983,-84.404516': 1355,
  '33.7723,-84.3922|33.773714,-84.394047': 283.3,
  '33.7723,-84.3922|33.776532,-84.397307': 637.2,
  '33.7723,-84.3922|33.777062,-84.388997': 603.2,
  '33.7723,-84.3922|33.774134,-84.39396': 269.8,
  '33.7723,-84.3922|33.77247,-84.391271': 220.4,
  '33.7723,-84.3922|33.779159,-84.403952': 1182.3,
  '33.7723,-84.3922|33.7742,-84.394637': 338.1,
  '33.7723,-84.3922|33.779564,-84.404718': 1248.6,
  '33.7723,-84.3922|33.778233,-84.404507': 1183.1,
  '33.7805,-84.3921|33.77258,-84.395624': 859.4,
  '33.7805,-84.3921|33.786914,-84.406213': 1451.9,
  '33.7805,-84.3921|33.775778,-84.401885': 1032.1,
  '33.7805,-84.3921|33.775041,-84.399287': 926.3,
  '33.7805,-84.3921|33.773978,-84.404311': 1430.7,
  '33.7805,-84.3921|33.772075,-84.395277': 891.6,
  '33.7805,-84.3921|33.775178,-84.401879': 1088.5,
  '33.7805,-84.3921|33.775381,-84.391451': 548.9,
  '33.7805,-84.3921|33.77535159008218,-84.39513500282604': 600.6,
  '33.7805,-84.3921|33.7738,-84.397': 827.7,
  '33.7805,-84.3921|33.7766,-84.4048': 1192.2,
  '33.7805,-84.3921|33.7756,-84.3963': 668,
  '33.7723,-84.3922|33.77258,-84.395624': 357.6,
  '33.7723,-84.3922|33.786914,-84.406213': 1876.3,
  '33.7723,-84.3922|33.775778,-84.401885': 872.5,
  '33.7723,-84.3922|33.775041,-84.399287': 696.9,
  '33.7723,-84.3922|33.773978,-84.404311': 1056,
  '33.7723,-84.3922|33.772075,-84.395277': 342.9,
  '33.7723,-84.3922|33.775178,-84.401879': 859.1,
  '33.7723,-84.3922|33.775381,-84.391451': 290.4,
  '33.7723,-84.3922|33.77535159008218,-84.39513500282604': 457.8,
  '33.7723,-84.3922|33.7738,-84.397': 467.2,
  '33.7723,-84.3922|33.7766,-84.4048': 1135.1,
  '33.7723,-84.3922|33.7756,-84.3963': 541.4,
  '33.7805,-84.3921|33.7805,-84.3921': 0,
  '33.7805,-84.3921|33.7723,-84.3922': 775.9,
  '33.7723,-84.3922|33.7805,-84.3921': 775.9,
  '33.7723,-84.3922|33.7723,-84.3922': 0,
};
